// ManagerDashboard.js - Fully Translated & Reorganized (TDZ Error Fixed)
import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios, { API_BASE_URL } from '../config/axiosConfig';
import { 
  FaUsers, FaMoneyBillWave, FaClipboardList, FaChartBar, 
  FaCheckCircle, FaTimesCircle, FaTachometerAlt,
  FaUserShield, FaFileExport, FaCalendar, FaCog, FaSignOutAlt,
  FaBars, FaTimes, FaUser, FaDatabase, FaBell,
  FaChartLine, FaDonate, FaEnvelope, FaSchool,
  FaFilePdf,
  FaBuilding, FaGraduationCap, FaHandsHelping,FaGlobe,
  FaSearch, FaEye, FaEdit, FaTrash, FaLock, FaUnlock,
  FaFilter, FaDownload, FaSpinner, FaExclamationTriangle,
  FaCalendarAlt, FaChartPie, FaBolt, FaPlus,
  FaClock, FaHome, FaBriefcase, FaWallet, FaSync,
  FaChevronRight, FaChevronDown, FaInfoCircle, FaFileInvoice,
  FaEllipsisH, FaPhone, FaMapMarkerAlt, FaIndustry,
  FaExclamationCircle, FaUserCheck, FaHistory,
  FaFileAlt, FaTachometer, FaTrashAlt, FaToggleOn,
  FaToggleOff, FaUserTimes, FaUserCheck as FaUserVerified,
  FaPercent, FaDollarSign, FaRegChartBar, FaRegCalendarCheck,
  FaRegFileAlt, FaUserPlus, FaUserMinus, FaRegMoneyBillAlt,FaHandshake,
  FaFemale, FaVenus, FaImages,
  FaStar, FaSave, FaUpload, FaEyeSlash,FaChalkboardTeacher,
  FaTools,
  FaPlay,
  FaVideo,
  FaCertificate, FaHeart,
  FaFileExcel, FaAward, FaCut, FaCarrot, FaUtensils, FaTint, FaBook, FaPalette,
  FaIndustry as FaIndustryIcon, FaHome as FaHomeIcon, FaGem, FaCoffee, FaShoePrints,
  FaShoppingBasket, FaBriefcase as FaBriefcaseIcon, FaLaptop, FaCode, FaRobot,
  FaDatabase as FaDatabaseIcon, FaNetworkWired, FaShieldAlt, FaRegBuilding,
  FaUserTie, FaRegStar,  FaUserGraduate 
} from 'react-icons/fa';

import {
  getAnalyticsSummary,
  getDailyVisitors,
  getMonthlyVisitors,
  getYearlyVisitors,
  getTopPages,
  getDeviceBreakdown,
  getRecentVisits
} from '../config/analyticsApi';
import { FaDesktop, FaMobileAlt, FaTabletAlt, FaChartArea, FaEye as FaEyeSolid} from 'react-icons/fa';
import './ManagerDashboard.css';
import AssignmentModal from '../components/AssignmentModal';
import { useTranslation } from '../contexts/TranslationContext';
import * as XLSX from 'xlsx';

import TraineeRegistrationModal from '../components/TraineeRegistrationModal';

// ========== Helper functions (unchanged) ==========
const safeToFixed = (value, decimals = 1) => {
  const num = parseFloat(value);
  return isNaN(num) ? '0.0' : num.toFixed(decimals);
};

const safeParseFloat = (value) => {
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
};

const safeParseInt = (value) => {
  const num = parseInt(value);
  return isNaN(num) ? 0 : num;
};

const formatCurrency = (value) => {
  const num = safeParseFloat(value);
  return num.toLocaleString() + ' RWF';
};

const getIconComponent = (iconName) => {
  const iconMap = {
    'FaUsers': <FaUsers />,
    'FaGraduationCap': <FaGraduationCap />,
    'FaHandsHelping': <FaHandsHelping />,
    'FaHeart': <FaHeart />,
    'FaAward': <FaAward />,
    'FaChartLine': <FaChartLine />
  };
  return iconMap[iconName] || <FaHeart />;
};


// ========== External component definitions (unchanged) ==========
const RequestSpecificationsBadge = ({ request, t, setSelectedRequestWithSpecs, setShowRequestDetailsModal }) => {
  const hasSpecs = request.age_range || request.experience_level || request.skill_level || 
                  request.education_level || request.language_requirements || 
                  request.special_skills || request.other_specifications;
  
  if (!hasSpecs) {
    return <span className="manager-status-badge manager-status-no-specs">{t('noSpecifications')}</span>;
  }
  
  const specCount = [
    request.age_range,
    request.experience_level,
    request.skill_level,
    request.education_level,
    request.language_requirements
  ].filter(Boolean).length;
  
  return (
    <div className="manager-specs-badge-container">
      <span className="manager-status-badge manager-status-has-specs">
        {specCount} {t('specifications')}
      </span>
      <button 
        className="manager-btn-icon manager-btn-icon-view"
        onClick={() => {
          setSelectedRequestWithSpecs(request);
          setShowRequestDetailsModal(true);
        }}
        title={t('viewSpecifications')}
      >
        <FaEye />
      </button>
    </div>
  );
};

const CertificateStatusBadge = ({ profile, t, API_BASE_URL, verifyCertificate, unverifyCertificate, deleteCertificate }) => {
  if (!profile.certificate_url) {
    return <span className="manager-status-badge manager-status-no-certificate">{t('noCertificate')}</span>;
  }
  
  const isVerified = profile.certificate_verified === true || profile.certificate_verified === 1;
  
  const getCertificateUrl = () => {
    if (!profile.certificate_url) return '#';
    if (profile.certificate_url.startsWith('http')) {
      return profile.certificate_url;
    }
    return `${API_BASE_URL}${profile.certificate_url}`;
  };
  
  return (
    <div className="manager-certificate-badge-container">
      <span className={`manager-status-badge ${isVerified ? 'manager-status-verified' : 'manager-status-unverified'}`}>
        {isVerified ? t('certificateVerified') : t('certificateUnverified')}
      </span>
      
      <div className="manager-certificate-actions">
        <button 
          className="manager-btn-icon manager-btn-icon-view"
          onClick={() => {
            const certUrl = getCertificateUrl();
            window.open(certUrl, '_blank');
          }}
          title={t('viewCertificate')}
        >
          <FaEye />
        </button>
        
        {isVerified ? (
          <button 
            className="manager-btn-icon manager-btn-icon-warning"
            onClick={() => unverifyCertificate(profile.id)}
            title={t('markAsUnverified')}
          >
            <FaTimesCircle />
          </button>
        ) : (
          <button 
            className="manager-btn-icon manager-btn-icon-success"
            onClick={() => verifyCertificate(profile.id)}
            title={t('verifyCertificate')}
          >
            <FaCheckCircle />
          </button>
        )}
        
        <button 
          className="manager-btn-icon manager-btn-icon-delete"
          onClick={() => deleteCertificate(profile.id)}
          title={t('deleteCertificate')}
        >
          <FaTrashAlt />
        </button>
      </div>
    </div>
  );
};

const RequestDetailsModal = ({ 
  request, 
  onClose, 
  t, 
  updateRequestWithSpecsStatus, 
  updatingRequest, 
  formatCurrency,
  openApproveRejectModal
}) => {
  const [competenceSkills, setCompetenceSkills] = useState([]);
  
  if (!request) return null;
  
  const hasSpecs = request.age_range || request.experience_level || request.skill_level || 
                  request.education_level || request.language_requirements || 
                  request.special_skills || request.other_specifications;
  
  useEffect(() => {
    const fetchRequestCompetenceSkills = async (requestId) => {
      try {
        const response = await axios.get(`https://hsn.urugowoc.org.rw/backend/api/manager/request/${requestId}/competence-skills`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setCompetenceSkills(response.data || []);
      } catch (error) {
        console.error('Error fetching competence skills:', error);
      }
    };
    
    if (request.id) {
      fetchRequestCompetenceSkills(request.id);
    }
  }, [request.id]);
  
  return (
    <div className="manager-modal-overlay">
      <div className="manager-modal manager-modal-lg">
        <div className="manager-modal-header">
          <h3>{t('requestDetails')} - REQ-{request.id}</h3>
          <button className="manager-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="manager-modal-body">
          <div className="manager-request-details-grid">
            <div className="manager-detail-section">
              <h4><FaUser /> {t('employerInformation')}</h4>
              <div className="manager-detail-item">
                <label>{t('name')}:</label>
                <span>{request.employer_name}</span>
              </div>
              <div className="manager-detail-item">
                <label>{t('email')}:</label>
                <span>{request.employer_email}</span>
              </div>
              <div className="manager-detail-item">
                <label>{t('phone')}:</label>
                <span>{request.employer_phone || t('n/a')}</span>
              </div>
              <div className="manager-detail-item">
                <label>{t('company')}:</label>
                <span>{request.company_name || t('n/a')}</span>
              </div>
            </div>
            
            <div className="manager-detail-section">
              <h4><FaBriefcase /> {t('requestDetails')}</h4>
              <div className="manager-detail-item">
                <label>{t('department')}:</label>
                <span>{request.department_name || t('n/a')}</span>
              </div>
              <div className="manager-detail-item">
                <label>{t('employeesNeeded')}:</label>
                <span>{request.number_of_employees}</span>
              </div>
              <div className="manager-detail-item">
                <label>{t('workType')}:</label>
                <span>{t(request.work_type)}</span>
              </div>
              
              {request.contract_period_name && (
                <div className="manager-detail-section">
                  <h4><FaCalendar /> {t('contractPeriod') || 'Contract Period'}</h4>
                  <div className="manager-detail-item">
                    <label>{t('months') || 'Months'}:</label>
                    <span>{request.contract_months || request.months} {t('months')}</span>
                  </div>
                </div>
              )}
              
             
            </div>
            
            {competenceSkills.length > 0 && (
              <div className="manager-specifications-section">
                <h4><FaCertificate /> {t('competenceSkills') || 'Competence Skills'}</h4>
                <div className="manager-competence-skills-list">
                  {competenceSkills.map((skill, index) => (
                    <div key={skill.id || index} className="manager-competence-skill-item">
                      <span className="manager-skill-name">{skill.skill_name}</span>
                      {skill.skill_description && (
                        <span className="manager-skill-description">
                          {skill.skill_description}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            <div className="manager-detail-section">
              <h4><FaClipboardList /> {t('statusInformation')}</h4>
              <div className="manager-detail-item">
                <label>{t('status')}:</label>
                <span className={`manager-status-badge manager-status-${request.status}`}>
                  {request.status}
                </span>
              </div>
              {/* <div className="manager-detail-item">
                <label>{t('paymentVerified')}:</label>
                <span className={`manager-status-badge ${request.payment_verified ? 'manager-status-verified' : 'manager-status-unverified'}`}>
                  {request.payment_verified ? t('verified') : t('pending')}
                </span>
              </div> */}
              {/* <div className="manager-detail-item">
                <label>{t('assignedWomen')}:</label>
              <span className="manager-spec-tag manager-spec-tag-assigned">
      <FaUserCheck /> {Number(request.assigned_women_count || 0)}/{Number(request.number_of_employees || 0)}
    </span>
              </div> */}
           <div className="manager-detail-item">
  <label>{t('assignedWomen')}:</label>
  <span
    className={
      Number(request.assigned_women_count || 0) >= Number(request.number_of_employees || 0)
        ? 'manager-count-complete'
        : Number(request.assigned_women_count || 0) > 0
        ? 'manager-count-partial'
        : 'manager-count-pending'
    }
  >
    <FaUserCheck /> {Number(request.assigned_women_count || 0)} / {Number(request.number_of_employees || 0)}
  </span>
</div>
<div className="manager-detail-item">
  <label>{t('availableWomen')}:</label>
  <span>{Number(request.available_women_count || 0)}</span>
</div>

{/* ✅ NEW: Assignment Progress Bar */}
<div className="manager-detail-item" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
  <label>{t('assignmentProgress') || 'Assignment Progress'}:</label>
  <div className="manager-assignment-progress" style={{ marginTop: '6px' }}>
    <div className="manager-progress-bar-wrapper">
      <div
        className="manager-progress-bar-fill"
        style={{
          width: `${
            Number(request.number_of_employees) > 0
              ? Math.min(100, (Number(request.assigned_women_count || 0) / Number(request.number_of_employees)) * 100)
              : 0
          }%`
        }}
      />
    </div>
  </div>
</div>
            </div>
          </div>
          
          {hasSpecs && (
            <div className="manager-specifications-section">
              <h4><FaSearch /> {t('specifications')}</h4>
              <div className="manager-specifications-grid">
                {request.age_range && (
                  <div className="manager-spec-item">
                    <label>{t('ageRange')}:</label>
                    <span>{request.age_range}</span>
                  </div>
                )}
                {request.experience_level && (
                  <div className="manager-spec-item">
                    <label>{t('experienceLevel')}:</label>
                    <span>{t(request.experience_level)}</span>
                  </div>
                )}
                {request.skill_level && (
                  <div className="manager-spec-item">
                    <label>{t('skillLevel')}:</label>
                    <span>{t(request.skill_level)}</span>
                  </div>
                )}
                {request.education_level && (
                  <div className="manager-spec-item">
                    <label>{t('educationLevel')}:</label>
                    <span>{t(request.education_level)}</span>
                  </div>
                )}
                {request.language_requirements && (
                  <div className="manager-spec-item">
                    <label>{t('languageRequirements')}:</label>
                    <span>{t(request.language_requirements)}</span>
                  </div>
                )}
                {request.special_skills && (
                  <div className="manager-spec-item">
                    <label>{t('specialSkills')}:</label>
                    <span>{request.special_skills}</span>
                  </div>
                )}
                {request.other_specifications && (
                  <div className="manager-spec-item full-width">
                    <label>{t('otherSpecifications')}:</label>
                    <div className="manager-spec-text">
                      {request.other_specifications}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {!hasSpecs && (
            <div className="manager-no-specifications">
              <FaInfoCircle />
              <p>{t('noSpecificationsProvided')}</p>
            </div>
          )}
        </div>
        <div className="manager-modal-footer">
          <button className="manager-btn manager-btn-outline" onClick={onClose}>
            {t('close')}
          </button>
          {request.status === 'pending' && (
            <>
             <button 
  className="manager-btn manager-btn-primary"
  onClick={() => {
    onClose();
    openApproveRejectModal(request.id, 'approved', request);
  }}
  disabled={updatingRequest}
>
  <FaCheckCircle />
  {t('approveRequest')}
</button>
<button 
  className="manager-btn manager-btn-danger"
  onClick={() => {
    onClose();
    openApproveRejectModal(request.id, 'rejected', request);
  }}
  disabled={updatingRequest}
>   
  <FaTimesCircle />
  {t('rejectRequest')}
</button>
            </>
          )}
          {request.status === 'approved' && request.available_women_count > 0 && (
            <button 
              className="manager-btn manager-btn-success"
              onClick={() => {
                onClose();
              }}
            >
              <FaUserCheck /> {t('assignWomen')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Add these helper functions for import/export
const generateWomenTemplate = () => {
  const headers = [
    'name', 'age', 'cohort', 'department', 'phone', 'email',
    'placement_location', 'competence_skills', 'skills',
    'education_level', 'location', 'bio',
    'employment_status', 'employment_sector', 'company_name',
    'working_position', 'working_location', 'mode_of_employment',
    'years_of_experience', 'monthly_income',
    'contract_start_date', 'contract_end_date',
    'job_secured_how', 'job_relevance',
    'job_search_challenges', 'entrepreneurship',
    'entrepreneurship_employed_count', 'support_needed',
    'confidence_improved', 'financial_support_changed',
    'financial_stability_rating', 'saved_money',
    'income_management_confidence', 'community_impact',
    'leadership_involvement'
  ];
  
  // Sample data row with example values
  const sampleRow = [
    'Jane Doe', '25', 'Cohort 2024', 'Weaving', '0781234567',
    'jane.doe@email.com', 'Kigali', 'Weaving, Sewing', 'Weaving, Sewing',
    'Secondary', 'Kigali', 'Experienced weaver',
    'employed', 'textile', 'Urugo Textiles',
    'Weaver', 'Kigali', 'full_time',
    '3', '150000',
    '2024-01-01', '2024-12-31',
    'job_referral', 'highly_relevant',
    '["transport", "equipment"]', 'yes',
    '2', '["mentorship", "equipment"]',
    'yes', 'yes',
    '4', 'yes',
    'yes', 'yes', 'yes'
  ];
  
  return { headers, sampleRow };
};

const parseWomenCSV = (csvData) => {
  // Parse CSV data into array of objects
  const lines = csvData.split('\n').filter(line => line.trim());
  if (lines.length < 2) return [];
  
  const headers = lines[0].split(',').map(h => h.trim());
  const results = [];
  
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(',').map(v => v.trim());
    const obj = {};
    headers.forEach((header, index) => {
      let value = values[index] || '';
      // Handle JSON arrays
      if (header === 'job_search_challenges' || header === 'support_needed') {
        if (value && value.startsWith('[')) {
          try {
            value = JSON.parse(value);
          } catch (e) {
            value = value.split(',').map(s => s.trim());
          }
        }
      }
      obj[header] = value;
    });
    results.push(obj);
  }
  
  return results;
};

const ImportModal = ({ t, showImportModal, setShowImportModal, importFile, setImportFile, importing, handleImport }) => {
  const [importPreview, setImportPreview] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  
  useEffect(() => {
    if (importFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(firstSheet);
  
          // Show preview of first 5 rows
          setImportPreview(jsonData.slice(0, 5));
          setShowPreview(true);
        } catch (error) {
          console.error('Error parsing Excel file:', error);
          setShowPreview(false);
        }
      };
      reader.readAsArrayBuffer(importFile);
    } else {
      setImportPreview([]);
      setShowPreview(false);
    }
  }, [importFile]);

  if (!showImportModal) return null;
  
  const downloadTemplate = () => {
    const { headers, sampleRow } = generateWomenTemplate();
    const csvContent = headers.join(',') + '\n' + sampleRow.join(',');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'women_profiles_template.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  
  return (
    <div className="manager-modal-overlay">
      <div className="manager-modal manager-modal-lg">
        <div className="manager-modal-header">
          <h3>{t('importWomenProfiles') || 'Import Women Profiles'}</h3>
          <button className="manager-modal-close" onClick={() => setShowImportModal(false)}>
            <FaTimes />
          </button>
        </div>
        <div className="manager-modal-body">
          <div className="manager-alert manager-alert-info">
            <FaInfoCircle />
            <p>
              <strong>{t('importInstructions') || 'Import Instructions:'}</strong><br />
              {t('importColumnsInfo') || 'The CSV file should contain the following columns. Required fields are marked with *.'}
            </p>
          </div>
          
          <div className="manager-form-group">
            <label>{t('uploadCSVFile') || 'Upload CSV File'} *</label>
            <input
  type="file"
  accept=".csv,.xlsx,.xls"
  onChange={(e) => setImportFile(e.target.files[0])}
/>
            <small>{t('csvTemplateInstructions') || 'Supported formats: CSV, Excel (.xlsx, .xls). Max file size: 10MB'}</small>
          </div>
          
          {showPreview && importPreview.length > 0 && (
            <div className="manager-import-preview">
              <h4>{t('previewData') || 'Preview Data'} ({importPreview.length} rows)</h4>
              <div className="manager-table-responsive">
                <table className="manager-data-table">
                  <thead>
                    <tr>
                      {Object.keys(importPreview[0]).map(key => (
                        <th key={key}>{key}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {importPreview.map((row, index) => (
                      <tr key={index}>
                        {Object.values(row).map((value, i) => (
                          <td key={i}>{value || '-'}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {importPreview.length >= 5 && (
                <p className="manager-preview-note">{t('showingFirstRows') || 'Showing first 5 rows only'}</p>
              )}
            </div>
          )}
          
          <div className="manager-form-group">
            <button 
              className="manager-btn manager-btn-outline"
              onClick={downloadTemplate}
            >
              <FaDownload /> {t('downloadTemplate') || 'Download CSV Template'}
            </button>
          </div>
        </div>
        <div className="manager-modal-footer">
          <button 
            className="manager-btn manager-btn-outline" 
            onClick={() => {
              setShowImportModal(false);
              setImportFile(null);
              setImportPreview([]);
            }}
          >
            {t('cancel')}
          </button>
          <button 
            className="manager-btn manager-btn-primary"
            onClick={handleImport}
            disabled={!importFile || importing}
          >
            {importing ? <FaSpinner className="manager-spinning" /> : <FaUpload />}
            {importing ? t('importing') : t('import')}
          </button>
        </div>
      </div>
    </div>
  );
};


// ========== Main Component ==========
const ManagerDashboard = ({ user, onLogout }) => {
  const { t: originalT } = useTranslation();
  const tRef = useRef(originalT);
  
  useEffect(() => {
    tRef.current = originalT;
  }, [originalT]);

  const t = useCallback((key, fallback = '') => {
    try {
      const result = tRef.current(key);
      return (result && result !== key) ? result : (fallback || key);
    } catch (error) {
      return fallback || key;
    }
  }, []);
  
  const safeT = useCallback((key, fallback = '') => {
    return t(key, fallback);
  }, [t]);

  const [stats, setStats] = useState({
    total_users: 0,
    total_requests: 0,
    active_women: 0,
    recent_activity: [],
    total_women: 0,
    employer_count: 0,
    new_this_month: 0,
    active_today: 0,
    pending_requests: 0,
    approved_requests: 0,
    rejected_requests: 0,
    employment_stats: {
      employed: 0,
      unemployed: 0,
      studying: 0,
      working_for_others: 0,
      employed_by_company: 0,
      self_employed: 0
    }
  });


  const [showEmploymentModal, setShowEmploymentModal] = useState(false);
const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState(null);
const [filteredWomen, setFilteredWomen] = useState([]);
  const [events, setEvents] = useState([]);
const [eventsPagination, setEventsPagination] = useState({ total: 0, page: 1, limit: 20, pages: 1 });
const [eventsFilters, setEventsFilters] = useState({ type: 'all', search: '' });
const [showEventModal, setShowEventModal] = useState(false);
const [currentEvent, setCurrentEvent] = useState(null);
const [eventImage, setEventImage] = useState(null);
const [newEvent, setNewEvent] = useState({
  title: '',
  description: '',
  event_date: '',
  location: '',
  organizer: '',
  is_active: true,
  image: null,
});



// ===== ONGOING TRAINING STATE =====
const [showOngoingModal, setShowOngoingModal] = useState(false);
const [ongoingTrainees, setOngoingTrainees] = useState([]);
const [ongoingPagination, setOngoingPagination] = useState({ total: 0, page: 1, limit: 20, pages: 1 });
const [ongoingFilters, setOngoingFilters] = useState({ search: '', department_id: 'all', status: 'ongoing' });
const [ongoingCount, setOngoingCount] = useState(0);
const [selectedOngoingIds, setSelectedOngoingIds] = useState([]);
const [editingOngoing, setEditingOngoing] = useState(null);
const [nameCheckState, setNameCheckState] = useState({ checking: false, exists: false, existing: null });
const [newOngoingTrainee, setNewOngoingTrainee] = useState({
  name: '', age: '', phone: '', email: '', location: '',
  department_id: '', cohort: '', enrollment_date: new Date().toISOString().split('T')[0],
  expected_completion_date: '', notes: ''
});
const [nameCheckTimer, setNameCheckTimer] = useState(null);

  const [maintenanceMode, setMaintenanceMode] = useState({
    is_enabled: false,
    message: 'Site is under maintenance. We will be back shortly.'
  });
  const [updatingMaintenance, setUpdatingMaintenance] = useState(false);

  const [activityImages, setActivityImages] = useState([]);
  const [activityImagesPagination, setActivityImagesPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    pages: 1
  });
  const [activityImagesFilters, setActivityImagesFilters] = useState({
    department_id: 'all',
    search: '',
    status: 'all'
  });
  const [showActivityImageModal, setShowActivityImageModal] = useState(false);
  const [currentActivityImage, setCurrentActivityImage] = useState(null);
  const [activityImageFile, setActivityImageFile] = useState(null);
  const [bulkUploadFiles, setBulkUploadFiles] = useState([]);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [activityImageStats, setActivityImageStats] = useState({});
  const [newActivityImage, setNewActivityImage] = useState({
    title: '',
    description: '',
    department_id: '',
    is_active: true,
    image: null
  });

  const [heroSlides, setHeroSlides] = useState([]);
  const [statsItems, setStatsItems] = useState([]);
  const [showHeroSlideModal, setShowHeroSlideModal] = useState(false);
  const [showStatModal, setShowStatModal] = useState(false);
  const [currentHeroSlide, setCurrentHeroSlide] = useState(null);
  const [currentStat, setCurrentStat] = useState(null);
  const [heroSlideFile, setHeroSlideFile] = useState(null);
  const [newHeroSlide, setNewHeroSlide] = useState({
    title: '',
    subtitle: '',
    description: '',
    button_text: 'Explore Departments',
    button_link: '#departments',
    sort_order: 0,
    is_active: true,
    background_image: null
  });
  const [newStat, setNewStat] = useState({
    value: '',
    label: '',
    icon: 'FaHeart',
    color: '#FF9800',
    sort_order: 0,
    is_active: true
  });

  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [selectedCertificateWoman, setSelectedCertificateWoman] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);
  const [certificateData, setCertificateData] = useState({
    certificate_number: '',
    certificate_type: '',
    issuing_organization: '',
  });


  const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState(true);
const [updatingEmailToggle, setUpdatingEmailToggle] = useState(false);


  const [videoFile, setVideoFile] = useState(null);
  const [newVideoSection, setNewVideoSection] = useState({
    title: '',
    description: '',
    video_file: null,
    is_active: false
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const [updatingRequest, setUpdatingRequest] = useState(false);
  
  const [requestsWithSpecs, setRequestsWithSpecs] = useState([]);
  const [selectedRequestWithSpecs, setSelectedRequestWithSpecs] = useState(null);
  const [showRequestDetailsModal, setShowRequestDetailsModal] = useState(false);
  const [requestFilters, setRequestFilters] = useState({
    status: 'all',
    start: '',   // empty -> show all by default
    end: '',     // empty -> show all by default
    search: ''
  });
  
  const [contractStats, setContractStats] = useState({
    active_contracts: 0,
    expiring_this_month: 0, 
    renewed_this_month: 0,
    expiring_next_month: 0
  });

  const [whyChooseUsItems, setWhyChooseUsItems] = useState([]);
  const [videoSections, setVideoSections] = useState([]);
  const [currentWhyChooseUs, setCurrentWhyChooseUs] = useState(null);
  const [currentVideoSection, setCurrentVideoSection] = useState(null);
  const [showWhyChooseUsModal, setShowWhyChooseUsModal] = useState(false);
  const [showVideoSectionModal, setShowVideoSectionModal] = useState(false);
  const [newWhyChooseUs, setNewWhyChooseUs] = useState({
    title: '',
    description: '',
    icon_name: 'FaHeart',
    icon_type: 'fa',
    sort_order: 0,
    is_active: true
  });
  
  const [aboutTab, setAboutTab] = useState('main');
  
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedWomenForAssignment, setSelectedWomenForAssignment] = useState([]);
  const [employerRequests, setEmployerRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  
  const [requests, setRequests] = useState([]);
  const [users, setUsers] = useState([]);
  
  const [womenProfiles, setWomenProfiles] = useState([]);
  const [womenPagination, setWomenPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    pages: 1
  });
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [employerDetails, setEmployerDetails] = useState(null);
  const [showEmployerModal, setShowEmployerModal] = useState(false);


  // ==================== VISITOR ANALYTICS STATE ====================
const [visitorsSummary, setVisitorsSummary] = useState({
  total_visits: 0,
  total_unique_visitors: 0,
  today_visits: 0,
  today_unique_visitors: 0,
  month_visits: 0,
  month_unique_visitors: 0,
  year_visits: 0,
  year_unique_visitors: 0,
});
const [visitorView, setVisitorView] = useState('daily');   // daily|monthly|yearly
const [visitorDaily, setVisitorDaily] = useState([]);
const [visitorMonthly, setVisitorMonthly] = useState([]);
const [visitorYearly, setVisitorYearly] = useState([]);
const [visitorTopPages, setVisitorTopPages] = useState([]);
const [visitorDevices, setVisitorDevices] = useState([]);
const [visitorRecent, setVisitorRecent] = useState([]);
const [visitorRecentPagination, setVisitorRecentPagination] = useState({ total: 0, page: 1, limit: 50, pages: 1 });
const [loadingVisitors, setLoadingVisitors] = useState(false);
const [visitorChartDays, setVisitorChartDays] = useState(30);



  // ✅ ADD: Approve/Reject modal state
const [showApproveRejectModal, setShowApproveRejectModal] = useState(false);
const [approveRejectAction, setApproveRejectAction] = useState(null);
// { action: 'approved' | 'rejected', requestId, requestData }
const [approveRejectMessage, setApproveRejectMessage] = useState('');
const [approveRejectSendEmail, setApproveRejectSendEmail] = useState(true);
const [approveRejectSubmitting, setApproveRejectSubmitting] = useState(false);

// ✅ ADD: Email toggle notification toast
const [emailToggleToast, setEmailToggleToast] = useState(null);
// { type: 'success' | 'error', message: '' }

  // const [departmentsFull, setDepartmentsFull] = useState([]);
  // const [departmentStats, setDepartmentStats] = useState({});
  // const [showDepartmentModal, setShowDepartmentModal] = useState(false);
  // const [currentDepartment, setCurrentDepartment] = useState(null);
  // const [departmentImage, setDepartmentImage] = useState(null);
  // const [departmentIcon, setDepartmentIcon] = useState(null);
  // const [departmentBulkSort, setDepartmentBulkSort] = useState(false);
  // const [departmentFilters, setDepartmentFilters] = useState({
  //   search: '',
  //   status: 'all',
  //   featured: 'all'
  // });
  // const [newDepartment, setNewDepartment] = useState({
  //   name: '',
  //   description: '',
  //   short_description: '',
  //   color: '#FF9800',
  //   icon_name: 'FaGraduationCap',
  //   sort_order: 0,
  //   is_active: true,
  //   featured: false,
  //   meta_title: '',
  //   meta_description: '',
  //   seo_keywords: '',
  //   requirements: '',
  //   learning_outcomes: '',
  //   career_opportunities: '',
  //   duration_weeks: '',
  //   price: '',
  //   image: null,
  //   icon: null
  // });


  const [departmentsFull, setDepartmentsFull] = useState([]);
const [showDepartmentModal, setShowDepartmentModal] = useState(false);
const [currentDepartment, setCurrentDepartment] = useState(null);
const [newDepartment, setNewDepartment] = useState({ name: '', description: '' });
  
  const [expiringContracts, setExpiringContracts] = useState([]);
  const [contractThreshold, setContractThreshold] = useState(30);

  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  
  const [partners, setPartners] = useState([]);
  const [partnersPagination, setPartnersPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    pages: 1
  });
  const [partnersFilters, setPartnersFilters] = useState({
    search: '',
    partner_type: 'all',
    active: 'all'
  });
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [currentPartner, setCurrentPartner] = useState(null);
  const [partnerLogo, setPartnerLogo] = useState(null);
  const [newPartner, setNewPartner] = useState({
    partner_name: '',
    partner_type: '',
    website_url: '',
    description: '',
    sort_order: 0,
    is_active: true,
    logo: null
  });

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailData, setEmailData] = useState({
    to: '',
    subject: '',
    html: '',
    request_id: ''
  });
  const [showEmailBroadcastModal, setShowEmailBroadcastModal] = useState(false);
  const [emailBroadcastData, setEmailBroadcastData] = useState({
    subject: '',
    message: '',
    recipients: 'all',
    test_email: '',
    send_as_test: false
  });
  const [broadcastLoading, setBroadcastLoading] = useState(false);
  const [showCustomEmailModal, setShowCustomEmailModal] = useState(false);
  const [customEmailData, setCustomEmailData] = useState({
    recipients: '',
    subject: '',
    message: '',
    attachments: []
  });
  const [customEmailLoading, setCustomEmailLoading] = useState(false);
  
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [changingPassword, setChangingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  
  const [filters, setFilters] = useState({
    status: 'all',
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0],
    user_type: 'all'
  });
  const [womenFilters, setWomenFilters] = useState({
    status: 'all',
    department_id: 'all',
    search: ''
  });
  
  const [employmentModalPagination, setEmploymentModalPagination] = useState({ page: 1, limit: 20, total: 0, pages: 1 });
const [modalLoading, setModalLoading] = useState(false);
  // const [showAddModal, setShowAddModal] = useState(false);
  // const [showEditModal, setShowEditModal] = useState(false);
  // const [currentProfile, setCurrentProfile] = useState(null);
  // const [newProfile, setNewProfile] = useState({
    // Basic Information
    // name: '',
    // age: '',
    // cohort: '',
    // department_id: '',
    // phone: '',
    // email: '',
    // placement_location: '',
    // competence_skills: '',
    // skills: '',
    // photo: null,
    
    // Employment Status
    // employment_status: '',
    // employment_sector: '',
    // company_name: '',
    // working_position: '',
    // working_location: '',
    // mode_of_employment: '',
    // years_of_experience: '',
    // monthly_income: '',
    // contract_start_date: '',
    // contract_end_date: '',
    
    // Job Secured
    // job_secured_how: '',
    
    // Job Relevance
    // job_relevance: '',
    
    // Job Search Challenges
    // job_search_challenges: [],
    
    // Entrepreneurship
    // entrepreneurship: '',
    // entrepreneurship_employed_count: '',
    
    // Support Needed
    // support_needed: [],
    
    // Confidence & Impact
    // confidence_improved: '',
    // financial_support_changed: '',
    // financial_stability_rating: '',
    // saved_money: '',
    // income_management_confidence: '',
    
    // Community Impact
    // community_impact: '',
    // leadership_involvement: '',
    
    // Education & Bio
  //   education_level: '',
  //   location: '',
  //   bio: ''
  // });

  // ADD these:
const [showTraineeRegistrationModal, setShowTraineeRegistrationModal] = useState(false);
const [editingTrainee, setEditingTrainee] = useState(null);

  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryPagination, setGalleryPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    pages: 1
  });
  const [galleryFilters, setGalleryFilters] = useState({
    department_id: 'all',
    search: ''
  });

  const [aboutData, setAboutData] = useState({
    title: '',
    mission: '',
    vision: '',
    history: ''
  });

  const [coreValues, setCoreValues] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);

  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showCoreValueModal, setShowCoreValueModal] = useState(false);
  const [showTeamMemberModal, setShowTeamMemberModal] = useState(false);

  const [currentGalleryImage, setCurrentGalleryImage] = useState(null);
  const [currentCoreValue, setCurrentCoreValue] = useState(null);
  const [currentTeamMember, setCurrentTeamMember] = useState(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'danger'
  });

  const [newGalleryImage, setNewGalleryImage] = useState({
    title: '',
    description: '',
    department_id: '',
    is_featured: false,
    image: null
  });

  const [newCoreValue, setNewCoreValue] = useState({
    value_text: '',
    sort_order: 0
  });

  const [newTeamMember, setNewTeamMember] = useState({
    full_name: '',
    position: '',
    department: '',
    bio: '',
    email: '',
    phone: '',
    sort_order: 0,
    is_active: true,
    photo: null
  });

  // ========== ALL useCallback HOOKS (REORDERED to fix TDZ) ==========
  // ------------------------------------------------------------------
  // 1. INDEPENDENT FETCH FUNCTIONS (do not call other callbacks)
  // ------------------------------------------------------------------
  const fetchDepartments = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/departments');
      setDepartments(response.data || []);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  }, []);



// Enhanced Excel/CSV Export with better formatting
const exportWomenToExcel = useCallback(async () => {
  setExporting(true);
  try {
    // Fetch all women profiles with full data
    const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles', {
      params: {
        ...womenFilters,
        limit: 1000,
        include_employer: true,
        include_certificates: true,
        lang: undefined
      }
    });
    
    const women = response.data.profiles || [];
    
    // Define columns for export with proper headers
    const columns = [
      { key: 'id', label: 'ID', width: 50 },
      { key: 'name', label: 'Full Name', width: 150 },
      { key: 'age', label: 'Age', width: 40 },
      { key: 'cohort', label: 'Cohort', width: 100 },
      { key: 'department_name', label: 'Department', width: 120 },
      { key: 'phone', label: 'Phone Number', width: 120 },
      { key: 'email', label: 'Email Address', width: 180 },
      { key: 'placement_location', label: 'Placement Location', width: 150 },
      { key: 'competence_skills', label: 'Competence Skills', width: 180 },
      { key: 'skills', label: 'Skills', width: 150 },
      { key: 'education_level', label: 'Education Level', width: 120 },
      { key: 'location', label: 'Location', width: 120 },
      { key: 'bio', label: 'Biography', width: 200 },
      { key: 'employment_status', label: 'Employment Status', width: 130 },
      { key: 'employment_sector', label: 'Employment Sector', width: 130 },
      { key: 'company_name', label: 'Company Name', width: 150 },
      { key: 'working_position', label: 'Position', width: 130 },
      { key: 'working_location', label: 'Work Location', width: 130 },
      { key: 'mode_of_employment', label: 'Mode of Employment', width: 130 },
      { key: 'years_of_experience', label: 'Years Experience', width: 100 },
      { key: 'monthly_income', label: 'Monthly Income (RWF)', width: 130 },
      { key: 'contract_start_date', label: 'Contract Start', width: 110 },
      { key: 'contract_end_date', label: 'Contract End', width: 110 },
      { key: 'job_secured_how', label: 'How Job Was Secured', width: 170 },
      { key: 'job_relevance', label: 'Job Relevance', width: 130 },
      { key: 'entrepreneurship', label: 'Entrepreneurship', width: 120 },
      { key: 'entrepreneurship_employed_count', label: 'Employees Hired', width: 120 },
      { key: 'confidence_improved', label: 'Confidence Level', width: 140 },
      { key: 'financial_support_changed', label: 'Financial Support', width: 170 },
      { key: 'financial_stability_rating', label: 'Financial Stability', width: 140 },
      { key: 'saved_money', label: 'Saved Money', width: 120 },
      { key: 'income_management_confidence', label: 'Income Confidence', width: 140 },
      { key: 'community_impact', label: 'Community Impact', width: 140 },
      { key: 'leadership_involvement', label: 'Leadership', width: 130 },
      { key: 'is_available', label: 'Availability', width: 80 },
      { key: 'is_active', label: 'Active Status', width: 80 },
      { key: 'created_at', label: 'Created Date', width: 120 }
    ];
    
    // Generate HTML table with proper styling for better export
    const headers = columns.map(c => c.label);
    const headerRow = headers.map(h => `<th style="border: 1px solid #000; padding: 8px 12px; background-color: #2c3e50; color: white; font-weight: bold; text-align: left;">${h}</th>`).join('');
    
    const rows = women.map(w => {
      return columns.map(col => {
        let value = w[col.key] || '';
        // Format boolean values
        if (col.key === 'is_available' || col.key === 'is_active') {
          value = value ? 'Yes' : 'No';
        }
        // Format arrays
        if (Array.isArray(value)) {
          value = value.join('; ');
        }
        // Format dates
        if (col.key === 'created_at' || col.key === 'contract_start_date' || col.key === 'contract_end_date') {
          if (value) {
            try {
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toLocaleDateString();
              }
            } catch (e) {}
          }
        }
        // Escape special characters for HTML
        if (typeof value === 'string') {
          value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }
        return `<td style="border: 1px solid #000; padding: 6px 12px; font-size: 12px; vertical-align: middle;">${value}</td>`;
      }).join('');
    });
    
    const rowHtml = women.map((w, index) => {
      const rowData = columns.map(col => {
        let value = w[col.key] || '';
        if (col.key === 'is_available' || col.key === 'is_active') {
          value = value ? 'Yes' : 'No';
        }
        if (Array.isArray(value)) {
          value = value.join('; ');
        }
        if (col.key === 'created_at' || col.key === 'contract_start_date' || col.key === 'contract_end_date') {
          if (value) {
            try {
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toLocaleDateString();
              }
            } catch (e) {}
          }
        }
        if (typeof value === 'string') {
          value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }
        return `<td style="border: 1px solid #000; padding: 6px 12px; font-size: 12px; vertical-align: middle; ${index % 2 === 0 ? 'background-color: #f9f9f9;' : ''}">${value}</td>`;
      }).join('');
      const bgColor = index % 2 === 0 ? '#f9f9f9' : '#ffffff';
      return `<tr style="background-color: ${bgColor};">${rowData}</tr>`;
    }).join('');
    
    // Create Excel-compatible HTML with proper styles
    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" 
            xmlns:x="urn:schemas-microsoft-com:office:excel" 
            xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8">
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <!--[if gte mso 9]>
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>Women Profiles</x:Name>
                <x:WorksheetOptions>
                  <x:DisplayGridlines/>
                </x:WorksheetOptions>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
          /* Table styles */
          table {
            border-collapse: collapse;
            width: 100%;
            font-family: 'Segoe UI', Arial, sans-serif;
            font-size: 11px;
          }
          th {
            border: 1px solid #000000;
            padding: 8px 12px;
            background-color: #2c3e50;
            color: #ffffff;
            font-weight: bold;
            text-align: left;
            font-size: 12px;
            white-space: nowrap;
          }
          td {
            border: 1px solid #000000;
            padding: 6px 12px;
            font-size: 11px;
            vertical-align: middle;
            word-wrap: break-word;
            max-width: 300px;
          }
          .header-title {
            font-size: 18px;
            font-weight: bold;
            color: #2c3e50;
            margin-bottom: 10px;
            text-align: center;
          }
          .header-info {
            font-size: 12px;
            color: #555;
            margin-bottom: 15px;
            text-align: center;
          }
          .footer {
            margin-top: 20px;
            font-size: 11px;
            color: #777;
            text-align: center;
            border-top: 1px solid #ddd;
            padding-top: 10px;
          }
          /* Column widths */
          .col-id { width: 50px; }
          .col-name { width: 150px; }
          .col-age { width: 40px; }
          .col-cohort { width: 100px; }
          .col-department { width: 120px; }
          .col-phone { width: 120px; }
          .col-email { width: 180px; }
          .col-location { width: 150px; }
          .col-skills { width: 180px; }
          .col-bio { width: 200px; }
          .col-status { width: 80px; }
        </style>
      </head>
      <body>
        <div class="header-title">Urugo WOC - Women Profiles Export</div>
        <div class="header-info">
          Generated: ${new Date().toLocaleString()} | Total Profiles: ${women.length}
          ${womenFilters.department_id !== 'all' ? `| Department: ${departments.find(d => d.id === parseInt(womenFilters.department_id))?.name || 'Filtered'}` : ''}
        </div>
        <table>
          <thead>
            <tr>
              ${columns.map(c => `<th style="border: 1px solid #000; padding: 8px 12px; background-color: #2c3e50; color: white; font-weight: bold; text-align: left; font-size: 12px; white-space: nowrap;">${c.label}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${rowHtml}
          </tbody>
        </table>
        <div class="footer">
          &copy; ${new Date().getFullYear()} Urugo Women Opportunity Center. All rights reserved.<br>
          This report was generated on ${new Date().toLocaleString()}
        </div>
      </body>
      </html>
    `;
    
    // Create blob with proper encoding
    const blob = new Blob([htmlContent], { 
      type: 'application/vnd.ms-excel;charset=utf-8' 
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `women_profiles_export_${new Date().toISOString().split('T')[0]}.xls`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    setSuccessMessage(`${women.length} women profiles exported successfully to Excel!`);
    setTimeout(() => setSuccessMessage(null), 5000);
  } catch (error) {
    console.error('Error exporting women profiles:', error);
    setError(`Failed to export women profiles: ${error.response?.data?.error || error.message}`);
  } finally {
    setExporting(false);
  }
}, [womenFilters, departments]);

// Enhanced PDF Export with better formatting
const exportWomenToPDF = useCallback(async () => {
  setExporting(true);
  try {
    // Fetch all women profiles
    const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles', {
      params: {
        ...womenFilters,
        limit: 1000,
        include_employer: true,
        include_certificates: true,
        lang: undefined
      }
    });
    
    const women = response.data.profiles || [];
    
    // Define columns for PDF
    const columns = [
      { key: 'id', label: 'ID' },
      { key: 'name', label: 'Full Name' },
      { key: 'age', label: 'Age' },
      { key: 'cohort', label: 'Cohort' },
      { key: 'department_name', label: 'Department' },
      { key: 'phone', label: 'Phone' },
      { key: 'email', label: 'Email' },
      { key: 'placement_location', label: 'Location' },
      { key: 'employment_status', label: 'Employment' },
      { key: 'company_name', label: 'Company' },
      { key: 'working_position', label: 'Position' },
      { key: 'monthly_income', label: 'Income (RWF)' },
      { key: 'is_available', label: 'Available' },
      { key: 'is_active', label: 'Active' }
    ];
    
    // Generate HTML for PDF with enhanced styling
    const headerRow = columns.map(c => `<th style="border: 1px solid #000; padding: 8px 12px; background-color: #1a3a2a; color: #ffffff; font-weight: bold; font-size: 12px; text-align: left;">${c.label}</th>`).join('');
    
    const rowsHtml = women.map((w, index) => {
      const rowData = columns.map(col => {
        let value = w[col.key] || '';
        if (col.key === 'is_available' || col.key === 'is_active') {
          value = value ? 'Yes' : 'No';
        }
        if (Array.isArray(value)) {
          value = value.join('; ');
        }
        if (typeof value === 'string') {
          value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return `<td style="border: 1px solid #000; padding: 6px 12px; font-size: 10px; ${index % 2 === 0 ? 'background-color: #f9f9f9;' : ''}">${value}</td>`;
      }).join('');
      return `<tr>${rowData}</tr>`;
    }).join('');
    
    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Women Profiles Export - PDF</title>
        <style>
          @page {
            size: A4 landscape;
            margin: 15mm 10mm 15mm 10mm;
          }
          body {
            font-family: 'Segoe UI', Arial, sans-serif;
            font-size: 10px;
            padding: 10px;
            color: #333;
          }
          .report-header {
            text-align: center;
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 3px solid #1a3a2a;
          }
          .report-title {
            font-size: 22px;
            font-weight: bold;
            color: #1a3a2a;
            margin: 0 0 5px 0;
          }
          .report-subtitle {
            font-size: 13px;
            color: #555;
            margin: 0;
          }
          .report-meta {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            color: #666;
            margin: 10px 0 15px 0;
            padding: 8px 12px;
            background: #f5f5f5;
            border-radius: 4px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 9px;
          }
          th {
            border: 1px solid #000;
            padding: 6px 8px;
            background-color: #1a3a2a;
            color: #ffffff;
            font-weight: bold;
            font-size: 10px;
            text-align: left;
          }
          td {
            border: 1px solid #000;
            padding: 4px 8px;
            font-size: 9px;
            vertical-align: middle;
          }
          .footer {
            text-align: center;
            font-size: 9px;
            color: #777;
            margin-top: 20px;
            padding-top: 10px;
            border-top: 1px solid #ddd;
          }
          .status-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 3px;
            font-weight: 600;
            font-size: 8px;
          }
          .status-active {
            background: #4CAF50;
            color: white;
          }
          .status-inactive {
            background: #f44336;
            color: white;
          }
          .status-available {
            background: #2196F3;
            color: white;
          }
          .status-hired {
            background: #FF9800;
            color: white;
          }
        </style>
      </head>
      <body>
        <div class="report-header">
          <div class="report-title">Urugo WOC - Women Profiles Report</div>
          <div class="report-subtitle">Women Opportunity Center - Trainee Database</div>
        </div>
        
        <div class="report-meta">
          <span><strong>Generated:</strong> ${new Date().toLocaleString()}</span>
          <span><strong>Total Profiles:</strong> ${women.length}</span>
          ${womenFilters.department_id !== 'all' ? `<span><strong>Department:</strong> ${departments.find(d => d.id === parseInt(womenFilters.department_id))?.name || 'All'}</span>` : ''}
          <span><strong>Status:</strong> ${womenFilters.status === 'all' ? 'All' : womenFilters.status === 'available' ? 'Available' : 'Hired'}</span>
        </div>
        
        <table>
          <thead>
            <tr>${headerRow}</tr>
          </thead>
          <tbody>
            ${rowsHtml}
          </tbody>
        </table>
        
        <div class="footer">
          <p>&copy; ${new Date().getFullYear()} Urugo Women Opportunity Center. All rights reserved.</p>
          <p>This report was generated on ${new Date().toLocaleString()} | Page 1 of 1</p>
        </div>
      </body>
      </html>
    `;
    
    // Create blob as HTML for PDF printing
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `women_profiles_export_${new Date().toISOString().split('T')[0]}.html`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    setSuccessMessage(`${women.length} women profiles exported as HTML! Open in browser and print to PDF.`);
    setTimeout(() => setSuccessMessage(null), 5000);
  } catch (error) {
    console.error('Error exporting women profiles:', error);
    setError('Failed to export women profiles');
  } finally {
    setExporting(false);
  }
}, [womenFilters, departments]);

  const fetchContractStats = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/contract-stats', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setContractStats(response.data);
    } catch (error) {
      console.error('Error fetching contract stats:', error);
    }
  }, []);


  const fetchExpiringContracts = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/expiring-contracts', {
        params: { days: contractThreshold, lang: undefined },
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setExpiringContracts(response.data.contracts || response.data || []);
    } catch (error) {
      console.error('Error fetching expiring contracts:', error);
      setError(t('failedLoadExpiringContracts') || 'Failed to load expiring contracts');
      setExpiringContracts([]);
    }
  }, [contractThreshold, t]);



  const fetchVisitorAnalytics = useCallback(async () => {
  setLoadingVisitors(true);
  try {
    const [summary, daily, monthly, yearly, topPages, devices, recent] = await Promise.all([
      getAnalyticsSummary(),
      getDailyVisitors(visitorChartDays),
      getMonthlyVisitors(12),
      getYearlyVisitors(5),
      getTopPages(30),
      getDeviceBreakdown(30),
      getRecentVisits(1, 50)
    ]);
    setVisitorsSummary(summary || {});
    setVisitorDaily(Array.isArray(daily) ? daily : []);
    setVisitorMonthly(Array.isArray(monthly) ? monthly : []);
    setVisitorYearly(Array.isArray(yearly) ? yearly : []);
    setVisitorTopPages(Array.isArray(topPages) ? topPages : []);
    setVisitorDevices(Array.isArray(devices) ? devices : []);
    setVisitorRecent(recent?.visits || []);
    setVisitorRecentPagination(recent?.pagination || { total: 0, page: 1, limit: 50, pages: 1 });
  } catch (err) {
    console.error('Error loading visitor analytics:', err);
    setError(t('Failed to load visitor analytics') || 'Failed to load visitor analytics');
  } finally {
    setLoadingVisitors(false);
  }
}, [visitorChartDays, t]);

// Refresh recent page
const handleVisitorRecentPage = useCallback(async (page) => {
  try {
    const recent = await getRecentVisits(page, visitorRecentPagination.limit);
    setVisitorRecent(recent?.visits || []);
    setVisitorRecentPagination(recent?.pagination || { total: 0, page, limit: 50, pages: 1 });
  } catch (err) {
    console.error('Recent visits page error:', err);
  }
}, [visitorRecentPagination.limit]);

  const fetchWhyChooseUsItems = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/why-choose-us', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setWhyChooseUsItems(response.data || []);
    } catch (error) {
      console.error('Error fetching why choose us items:', error);
      setError(t('failedLoadWhyChooseUs') || 'Failed to load why choose us items');
    }
  }, [t]);

  const fetchVideoSections = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/video-sections', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setVideoSections(response.data || []);
    } catch (error) {
      console.error('Error fetching video sections:', error);
      setError(t('failedLoadVideoSections') || 'Failed to load video sections');
    }
  }, [t]);

  const fetchHeroSlides = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/hero-slides', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setHeroSlides(response.data || []);
    } catch (error) {
      console.error('Error fetching hero slides:', error);
      setError(t('failedLoadHeroSlides') || 'Failed to load hero slides');
    }
  }, [t]);


  const fetchEvents = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/events', {
        params: {
          ...eventsFilters,
          page: eventsPagination.page,
          limit: eventsPagination.limit,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setEvents(response.data.events || []);
      setEventsPagination(response.data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (error) {
      console.error('Error fetching events:', error);
      setError(t('failedLoadEvents') || 'Failed to load events');
    }
  }, [eventsFilters, eventsPagination.page, eventsPagination.limit, t]);
  
  const handleAddEvent = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', newEvent.title);
    formData.append('description', newEvent.description);
    formData.append('event_date', newEvent.event_date);
    formData.append('location', newEvent.location || '');
    formData.append('organizer', newEvent.organizer || '');
    formData.append('is_active', newEvent.is_active ? 'true' : 'false');
    if (eventImage) formData.append('image', eventImage);
  
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/events', formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSuccessMessage(t('eventAdded') || 'Event added successfully');
      setShowEventModal(false);
      setEventImage(null);
      setNewEvent({ title: '', description: '', event_date: '', location: '', organizer: '', is_active: true, image: null });
      fetchEvents();
    } catch (error) {
      console.error('Error adding event:', error);
      setError(`${t('failedAddEvent') || 'Failed to add event'}: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [newEvent, eventImage, t, fetchEvents]);
  
  const handleEditEvent = useCallback(async (e) => {
    e.preventDefault();
    if (!currentEvent) return;
    const formData = new FormData();
    formData.append('title', currentEvent.title);
    formData.append('description', currentEvent.description);
    formData.append('event_date', currentEvent.event_date || '');
    formData.append('location', currentEvent.location || '');
    formData.append('organizer', currentEvent.organizer || '');
    formData.append('is_active', currentEvent.is_active ? 'true' : 'false');
    if (eventImage) formData.append('image', eventImage);
  
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/events/${currentEvent.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSuccessMessage(t('eventUpdated') || 'Event updated successfully');
      setShowEventModal(false);
      setCurrentEvent(null);
      setEventImage(null);
      fetchEvents();
    } catch (error) {
      console.error('Error updating event:', error);
      setError(`${t('failedUpdateEvent') || 'Failed to update event'}: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [currentEvent, eventImage, t, fetchEvents]);
  
  const deleteEvent = useCallback(async (eventId) => {
    setConfirmData({
      title: t('confirmDeleteEventTitle') || 'Delete Event',
      message: t('confirmDeleteEvent') || 'Are you sure you want to delete this event?',
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/events/${eventId}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });
          setEvents(prev => prev.filter(ev => ev.id !== eventId));
          setSuccessMessage(t('eventDeleted') || 'Event deleted successfully');
        } catch (error) {
          console.error('Error deleting event:', error);
          setError(t('failedDeleteEvent') || 'Failed to delete event');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'),
      cancelText: t('cancel'),
      type: 'danger',
    });
    setShowConfirmModal(true);
  }, [t]);
  
  const toggleEventStatus = useCallback(async (eventId) => {
    try {
      const response = await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/events/${eventId}/toggle-status`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setEvents(prev => prev.map(ev => ev.id === eventId ? { ...ev, is_active: ev.is_active ? 0 : 1 } : ev));
      setSuccessMessage(t('eventStatusToggled') || 'Event status updated');
    } catch (error) {
      console.error('Error toggling event status:', error);
      setError(t('failedToggleEventStatus') || 'Failed to update status');
    }
  }, [t]);

  const fetchStatsItems = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/stats-items', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setStatsItems(response.data || []);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setError(t('failedLoadStats') || 'Failed to load stats');
    }
  }, [t]);

  const fetchMaintenanceSettings = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/maintenance-settings', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setMaintenanceMode({
        is_enabled: response.data.is_enabled === 1,
        message: response.data.message || 'Site is under maintenance. We will be back shortly.'
      });
    } catch (error) {
      console.error('Error fetching maintenance settings:', error);
    }
  }, []);


  const fetchEmailSettings = useCallback(async () => {
  try {
    const response = await axios.get(
      'https://hsn.urugowoc.org.rw/backend/api/manager/email-settings',
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    setEmailNotificationsEnabled(response.data.email_notifications_enabled);
  } catch (error) {
    console.error('Error fetching email settings:', error);
  }
}, []);

const toggleEmailNotifications = useCallback(async () => {
  const newValue = !emailNotificationsEnabled;
  setUpdatingEmailToggle(true);
  setError(null);
  try {
    const response = await axios.post(
      'https://hsn.urugowoc.org.rw/backend/api/manager/email-settings',
      { email_notifications_enabled: newValue },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    setEmailNotificationsEnabled(response.data.email_notifications_enabled);
    setSuccessMessage(
      newValue
        ? '📧 Email notifications ENABLED — all emails will be sent'
        : '🔕 Email notifications DISABLED — no emails will be sent'
    );
    setTimeout(() => setSuccessMessage(null), 4000);
  } catch (error) {
    console.error('Error toggling email notifications:', error);
    setError(error.response?.data?.error || 'Failed to toggle email notifications');
  } finally {
    setUpdatingEmailToggle(false);
  }
}, [emailNotificationsEnabled]);

  const fetchDepartmentsFull = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/departments-full', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setDepartmentsFull(response.data || []);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setError(t('failedLoadDepartments') || 'Failed to load departments');
    }
  }, [t]);

  const fetchDepartmentStats = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/departments-stats', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      // Ensure we have a plain object, not an array or something else
      let stats = response.data;
      if (Array.isArray(stats) && stats.length > 0) stats = stats[0];
      if (typeof stats !== 'object' || stats === null) stats = {};
      setDepartmentStats(stats);
    } catch (error) {
      console.error('Error fetching department stats:', error);
      setDepartmentStats({});
    }
  }, []);

  const fetchDepartmentById = useCallback(async (id) => {
    try {
      const response = await axios.get(`https://hsn.urugowoc.org.rw/backend/api/manager/departments/${id}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching department:', error);
      throw error;
    }
  }, []);



  // In ManagerDashboard.js, add this function
const toggleTraineeStatus = useCallback(async (traineeId) => {
  setConfirmData({
    title: t('confirmToggleStatus'),
    message: t('confirmToggleTraineeStatus'),
    onConfirm: async () => {
      try {
        const response = await axios.patch(
          `https://hsn.urugowoc.org.rw/backend/api/manager/trainee/${traineeId}/toggle-status`,
          {},
          {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          }
        );
        
        setWomenProfiles(prev => prev.map(profile => 
          profile.id === traineeId 
            ? { ...profile, is_active: response.data.is_active } 
            : profile
        ));
        
        setSuccessMessage(
          response.data.is_active 
            ? t('traineeActivated') 
            : t('traineeDeactivated')
        );
        
        setTimeout(() => setSuccessMessage(null), 3000);
      } catch (error) {
        console.error('Error toggling trainee status:', error);
        setError(t('failedToggleTraineeStatus'));
      }
    },
    onCancel: () => {},
    confirmText: t('confirm'),
    cancelText: t('cancel'),
    type: 'warning'
  });
  setShowConfirmModal(true);
}, [t]);

  const fetchPartners = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/partners', {
        params: {
          ...partnersFilters,
          page: partnersPagination.page,
          limit: partnersPagination.limit
        },
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setPartners(response.data.partners || []);
      setPartnersPagination(response.data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (error) {
      console.error('Error fetching partners:', error);
      setError(t('failedLoadPartners'));
    }
  }, [partnersFilters, partnersPagination.page, partnersPagination.limit, t]);

  const fetchPartnerTypes = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/partner-types', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setPartnerTypes(response.data || []);
    } catch (error) {
      console.error('Error fetching partner types:', error);
    }
  }, []);

  const fetchGalleryImages = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/gallery-images', {
        params: {
          ...galleryFilters,
          page: galleryPagination.page,
          limit: galleryPagination.limit
        }
      });
      setGalleryImages(response.data.images || []);
      setGalleryPagination(response.data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (error) {
      console.error('Error fetching gallery images:', error);
      setError(`${t('failedLoadGalleryImages')}: ${error.response?.data?.error || error.message}`);
    }
  }, [galleryFilters, galleryPagination.page, galleryPagination.limit, t]);

  const fetchAboutData = useCallback(async () => {
    try {
      let aboutRes, coreValuesRes, teamRes;
      try {
        aboutRes = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/about-us');
      } catch (error) {
        aboutRes = { data: {} };
      }
      try {
        coreValuesRes = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/core-values');
      } catch (error) {
        coreValuesRes = { data: [] };
      }
      try {
        teamRes = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/team-members');
      } catch (error) {
        teamRes = { data: [] };
      }
      setAboutData(aboutRes.data || {
        title: t('defaultAboutTitle'),
        mission: t('defaultMission'),
        vision: t('defaultVision'),
        history: t('defaultHistory')
      });
      setCoreValues(coreValuesRes.data || []);
      setTeamMembers(teamRes.data || []);
    } catch (error) {
      console.error('Error fetching about data:', error);
      setAboutData({
        title: t('defaultAboutTitle'),
        mission: t('defaultMission'),
        vision: t('defaultVision'),
        history: t('defaultHistory')
      });
      setCoreValues([]);
      setTeamMembers([]);
    }
  }, [t]);

  const fetchActivityImages = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/activity-images', {
        params: {
          ...activityImagesFilters,
          page: activityImagesPagination.page,
          limit: activityImagesPagination.limit
        },
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setActivityImages(response.data.images || []);
      setActivityImagesPagination(response.data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (error) {
      console.error('Error fetching activity images:', error);
      setError(t('failedLoadActivityImages') || 'Failed to load activity images');
    }
  }, [activityImagesFilters, activityImagesPagination.page, activityImagesPagination.limit, t]);

  const fetchActivityImageStats = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/activity-images-stats', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setActivityImageStats(response.data || {});
    } catch (error) {
      console.error('Error fetching activity image stats:', error);
    }
  }, []);

  // ------------------------------------------------------------------
  // 2. DATA FETCHING CALLBACKS THAT DEPEND ON OTHER FETCH FUNCTIONS
  //    (but not on CRUD handlers)
  // ------------------------------------------------------------------
  const fetchDashboardData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [statsRes, requestsRes, usersRes] = await Promise.all([
        axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/stats', { 
          params: { start: filters.start, end: filters.end }
        }),
        axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/requests', { 
          params: { 
            start: filters.start, 
            end: filters.end,
            status: filters.status !== 'all' ? filters.status : undefined
          }
        }),
        axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/users', {
          params: { user_type: filters.user_type !== 'all' ? filters.user_type : undefined }
        })
      ]);
      const safeStats = {
        total_users: safeParseInt(statsRes.data?.total_users),
        total_requests: safeParseInt(statsRes.data?.total_requests),
        
        active_women: safeParseInt(statsRes.data?.active_women),
        recent_activity: Array.isArray(statsRes.data?.recent_activity) ? statsRes.data.recent_activity : [],
        total_women: safeParseInt(statsRes.data?.total_women),
        employer_count: safeParseInt(statsRes.data?.employer_count),
        new_this_month: safeParseInt(statsRes.data?.new_this_month),
        active_today: safeParseInt(statsRes.data?.active_today),
        pending_requests: safeParseInt(statsRes.data?.pending_requests),
        approved_requests: safeParseInt(statsRes.data?.approved_requests),
        rejected_requests: safeParseInt(statsRes.data?.rejected_requests),
        employment_stats: statsRes.data?.employment_stats || {
          employed: 0, unemployed: 0, studying: 0,
          working_for_others: 0, employed_by_company: 0, self_employed: 0
        }
      };
      setStats(safeStats);
      setStats(safeStats);
      setRequests(requestsRes.data || []);
      setUsers(usersRes.data || []);
      
      const newNotifications = [];
      const pendingCount = (requestsRes.data || []).filter(req => req.status === 'pending').length;
      if (pendingCount > 0) {
        newNotifications.push({
          id: 1, type: 'warning',
          message: t('notificationPendingRequests', { count: pendingCount }),
          time: t('justNow'), action: () => setActiveMenu('requests')
        });
      }
      const newUsersCount = (usersRes.data || []).filter(u => {
        const userDate = new Date(u.created_at);
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        return userDate > weekAgo;
      }).length;
      if (newUsersCount > 0) {
        newNotifications.push({
          id: 2, type: 'user',
          message: `${newUsersCount} ${t('newUsersThisWeek')}`,
          time: t('justNow'), action: () => setActiveMenu('users')
        });
      }
     
      setNotifications(newNotifications);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setError(error.response?.data?.error || t('failedLoadDashboard'));
      if (error.response?.status === 401) onLogout();
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [filters, onLogout, t]);


  // ✅ Helper: Show email toggle toast
const showEmailToast = useCallback((message, type = 'error') => {
  setEmailToggleToast({ message, type });
  setTimeout(() => setEmailToggleToast(null), 5000);
}, []);

  const fetchRequestsWithSpecs = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/requests-with-specs', {
        params: { ...requestFilters, include_contract_period: true, include_competence_skills: true },
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setRequestsWithSpecs(response.data || []);
    } catch (error) {
      console.error('Error fetching requests with specifications:', error);
      setError(t('failedLoadRequests'));
    }
  }, [requestFilters, t]);

  const fetchWomenProfiles = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles', {
        params: {
          ...womenFilters,
          page: womenPagination.page,
          limit: womenPagination.limit,
          include_employer: true,
          include_certificates: true,
          lang: undefined
        }
      });
      setWomenProfiles(response.data.profiles || []);
      setWomenPagination(response.data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (error) {
      console.error('Error fetching women profiles:', error);
      setError(t('failedLoadWomenProfiles'));
      if (error.response?.status === 401 || error.response?.status === 403) setError(t('accessDenied'));
      else setError(`${t('failedLoadWomenProfiles')}: ${error.response?.data?.error || error.message}`);
      setWomenProfiles([]);
      setWomenPagination({ total: 0, page: 1, limit: 20, pages: 1 });
    }
  }, [womenFilters, womenPagination.page, womenPagination.limit, t]);



  
// ===== ONGOING TRAINING FETCH =====
const fetchOngoingTrainees = useCallback(async () => {
  try {
    const res = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees', {
      params: {
        ...ongoingFilters,
        page: ongoingPagination.page,
        limit: ongoingPagination.limit
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    setOngoingTrainees(res.data.trainees || []);
    setOngoingPagination(res.data.pagination || { total: 0, page: 1, pages: 1 });
  } catch (err) {
    console.error('Error fetching ongoing trainees:', err);
    setError('Failed to load ongoing trainees');
  }
}, [ongoingFilters, ongoingPagination.page, ongoingPagination.limit]);

const fetchOngoingCount = useCallback(async () => {
  try {
    const res = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees-count', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    setOngoingCount(res.data.ongoing_count || 0);
  } catch (err) {
    console.error('Error fetching ongoing count:', err);
    setOngoingCount(0);
  }
}, []);

// ✅ Live check name as manager types
const checkOngoingName = useCallback((name) => {
  if (nameCheckTimer) clearTimeout(nameCheckTimer);
  if (!name || name.trim().length < 2) {
    setNameCheckState({ checking: false, exists: false, existing: null });
    return;
  }
  setNameCheckState(prev => ({ ...prev, checking: true }));
  const timer = setTimeout(async () => {
    try {
      const res = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees/check-name', {
        params: { name: name.trim() },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setNameCheckState({
        checking: false,
        exists: res.data.exists,
        existing: res.data.existing
      });
    } catch (err) {
      setNameCheckState({ checking: false, exists: false, existing: null });
    }
  }, 450);
  setNameCheckTimer(timer);
}, [nameCheckTimer]);



// ===== ONGOING TRAINEE ADD =====
const handleAddOngoingTrainee = useCallback(async (e) => {
  e.preventDefault();

  if (!newOngoingTrainee.name || !newOngoingTrainee.name.trim()) {
    setError('Name is required');
    return;
  }

  // ✅ Block if duplicate name detected
  if (nameCheckState.exists) {
    setError(`A trainee named "${newOngoingTrainee.name}" is already in ongoing training.`);
    return;
  }

  setLoading(true);
  try {
    await axios.post(
      'https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees',
      newOngoingTrainee,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );

    setSuccessMessage('Trainee added to ongoing training!');
    setTimeout(() => setSuccessMessage(null), 3000);

    setShowOngoingModal(false);
    setNewOngoingTrainee({
      name: '', age: '', phone: '', email: '', location: '',
      department_id: '', cohort: '', enrollment_date: new Date().toISOString().split('T')[0],
      expected_completion_date: '', notes: ''
    });
    setNameCheckState({ checking: false, exists: false, existing: null });
    fetchOngoingTrainees();
    fetchOngoingCount();
  } catch (err) {
    console.error('Error adding ongoing trainee:', err);
    setError(err.response?.data?.error || 'Failed to add trainee');
  } finally {
    setLoading(false);
  }
}, [newOngoingTrainee, nameCheckState.exists, fetchOngoingTrainees, fetchOngoingCount]);

// ===== ONGOING TRAINEE UPDATE =====
const handleUpdateOngoingTrainee = useCallback(async (e) => {
  e.preventDefault();
  if (!editingOngoing) return;
  setLoading(true);
  try {
    await axios.put(
      `https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees/${editingOngoing.id}`,
      editingOngoing,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    setSuccessMessage('Trainee updated!');
    setTimeout(() => setSuccessMessage(null), 3000);
    setShowOngoingModal(false);
    setEditingOngoing(null);
    fetchOngoingTrainees();
  } catch (err) {
    setError(err.response?.data?.error || 'Failed to update');
  } finally {
    setLoading(false);
  }
}, [editingOngoing, fetchOngoingTrainees]);

// ===== DELETE =====
const deleteOngoingTrainee = useCallback((id) => {
  setConfirmData({
    title: 'Remove Trainee',
    message: 'Remove this trainee from ongoing training?',
    onConfirm: async () => {
      try {
        await axios.delete(
          `https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setOngoingTrainees(prev => prev.filter(t => t.id !== id));
        setSelectedOngoingIds(prev => prev.filter(x => x !== id));
        setSuccessMessage('Trainee removed');
        fetchOngoingCount();
      } catch (err) {
        setError('Failed to delete');
      }
    },
    onCancel: () => {},
    confirmText: 'Remove',
    cancelText: 'Cancel',
    type: 'danger'
  });
  setShowConfirmModal(true);
}, [fetchOngoingCount]);

// ===== BULK COMPLETE =====
const handleBulkComplete = useCallback(() => {
  if (selectedOngoingIds.length === 0) {
    setError('Please select at least one trainee');
    return;
  }
  setConfirmData({
    title: 'Complete Training',
    message: `Mark ${selectedOngoingIds.length} trainee(s) as completed? They will be moved to Women Profiles with "Unemployed" status.`,
    onConfirm: async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          'https://hsn.urugowoc.org.rw/backend/api/manager/ongoing-trainees/complete',
          { trainee_ids: selectedOngoingIds },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setSuccessMessage(res.data.message);
        setTimeout(() => setSuccessMessage(null), 5000);
        setSelectedOngoingIds([]);
        fetchOngoingTrainees();
        fetchOngoingCount();
        fetchWomenProfiles();
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to complete trainees');
      } finally {
        setLoading(false);
      }
    },
    onCancel: () => {},
    confirmText: 'Complete',
    cancelText: 'Cancel',
    type: 'warning'
  });
  setShowConfirmModal(true);
}, [selectedOngoingIds, fetchOngoingTrainees, fetchOngoingCount, fetchWomenProfiles]);


  const fetchEmployerRequests = useCallback(async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/requests-for-assignment');
      setEmployerRequests(response.data || []);
    } catch (error) {
      console.error('Error fetching employer requests:', error);
    }
  }, []);

  // ------------------------------------------------------------------
  // 3. RESET / FORM HELPER CALLBACKS (independent)
  // ------------------------------------------------------------------
  const resetActivityImageForm = useCallback(() => {
    setNewActivityImage({ title: '', description: '', department_id: '', is_active: true, image: null });
    setActivityImageFile(null);
  }, []);

  const resetDepartmentForm = useCallback(() => {
    setNewDepartment({ name: '', description: '' });
  }, []);

  // ------------------------------------------------------------------
  // 4. CRUD HANDLERS THAT DEPEND ON FETCH FUNCTIONS (must come after them)
  // ------------------------------------------------------------------
  const handleAddActivityImage = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', newActivityImage.title);
    formData.append('description', newActivityImage.description);
    formData.append('department_id', newActivityImage.department_id);
    formData.append('is_active', newActivityImage.is_active ? 'true' : 'false');
    if (activityImageFile) formData.append('image', activityImageFile);
    else { setError(t('imageRequired') || 'Image file is required'); return; }
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/activity-images', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('activityImageAdded') || 'Activity image added successfully');
      setShowActivityImageModal(false);
      resetActivityImageForm();
      fetchActivityImages();
      fetchActivityImageStats();
    } catch (error) {
      console.error('Error adding activity image:', error);
      setError(`${t('failedAddActivityImage') || 'Failed to add activity image'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newActivityImage, activityImageFile, t, resetActivityImageForm, fetchActivityImages, fetchActivityImageStats]);

  const handleEditActivityImage = useCallback(async (e) => {
    e.preventDefault();
    if (!currentActivityImage) return;
    const formData = new FormData();
    formData.append('title', currentActivityImage.title || '');
    formData.append('description', currentActivityImage.description || '');
    formData.append('department_id', currentActivityImage.department_id || '');
    formData.append('is_active', currentActivityImage.is_active ? 'true' : 'false');
    if (activityImageFile) formData.append('image', activityImageFile);
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/${currentActivityImage.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('activityImageUpdated') || 'Activity image updated successfully');
      setShowActivityImageModal(false);
      setCurrentActivityImage(null);
      setActivityImageFile(null);
      fetchActivityImages();
      fetchActivityImageStats();
    } catch (error) {
      console.error('Error updating activity image:', error);
      setError(`${t('failedUpdateActivityImage') || 'Failed to update activity image'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentActivityImage, activityImageFile, t, fetchActivityImages, fetchActivityImageStats]);

  const deleteActivityImage = useCallback(async (imageId, permanent = false) => {
    const title = permanent ? t('confirmPermanentDeleteTitle') || 'Permanently Delete Image' : t('confirmDeleteImageTitle') || 'Delete Image';
    const message = permanent 
      ? t('confirmPermanentDeleteImage') || 'Are you sure you want to permanently delete this image? This action cannot be undone.'
      : t('confirmDeleteImage') || 'Are you sure you want to delete this image? It will be moved to trash.';
    setConfirmData({
      title, message,
      onConfirm: async () => {
        try {
          const url = permanent 
            ? `https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/${imageId}?permanent=true`
            : `https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/${imageId}`;
          await axios.delete(url, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
          setActivityImages(prev => prev.filter(img => img.id !== imageId));
          setSuccessMessage(permanent ? t('imagePermanentlyDeleted') || 'Image permanently deleted' : t('imageDeleted') || 'Image moved to trash');
          fetchActivityImageStats();
        } catch (error) {
          console.error('Error deleting activity image:', error);
          setError(t('failedDeleteImage') || 'Failed to delete image');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t, fetchActivityImageStats]);

  const restoreActivityImage = useCallback(async (imageId) => {
    try {
      await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/${imageId}/restore`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setActivityImages(prev => prev.map(img => img.id === imageId ? { ...img, is_active: 1 } : img));
      setSuccessMessage(t('imageRestored') || 'Image restored successfully');
      fetchActivityImageStats();
    } catch (error) {
      console.error('Error restoring activity image:', error);
      setError(t('failedRestoreImage') || 'Failed to restore image');
    }
  }, [t, fetchActivityImageStats]);

  const toggleActivityImageStatus = useCallback(async (imageId) => {
    try {
      const response = await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/${imageId}/toggle-status`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setActivityImages(prev => prev.map(img => img.id === imageId ? { ...img, is_active: response.data.is_active ? 1 : 0 } : img));
      setSuccessMessage(t('imageStatusToggled') || 'Image status updated');
      fetchActivityImageStats();
    } catch (error) {
      console.error('Error toggling activity image status:', error);
      setError(t('failedToggleImageStatus') || 'Failed to update status');
    }
  }, [t, fetchActivityImageStats]);

  const handleBulkUpload = useCallback(async (e) => {
    e.preventDefault();
    if (bulkUploadFiles.length === 0) { setError(t('selectImagesToUpload') || 'Please select images to upload'); return; }
    const formData = new FormData();
    bulkUploadFiles.forEach(file => formData.append('images', file));
    formData.append('department_id', newActivityImage.department_id);
    formData.append('is_active', newActivityImage.is_active ? 'true' : 'false');
    setLoading(true);
    try {
      const response = await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/activity-images/bulk', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(response.data.message || t('bulkUploadComplete') || 'Bulk upload completed');
      setShowBulkUploadModal(false);
      setBulkUploadFiles([]);
      fetchActivityImages();
      fetchActivityImageStats();
    } catch (error) {
      console.error('Error in bulk upload:', error);
      setError(`${t('failedBulkUpload') || 'Failed to upload images'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [bulkUploadFiles, newActivityImage.department_id, newActivityImage.is_active, t, fetchActivityImages, fetchActivityImageStats]);

  const exportActivityImages = useCallback(async () => {
    setExporting(true);
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/export/activity-images', {
        responseType: 'blob', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `activity_images_export_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); link.click(); link.remove();
      setSuccessMessage(t('exportSuccessful') || 'Activity images exported successfully');
    } catch (error) {
      console.error('Error exporting activity images:', error);
      setError(t('failedExportData') || 'Failed to export data');
    } finally { setExporting(false); }
  }, [t]);

  const handleAddDepartment = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/departments', {
        name: newDepartment.name,
        description: newDepartment.description
      }, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('departmentAdded') || 'Department added successfully');
      setShowDepartmentModal(false);
      resetDepartmentForm();
      fetchDepartmentsFull();
    } catch (error) {
      console.error('Error adding department:', error);
      setError(`${t('failedAddDepartment') || 'Failed to add department'}: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [newDepartment, t, resetDepartmentForm, fetchDepartmentsFull]);
  
  const handleEditDepartment = useCallback(async (e) => {
    e.preventDefault();
    if (!currentDepartment) return;
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/departments/${currentDepartment.id}`, {
        name: newDepartment.name,
        description: newDepartment.description
      }, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('departmentUpdated') || 'Department updated successfully');
      setShowDepartmentModal(false);
      setCurrentDepartment(null);
      resetDepartmentForm();
      fetchDepartmentsFull();
    } catch (error) {
      console.error('Error updating department:', error);
      setError(`${t('failedUpdateDepartment') || 'Failed to update department'}: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [currentDepartment, newDepartment, t, resetDepartmentForm, fetchDepartmentsFull]);

  const deleteDepartment = useCallback(async (departmentId, permanent = false) => {
    const title = permanent ? t('confirmPermanentDeleteTitle') || 'Permanently Delete Department' : t('confirmDeleteDepartmentTitle') || 'Delete Department';
    const message = permanent 
      ? t('confirmPermanentDelete') || 'Are you sure you want to permanently delete this department? This action cannot be undone.'
      : t('confirmDeleteDepartment') || 'Are you sure you want to delete this department? It will be moved to trash.';
    setConfirmData({
      title, message,
      onConfirm: async () => {
        try {
          const url = permanent 
            ? `https://hsn.urugowoc.org.rw/backend/api/manager/departments/${departmentId}?permanent=true`
            : `https://hsn.urugowoc.org.rw/backend/api/manager/departments/${departmentId}`;
          await axios.delete(url, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
          setDepartmentsFull(prev => prev.filter(dept => dept.id !== departmentId));
          setSuccessMessage(permanent ? t('departmentPermanentlyDeleted') || 'Department permanently deleted' : t('departmentDeleted') || 'Department moved to trash');
          fetchDepartmentStats();
        } catch (error) {
          console.error('Error deleting department:', error);
          setError(t('failedDeleteDepartment') || 'Failed to delete department');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t, fetchDepartmentStats]);

  const restoreDepartment = useCallback(async (departmentId) => {
    try {
      await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/departments/${departmentId}/restore`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setDepartmentsFull(prev => prev.map(dept => dept.id === departmentId ? { ...dept, is_active: 1, deleted_at: null } : dept));
      setSuccessMessage(t('departmentRestored') || 'Department restored successfully');
      fetchDepartmentStats();
    } catch (error) {
      console.error('Error restoring department:', error);
      setError(t('failedRestoreDepartment') || 'Failed to restore department');
    }
  }, [t, fetchDepartmentStats]);

 

  const handleAddHeroSlide = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', newHeroSlide.title);
    formData.append('subtitle', newHeroSlide.subtitle || '');
    formData.append('description', newHeroSlide.description || '');
    formData.append('button_text', newHeroSlide.button_text);
    formData.append('button_link', newHeroSlide.button_link);
    formData.append('sort_order', newHeroSlide.sort_order);
    formData.append('is_active', newHeroSlide.is_active ? 'true' : 'false');
    if (heroSlideFile) formData.append('background_image', heroSlideFile);
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/hero-slides', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('heroSlideAdded') || 'Hero slide added successfully');
      setShowHeroSlideModal(false);
      setNewHeroSlide({ title: '', subtitle: '', description: '', button_text: 'Explore Departments', button_link: '#departments', sort_order: 0, is_active: true, background_image: null });
      setHeroSlideFile(null);
      fetchHeroSlides();
    } catch (error) {
      console.error('Error adding hero slide:', error);
      setError(`${t('failedAddHeroSlide') || 'Failed to add hero slide'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newHeroSlide, heroSlideFile, t, fetchHeroSlides]);

  const handleEditHeroSlide = useCallback(async (e) => {
    e.preventDefault();
    if (!currentHeroSlide) return;
    const formData = new FormData();
    formData.append('title', currentHeroSlide.title);
    formData.append('subtitle', currentHeroSlide.subtitle || '');
    formData.append('description', currentHeroSlide.description || '');
    formData.append('button_text', currentHeroSlide.button_text);
    formData.append('button_link', currentHeroSlide.button_link);
    formData.append('sort_order', currentHeroSlide.sort_order);
    formData.append('is_active', currentHeroSlide.is_active ? 'true' : 'false');
    if (heroSlideFile) formData.append('background_image', heroSlideFile);
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/hero-slides/${currentHeroSlide.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('heroSlideUpdated') || 'Hero slide updated successfully');
      setShowHeroSlideModal(false);
      setCurrentHeroSlide(null);
      setHeroSlideFile(null);
      fetchHeroSlides();
    } catch (error) {
      console.error('Error updating hero slide:', error);
      setError(`${t('failedUpdateHeroSlide') || 'Failed to update hero slide'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentHeroSlide, heroSlideFile, t, fetchHeroSlides]);

  const deleteHeroSlide = useCallback(async (slideId) => {
    setConfirmData({
      title: t('confirmDeleteHeroSlideTitle') || 'Delete Hero Slide',
      message: t('confirmDeleteHeroSlide') || 'Are you sure you want to delete this hero slide?',
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/hero-slides/${slideId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          setHeroSlides(prev => prev.filter(slide => slide.id !== slideId));
          setSuccessMessage(t('heroSlideDeleted') || 'Hero slide deleted successfully');
        } catch (error) {
          console.error('Error deleting hero slide:', error);
          setError(t('failedDeleteHeroSlide') || 'Failed to delete hero slide');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const toggleHeroSlideStatus = useCallback(async (slideId) => {
    try {
      await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/hero-slides/${slideId}/toggle-status`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setHeroSlides(prev => prev.map(slide => slide.id === slideId ? { ...slide, is_active: !slide.is_active } : slide));
      setSuccessMessage(t('heroSlideStatusToggled') || 'Hero slide status updated');
    } catch (error) {
      console.error('Error toggling hero slide status:', error);
      setError(t('failedToggleHeroSlideStatus') || 'Failed to update status');
    }
  }, [t]);

  const handleAddStat = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/stats', newStat, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('statAdded') || 'Stat added successfully');
      setShowStatModal(false);
      setNewStat({ value: '', label: '', icon: 'FaHeart', color: '#FF9800', sort_order: 0, is_active: true });
      fetchStatsItems();
    } catch (error) {
      console.error('Error adding stat:', error);
      setError(`${t('failedAddStat') || 'Failed to add stat'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newStat, t, fetchStatsItems]);

  const handleEditStat = useCallback(async (e) => {
    e.preventDefault();
    if (!currentStat) return;
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/stats/${currentStat.id}`, currentStat, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('statUpdated') || 'Stat updated successfully');
      setShowStatModal(false);
      setCurrentStat(null);
      fetchStatsItems();
    } catch (error) {
      console.error('Error updating stat:', error);
      setError(`${t('failedUpdateStat') || 'Failed to update stat'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentStat, t, fetchStatsItems]);

  const deleteStat = useCallback(async (statId) => {
    setConfirmData({
      title: t('confirmDeleteStatTitle') || 'Delete Stat',
      message: t('confirmDeleteStat') || 'Are you sure you want to delete this stat?',
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/stats/${statId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          setStatsItems(prev => prev.filter(stat => stat.id !== statId));
          setSuccessMessage(t('statDeleted') || 'Stat deleted successfully');
        } catch (error) {
          console.error('Error deleting stat:', error);
          setError(t('failedDeleteStat') || 'Failed to delete stat');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const toggleMaintenanceMode = useCallback(async () => {
    setUpdatingMaintenance(true);
    setError(null);
    try {
      const response = await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/maintenance-mode', {
        is_enabled: !maintenanceMode.is_enabled,
        message: maintenanceMode.message
      }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      setMaintenanceMode(prev => ({ ...prev, is_enabled: response.data.is_enabled }));
      setSuccessMessage(`Maintenance mode ${response.data.is_enabled ? 'enabled' : 'disabled'} successfully!`);
    } catch (error) {
      console.error('Error toggling maintenance mode:', error);
      setError(`Failed to toggle maintenance mode: ${error.response?.data?.error || error.message}`);
    } finally { setUpdatingMaintenance(false); }
  }, [maintenanceMode.is_enabled, maintenanceMode.message]);

  const updateMaintenanceMessage = useCallback(async () => {
    setUpdatingMaintenance(true);
    setError(null);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/maintenance-mode', {
        is_enabled: maintenanceMode.is_enabled,
        message: maintenanceMode.message
      }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      setSuccessMessage('Maintenance message updated successfully!');
    } catch (error) {
      console.error('Error updating maintenance message:', error);
      setError(`Failed to update maintenance message: ${error.response?.data?.error || error.message}`);
    } finally { setUpdatingMaintenance(false); }
  }, [maintenanceMode.is_enabled, maintenanceMode.message]);

  const handleAddWhyChooseUs = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/why-choose-us', newWhyChooseUs, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' }
      });
      setSuccessMessage(t('whyChooseUsAdded') || 'Item added successfully');
      setShowWhyChooseUsModal(false);
      setNewWhyChooseUs({ title: '', description: '', icon_name: 'FaHeart', icon_type: 'fa', sort_order: 0, is_active: true });
      fetchWhyChooseUsItems();
    } catch (error) {
      console.error('Error adding why choose us item:', error);
      setError(`${t('failedAddWhyChooseUs') || 'Failed to add item'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newWhyChooseUs, t, fetchWhyChooseUsItems]);

  const handleEditWhyChooseUs = useCallback(async (e) => {
    e.preventDefault();
    if (!currentWhyChooseUs) return;
    setLoading(true);
    setError(null);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/why-choose-us/${currentWhyChooseUs.id}`, currentWhyChooseUs, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' }
      });
      setSuccessMessage(t('whyChooseUsUpdated') || 'Item updated successfully');
      setShowWhyChooseUsModal(false);
      setCurrentWhyChooseUs(null);
      fetchWhyChooseUsItems();
    } catch (error) {
      console.error('Error updating why choose us item:', error);
      setError(`${t('failedUpdateWhyChooseUs') || 'Failed to update item'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentWhyChooseUs, t, fetchWhyChooseUsItems]);

  const deleteWhyChooseUsItem = useCallback(async (itemId) => {
    setConfirmData({
      title: t('confirmDeleteWhyChooseUsTitle') || 'Delete Item',
      message: t('confirmDeleteWhyChooseUs') || 'Are you sure you want to delete this item?',
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/why-choose-us/${itemId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          setWhyChooseUsItems(prev => prev.filter(item => item.id !== itemId));
          setSuccessMessage(t('whyChooseUsDeleted') || 'Item deleted successfully');
        } catch (error) {
          console.error('Error deleting why choose us item:', error);
          setError(t('failedDeleteWhyChooseUs') || 'Failed to delete item');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const toggleWhyChooseUsStatus = useCallback(async (itemId) => {
    try {
      const response = await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/why-choose-us/${itemId}/toggle-status`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setWhyChooseUsItems(prev => prev.map(item => item.id === itemId ? { ...item, is_active: response.data.is_active ? 1 : 0 } : item));
      setSuccessMessage(t('whyChooseUsStatusToggled') || 'Status updated successfully');
    } catch (error) {
      console.error('Error toggling why choose us status:', error);
      setError(t('failedToggleWhyChooseUsStatus') || 'Failed to update status');
    }
  }, [t]);

  const handleAddVideoSection = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    if (!newVideoSection.video_file) { setError(t('videoFileRequired') || 'Video file is required'); setLoading(false); return; }
    const formData = new FormData();
    formData.append('video_file', newVideoSection.video_file);
    formData.append('title', newVideoSection.title || '');
    formData.append('description', newVideoSection.description || '');
    formData.append('is_active', newVideoSection.is_active ? 'true' : 'false');
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/video-sections', formData, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'multipart/form-data' }
      });
      setSuccessMessage(t('videoSectionAdded') || 'Video section added successfully');
      setShowVideoSectionModal(false);
      setNewVideoSection({ title: '', description: '', video_file: null, is_active: false });
      fetchVideoSections();
    } catch (error) {
      console.error('Error adding video section:', error);
      setError(`${t('failedAddVideoSection') || 'Failed to add video section'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newVideoSection, t, fetchVideoSections]);

  const handleEditVideoSection = useCallback(async (e) => {
    e.preventDefault();
    if (!currentVideoSection) return;
    setLoading(true);
    setError(null);
    const formData = new FormData();
    formData.append('title', currentVideoSection.title || '');
    formData.append('description', currentVideoSection.description || '');
    formData.append('is_active', currentVideoSection.is_active ? 'true' : 'false');
    if (currentVideoSection.video_file && currentVideoSection.video_file instanceof File) formData.append('video_file', currentVideoSection.video_file);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/video-sections/${currentVideoSection.id}`, formData, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'multipart/form-data' }
      });
      setSuccessMessage(t('videoSectionUpdated') || 'Video section updated successfully');
      setShowVideoSectionModal(false);
      setCurrentVideoSection(null);
      fetchVideoSections();
    } catch (error) {
      console.error('Error updating video section:', error);
      setError(`${t('failedUpdateVideoSection') || 'Failed to update video section'}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentVideoSection, t, fetchVideoSections]);

  const deleteVideoSection = useCallback(async (videoId) => {
    setConfirmData({
      title: t('confirmDeleteVideoTitle') || 'Delete Video Section',
      message: t('confirmDeleteVideo') || 'Are you sure you want to delete this video section?',
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/video-sections/${videoId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          setVideoSections(prev => prev.filter(video => video.id !== videoId));
          setSuccessMessage(t('videoSectionDeleted') || 'Video section deleted successfully');
        } catch (error) {
          console.error('Error deleting video section:', error);
          setError(t('failedDeleteVideoSection') || 'Failed to delete video section');
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const setActiveVideo = useCallback(async (videoId) => {
    try {
      await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/video-sections/${videoId}/set-active`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setVideoSections(prev => prev.map(video => ({ ...video, is_active: video.id === videoId ? 1 : 0 })));
      setSuccessMessage(t('videoActivated') || 'Video activated successfully');
    } catch (error) {
      console.error('Error setting active video:', error);
      setError(t('failedActivateVideo') || 'Failed to activate video');
    }
  }, [t]);

  const sendContractReminder = useCallback(async (contract) => {
    setConfirmData({
      title: t('sendContractReminder') || 'Send Contract Expiration Reminder',
      message: t('confirmSendReminder', { woman: contract.woman_name, employer: contract.employer_name, days: contract.days_remaining }) ||
                `Send contract expiration reminder for ${contract.woman_name} to ${contract.employer_name}?`,
      onConfirm: async () => {
        try {
          await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/send-contract-reminder', {
            contract_id: contract.id, woman_id: contract.woman_id, employer_id: contract.employer_id,
            days_remaining: contract.days_remaining, end_date: contract.end_date
          }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
          setSuccessMessage(t('reminderSent') || 'Reminder sent successfully!');
        } catch (error) {
          console.error('Error sending reminder:', error);
          setError(t('failedSendReminder') || 'Failed to send reminder');
        }
      },
      onCancel: () => {},
      confirmText: t('send') || 'Send', cancelText: t('cancel') || 'Cancel', type: 'warning'
    });
    setShowConfirmModal(true);
  }, [t]);

  const renewContract = useCallback(async (contract) => {
    const months = window.prompt(t('enterRenewalMonths') || `Enter number of months to renew contract for ${contract.woman_name}:`, '12');
    if (months && !isNaN(months) && parseInt(months) > 0) {
      setLoading(true);
      try {
        await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/renew-contract', {
          contract_id: contract.id, woman_id: contract.woman_id, employer_id: contract.employer_id,
          renewal_months: parseInt(months), current_end_date: contract.end_date
        }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
        setSuccessMessage(t('contractRenewed') || `Contract renewed for ${months} months!`);
        fetchExpiringContracts();
      } catch (error) {
        console.error('Error renewing contract:', error);
        setError(t('failedRenewContract') || 'Failed to renew contract');
      } finally { setLoading(false); }
    }
  }, [t, fetchExpiringContracts]);

  const openEmailModal = useCallback((request) => {
    setEmailData({ to: request.employer_email, subject: `Regarding Your Request REQ-${request.id}`, html: '', request_id: request.id });
    setShowEmailModal(true);
  }, []);

  const sendEmail = useCallback(async () => {
  try {
    const response = await axios.post(
      'https://hsn.urugowoc.org.rw/backend/api/send-email',
      emailData,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    // ✅ Check if email was blocked due to toggle
    if (response.data.blocked || response.data.email_disabled) {
      showEmailToast(
        '📧 Email notifications are currently DISABLED. Your email was NOT sent. Go to Settings → Email Notifications to enable.',
        'error'
      );
      setShowEmailModal(false);
      setEmailData({ to: '', subject: '', html: '', request_id: '' });
      return;
    }
    
    setSuccessMessage('Email sent successfully');
    setShowEmailModal(false);
    setEmailData({ to: '', subject: '', html: '', request_id: '' });
  } catch (error) {
    console.error('Failed to send email:', error);
    setError(`Failed to send email: ${error.response?.data?.error || error.message}`);
  }
}, [emailData, showEmailToast]);

  const openEmailBroadcastModal = useCallback(() => {
    setEmailBroadcastData({ subject: '', message: '', recipients: 'all', test_email: '', send_as_test: false });
    setShowEmailBroadcastModal(true);
  }, []);

  const sendEmailBroadcast = useCallback(async () => {
  if (!emailBroadcastData.subject || !emailBroadcastData.message) {
    setError('Subject and message are required');
    return;
  }
  if (emailBroadcastData.send_as_test && !emailBroadcastData.test_email) {
    setError('Test email address is required');
    return;
  }
  
  // ✅ Quick check via frontend state
  if (!emailNotificationsEnabled && !emailBroadcastData.send_as_test) {
    showEmailToast(
      '📧 Email notifications are DISABLED. Please enable them in Settings before sending broadcasts.',
      'error'
    );
    return;
  }
  
  setBroadcastLoading(true);
  setError(null);
  
  try {
    const endpoint = emailBroadcastData.send_as_test
      ? 'https://hsn.urugowoc.org.rw/backend/api/manager/send-test-broadcast'
      : 'https://hsn.urugowoc.org.rw/backend/api/manager/send-broadcast';
    
    const response = await axios.post(endpoint, emailBroadcastData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.blocked || response.data.email_disabled) {
      showEmailToast(
        '📧 Email notifications are DISABLED. Broadcast was NOT sent.',
        'error'
      );
    } else {
      setSuccessMessage(response.data.message || 'Email broadcast sent successfully!');
    }
    
    setShowEmailBroadcastModal(false);
    setEmailBroadcastData({
      subject: '',
      message: '',
      recipients: 'all',
      test_email: '',
      send_as_test: false
    });
  } catch (error) {
    console.error('Failed to send email broadcast:', error);
    setError(`Failed to send email: ${error.response?.data?.error || error.message}`);
  } finally {
    setBroadcastLoading(false);
  }
}, [emailBroadcastData, emailNotificationsEnabled, showEmailToast]);

  const openCustomEmailModal = useCallback(() => {
    setCustomEmailData({ recipients: '', subject: '', message: '', attachments: [] });
    setShowCustomEmailModal(true);
  }, []);

  const handleAttachmentChange = useCallback((e) => {
    const files = Array.from(e.target.files);
    if (files.length > 5) { setError('Maximum 5 attachments allowed'); return; }
    setCustomEmailData(prev => ({ ...prev, attachments: files }));
  }, []);

 const sendCustomEmail = useCallback(async () => {
  if (!customEmailData.recipients || !customEmailData.subject || !customEmailData.message) {
    setError('Recipients, subject, and message are required');
    return;
  }
  
  const emailList = customEmailData.recipients.split(',').map(email => email.trim());
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const invalidEmails = emailList.filter(email => !emailRegex.test(email));
  if (invalidEmails.length > 0) {
    setError(`Invalid email addresses: ${invalidEmails.join(', ')}`);
    return;
  }
  
  // ✅ Quick check via frontend state
  if (!emailNotificationsEnabled) {
    showEmailToast(
      '📧 Email notifications are DISABLED. Your custom email was NOT sent. Enable them in Settings first.',
      'error'
    );
    return;
  }
  
  setCustomEmailLoading(true);
  setError(null);
  
  try {
    const formData = new FormData();
    formData.append('recipients', customEmailData.recipients);
    formData.append('subject', customEmailData.subject);
    formData.append('message', customEmailData.message);
    customEmailData.attachments.forEach((file) => formData.append('attachments', file));
    
    const response = await axios.post(
      'https://hsn.urugowoc.org.rw/backend/api/manager/send-custom-email',
      formData,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    if (response.data.blocked || response.data.email_disabled) {
      showEmailToast(
        '📧 Email notifications are DISABLED. Custom email was NOT sent.',
        'error'
      );
    } else {
      setSuccessMessage(response.data.message || 'Custom email sent successfully!');
    }
    
    setShowCustomEmailModal(false);
    setCustomEmailData({ recipients: '', subject: '', message: '', attachments: [] });
  } catch (error) {
    console.error('Failed to send custom email:', error);
    if (error.response) {
      setError(`Server error: ${error.response.status} - ${error.response.data?.error || error.message}`);
    } else if (error.request) {
      setError('No response from server. Please check your connection.');
    } else {
      setError(`Request error: ${error.message}`);
    }
  } finally {
    setCustomEmailLoading(false);
  }
}, [customEmailData, emailNotificationsEnabled, showEmailToast]);

 // ✅ REPLACED: Open modal instead of window.prompt
const openApproveRejectModal = useCallback((requestId, action, requestData = null) => {
  setApproveRejectAction({ action, requestId, requestData });
  setApproveRejectMessage('');
  setApproveRejectSendEmail(true);
  setShowApproveRejectModal(true);
}, []);

// ✅ NEW: Actual submission from modal
const submitApproveRejectAction = useCallback(async () => {
  if (!approveRejectAction) return;
  
  const { requestId, action } = approveRejectAction;
  
  setApproveRejectSubmitting(true);
  setUpdatingRequest(true);
  setError(null);
  
  try {
    const response = await axios.put(
      `https://hsn.urugowoc.org.rw/backend/api/manager/requests-with-specs/${requestId}/status`,
      {
        status: action,
        message: approveRejectSendEmail ? (approveRejectMessage || '') : '',
        send_email: approveRejectSendEmail
      }
    );
    
    // Update local state
    setRequestsWithSpecs(prev => prev.map(req => 
      req.id === requestId ? { ...req, status: action } : req
    ));
    
    // ✅ Handle email toggle feedback
    const data = response.data || {};
    if (data.email_disabled || data.email_blocked) {
      showEmailToast(
        `Request ${action}. Email notification was NOT sent because email notifications are currently DISABLED in Settings.`,
        'error'
      );
    } else if (data.email_sent) {
      setSuccessMessage(t('requestStatusUpdated', { status: action }) + ' — Email sent to employer.');
      setTimeout(() => setSuccessMessage(null), 5000);
    } else {
      setSuccessMessage(t('requestStatusUpdated', { status: action }));
      setTimeout(() => setSuccessMessage(null), 5000);
    }
    
    // Close modals
    setShowApproveRejectModal(false);
    setApproveRejectAction(null);
    setApproveRejectMessage('');
    
    if (showRequestDetailsModal) {
      setShowRequestDetailsModal(false);
      setSelectedRequestWithSpecs(null);
    }
    
    setTimeout(() => fetchRequestsWithSpecs(), 800);
  } catch (error) {
    console.error('Error updating request status:', error);
    setError(t('failedUpdateRequest') + ': ' + (error.response?.data?.error || error.message));
  } finally {
    setApproveRejectSubmitting(false);
    setUpdatingRequest(false);
  }
}, [
  approveRejectAction,
  approveRejectMessage,
  approveRejectSendEmail,
  showRequestDetailsModal,
  fetchRequestsWithSpecs,
  t,
  showEmailToast
]);

  const handleAssignToEmployer = useCallback(async (selectedReq) => {
    if (!selectedReq) { setError(t('selectRequestEmployer')); return; }
    if (selectedWomenForAssignment.length === 0) { setError(t('noWomenSelected')); return; }
    setLoading(true);
    setError(null);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/assign-women', {
        women_ids: selectedWomenForAssignment, request_id: selectedReq.request_id, employer_id: selectedReq.employer_id
      });
      setSuccessMessage(t('successfullyAssignedWomenWithEmail', {
        count: selectedWomenForAssignment.length, employer: selectedReq.employer_name, email: selectedReq.employer_email
      }));
      setShowAssignModal(false);
      setSelectedWomenForAssignment([]);
      setSelectedRequest(null);
      fetchWomenProfiles();
      if (activeMenu === 'requests') fetchRequestsWithSpecs();
    } catch (error) {
      console.error('Error assigning women:', error);
      setError(`${t('failedToAssignWomen')}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [selectedWomenForAssignment, t, fetchWomenProfiles, activeMenu, fetchRequestsWithSpecs]);

  const handleRefresh = useCallback(() => {
    setRefreshing(true);
    fetchDashboardData();
    if (activeMenu === 'women') fetchWomenProfiles();
  }, [fetchDashboardData, fetchWomenProfiles, activeMenu]);

// Fetch women by employment status with pagination
const fetchEmploymentStatusWomen = useCallback(async (statusKey, page = 1, limit = 20) => {
  setModalLoading(true);
  setError(null);
  try {
    const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles', {
      params: {
        employment_status: statusKey,
        page: page,
        limit: limit,
        include_employer: true,
        include_certificates: true,
        lang: undefined
      },
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    const data = response.data;
    setFilteredWomen(data.profiles || []);
    setEmploymentModalPagination({
      page: data.pagination.page || page,
      limit: data.pagination.limit || limit,
      total: data.pagination.total || 0,
      pages: data.pagination.pages || 1
    });
    setSelectedEmploymentStatus({ key: statusKey, label: t(statusKey) || statusKey });
    setShowEmploymentModal(true);
  } catch (error) {
    console.error('Error fetching women by status:', error);
    setError(t('failedLoadWomenProfiles') + ': ' + (error.response?.data?.error || error.message));
  } finally {
    setModalLoading(false);
  }
}, [t]);

// Click handler for status cards
const handleEmploymentCardClick = useCallback((statusKey, statusLabel) => {
  fetchEmploymentStatusWomen(statusKey, 1, 20);
}, [fetchEmploymentStatusWomen]);

// Change page inside modal
const handleEmploymentModalPageChange = useCallback((newPage) => {
  if (selectedEmploymentStatus) {
    fetchEmploymentStatusWomen(selectedEmploymentStatus.key, newPage, employmentModalPagination.limit);
  }
}, [selectedEmploymentStatus, employmentModalPagination.limit, fetchEmploymentStatusWomen]);
  const viewEmployerDetails = useCallback(async (employerId) => {
    try {
      const response = await axios.get(`https://hsn.urugowoc.org.rw/backend/api/manager/employer/${employerId}`);
      setEmployerDetails(response.data);
      setShowEmployerModal(true);
    } catch (error) {
      console.error('Error fetching employer details:', error);
      setError(t('failedLoadEmployerDetails'));
    }
  }, [t]);

  const handleSelectForAssignment = useCallback((womanId) => {
    const womanProfile = womenProfiles.find(w => w.id === womanId);
    if (!womanProfile?.is_available) return;
    setSelectedWomenForAssignment(prev => prev.includes(womanId) ? prev.filter(id => id !== womanId) : [...prev, womanId]);
  }, [womenProfiles]);

  const handleOpenAssignModal = useCallback(() => {
    if (selectedWomenForAssignment.length === 0) { setError(t('selectWomenToAssign')); return; }
    fetchEmployerRequests();
    setShowAssignModal(true);
  }, [selectedWomenForAssignment.length, t, fetchEmployerRequests]);

  const updateRequestStatus = useCallback(async (requestId, status) => {
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/request/${requestId}/status`, { status });
      setRequests(prev => prev.map(req => req.id === requestId ? { ...req, status } : req));
      setSuccessMessage(t('requestStatusUpdated', { status }));
      setTimeout(() => setSuccessMessage(null), 5000);
    } catch (error) {
      console.error('Error updating request:', error);
      setError(t('failedUpdateRequest'));
    }
  }, [t]);

  const updateUserStatus = useCallback(async (userId, status) => {
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/users/${userId}/status`, { status });
      setUsers(prev => prev.map(user => user.id === userId ? { ...user, status } : user));
      setSuccessMessage(t('userStatusUpdated', { status: status === 'suspended' ? t('suspended') : t('activated') }));
      setTimeout(() => setSuccessMessage(null), 5000);
    } catch (error) {
      console.error('Error updating user status:', error);
      setError(t('failedUpdateUser'));
    }
  }, [t]);

  const deleteUser = useCallback(async (userId) => {
    setConfirmData({
      title: t('confirmDeleteUserTitle'), message: t('confirmDeleteUser'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/users/${userId}`);
          setUsers(prev => prev.filter(user => user.id !== userId));
          setSuccessMessage(t('userDeleted'));
          setTimeout(() => setSuccessMessage(null), 5000);
        } catch (error) {
          console.error('Error deleting user:', error);
          setError(t('failedDeleteUser'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const toggleAvailability = useCallback(async (profileId, isAvailable) => {
    try {
      const profile = womenProfiles.find(p => p.id === profileId);
      const updateData = { is_available: isAvailable };
      if (isAvailable && profile) { updateData.assigned_employer_id = null; updateData.assigned_request_id = null; updateData.assigned_at = null; }
      const formData = new FormData();
      Object.keys(updateData).forEach(key => formData.append(key, updateData[key]));
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${profileId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setWomenProfiles(prev => prev.map(profile => profile.id === profileId ? {
        ...profile, is_available: isAvailable,
        ...(isAvailable ? { assigned_employer_id: null, assigned_request_id: null, assigned_at: null } : {})
      } : profile));
      setSuccessMessage(t('profileAvailabilityUpdated', { status: isAvailable ? t('available') : t('hired') }));
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error('Error toggling availability:', error);
      setError(`${t('failedUpdateProfile')}: ${error.response?.data?.error || error.message}`);
    }
  }, [womenProfiles, t]);

  const deleteProfile = useCallback(async (profileId) => {
    setConfirmData({
      title: t('confirmDeleteProfileTitle'), message: t('confirmDeleteProfile'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${profileId}`);
          setWomenProfiles(prev => prev.filter(profile => profile.id !== profileId));
          setSuccessMessage(t('profileDeleted'));
          setTimeout(() => setSuccessMessage(null), 3000);
        } catch (error) {
          console.error('Error deleting profile:', error);
          setError(t('failedDeleteProfile'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  // const handleAddProfile = useCallback(async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData();
    
    // Add all fields to formData
  //   const fields = {
  //     name: newProfile.name,
  //     age: newProfile.age,
  //     cohort: newProfile.cohort,
  //     department_id: newProfile.department_id,
  //     phone: newProfile.phone,
  //     email: newProfile.email,
  //     placement_location: newProfile.placement_location,
  //     competence_skills: newProfile.competence_skills,
  //     skills: newProfile.skills,
  //     employment_status: newProfile.employment_status,
  //     employment_sector: newProfile.employment_sector,
  //     company_name: newProfile.company_name,
  //     working_position: newProfile.working_position,
  //     working_location: newProfile.working_location,
  //     mode_of_employment: newProfile.mode_of_employment,
  //     years_of_experience: newProfile.years_of_experience,
  //     monthly_income: newProfile.monthly_income,
  //     contract_start_date: newProfile.contract_start_date,
  //     contract_end_date: newProfile.contract_end_date,
  //     job_secured_how: newProfile.job_secured_how,
  //     job_relevance: newProfile.job_relevance,
  //     entrepreneurship: newProfile.entrepreneurship,
  //     entrepreneurship_employed_count: newProfile.entrepreneurship_employed_count,
  //     confidence_improved: newProfile.confidence_improved,
  //     financial_support_changed: newProfile.financial_support_changed,
  //     financial_stability_rating: newProfile.financial_stability_rating,
  //     saved_money: newProfile.saved_money,
  //     income_management_confidence: newProfile.income_management_confidence,
  //     community_impact: newProfile.community_impact,
  //     leadership_involvement: newProfile.leadership_involvement,
  //     education_level: newProfile.education_level,
  //     location: newProfile.location,
  //     bio: newProfile.bio,
  //     is_available: true,
  //     is_active: true
  //   };
    
  //   Object.keys(fields).forEach(key => {
  //     if (fields[key] !== null && fields[key] !== undefined && fields[key] !== '') {
  //       if (key === 'job_search_challenges' || key === 'support_needed') {
  //         if (Array.isArray(fields[key]) && fields[key].length > 0) {
  //           formData.append(key, JSON.stringify(fields[key]));
  //         }
  //       } else if (key !== 'photo') {
  //         formData.append(key, fields[key]);
  //       }
  //     }
  //   });
    
  //   if (newProfile.photo) {
  //     formData.append('photo', newProfile.photo);
  //   }
    
  //   try {
  //     await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles', formData, {
  //       headers: { 'Content-Type': 'multipart/form-data' }
  //     });
  //     setShowAddModal(false);
  //     setNewProfile({
  //       name: '',
  //       age: '',
  //       cohort: '',
  //       department_id: '',
  //       phone: '',
  //       email: '',
  //       placement_location: '',
  //       competence_skills: '',
  //       skills: '',
  //       photo: null,
  //       employment_status: '',
  //       employment_sector: '',
  //       company_name: '',
  //       working_position: '',
  //       working_location: '',
  //       mode_of_employment: '',
  //       years_of_experience: '',
  //       monthly_income: '',
  //       contract_start_date: '',
  //       contract_end_date: '',
  //       job_secured_how: '',
  //       job_relevance: '',
  //       job_search_challenges: [],
  //       entrepreneurship: '',
  //       entrepreneurship_employed_count: '',
  //       support_needed: [],
  //       confidence_improved: '',
  //       financial_support_changed: '',
  //       financial_stability_rating: '',
  //       saved_money: '',
  //       income_management_confidence: '',
  //       community_impact: '',
  //       leadership_involvement: '',
  //       education_level: '',
  //       location: '',
  //       bio: ''
  //     });
  //     fetchWomenProfiles();
  //     setSuccessMessage(t('profileAdded'));
  //     setTimeout(() => setSuccessMessage(null), 3000);
  //   } catch (error) {
  //     console.error('Error adding profile:', error);
  //     setError(`${t('failedAddProfile')}: ${error.response?.data?.error || error.message}`);
  //   }
  // }, [newProfile, t, fetchWomenProfiles]);
  // const handleEditProfile = useCallback(async (e) => {
  //   e.preventDefault();
  //   if (!currentProfile) return;
  //   const formData = new FormData();
  //   Object.keys(currentProfile).forEach(key => {
  //     if (currentProfile[key] !== null && currentProfile[key] !== undefined) {
  //       if (key === 'photo' && currentProfile[key]) formData.append(key, currentProfile[key]);
  //       else if (key === 'certificate_file' && currentProfile[key]) { /* skip */ }
  //       else if (key === 'certificate_number' && currentProfile[key]) { /* skip */ }
  //       else if (key === 'certificate_verified' && currentProfile[key] !== undefined) { /* skip */ }
  //       else if (key === 'certificates' || key === 'latest_certificate') { /* skip */ }
  //       else if (key !== 'photo') formData.append(key, currentProfile[key]);
  //     }
  //   });
  //   try {
  //     await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${currentProfile.id}`, formData, {
  //       headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  //     });
  //     setShowEditModal(false);
  //     setCurrentProfile(null);
  //     await fetchWomenProfiles();
  //     setSuccessMessage(t('profileUpdated'));
  //     setTimeout(() => setSuccessMessage(null), 3000);
  //   } catch (error) {
  //     console.error('Error updating profile:', error);
  //     setError(`${t('failedUpdateProfile')}: ${error.response?.data?.error || error.message}`);
  //   }
  // }, [currentProfile, t, fetchWomenProfiles]);


  const handleTraineeRegistrationSuccess = useCallback(() => {
    const wasEditing = !!editingTrainee;
    setShowTraineeRegistrationModal(false);
    setEditingTrainee(null);
    fetchWomenProfiles();
    setSuccessMessage(wasEditing ? 'Trainee updated successfully!' : 'Trainee added successfully!');
    setTimeout(() => setSuccessMessage(null), 3000);
  }, [fetchWomenProfiles, editingTrainee]);

const openAddTraineeModal = useCallback(() => {
  setEditingTrainee(null);
  setShowTraineeRegistrationModal(true);
}, []);

const openEditTraineeModal = useCallback((profile) => {
  setEditingTrainee(profile);
  setShowTraineeRegistrationModal(true);
}, []);


const exportFilteredWomen = (format) => {
  if (filteredWomen.length === 0) {
    setError('No data to export');
    return;
  }

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Full Name' },
    { key: 'department_name', label: 'Department' },
    { key: 'phone', label: 'Phone' },
    { key: 'email', label: 'Email' },
    { key: 'employment_status', label: 'Employment Status' },
    { key: 'company_name', label: 'Company' },
    { key: 'working_position', label: 'Position' }
  ];

  const generateHtml = () => {
    const headerRow = columns.map(c => `<th style="border:1px solid #000;padding:8px;background:#2c3e50;color:#fff;text-align:left;">${c.label}</th>`).join('');
    const rowsHtml = filteredWomen.map((w, idx) => {
      const cells = columns.map(c => {
        let val = w[c.key] || '-';
        if (typeof val === 'string') val = val.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return `<td style="border:1px solid #000;padding:6px;${idx%2===0?'background:#f9f9f9;':''}">${val}</td>`;
      }).join('');
      return `<tr>${cells}</tr>`;
    }).join('');

    return `
      <html>
        <head><meta charset="UTF-8"><title>${selectedEmploymentStatus?.label} Women</title></head>
        <body>
          <h2 style="text-align:center;">${selectedEmploymentStatus?.label} - ${filteredWomen.length} Women</h2>
          <table style="border-collapse:collapse;width:100%;font-family:Arial,sans-serif;font-size:12px;">
            <thead><tr>${headerRow}</tr></thead>
            <tbody>${rowsHtml}</tbody>
          </table>
          <p style="text-align:center;margin-top:20px;font-size:11px;color:#777;">
            Generated on ${new Date().toLocaleString()}
          </p>
        </body>
      </html>
    `;
  };

  if (format === 'excel') {
    const html = generateHtml();
    const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${selectedEmploymentStatus?.key}_women_${new Date().toISOString().split('T')[0]}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } else if (format === 'pdf') {
    const html = generateHtml();
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.print();
  }
};

  const exportData = useCallback(async (type) => {
    setExporting(true);
    try {
      const response = await axios.get(`https://hsn.urugowoc.org.rw/backend/api/manager/export/${type}`, {
        responseType: 'blob', params: { start: filters.start, end: filters.end, lang: undefined }
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${type}_export_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); link.click(); link.remove();
      setSuccessMessage(t('exportSuccessful'));
      setTimeout(() => setSuccessMessage(null), 5000);
    } catch (error) {
      console.error('Error exporting data:', error);
      setError(t('failedExportData'));
    } finally { setExporting(false); }
  }, [filters.start, filters.end, t]);

  // Enhanced Contract Export
const exportContractsAsCSV = useCallback((contracts, type = 'all') => {
  const fileName = `${type}_contracts_${new Date().toISOString().split('T')[0]}.xls`;
  
  const columns = [
    { key: 'id', label: 'Contract ID' },
    { key: 'woman_name', label: 'Woman Name' },
    { key: 'department_name', label: 'Department' },
    { key: 'employer_name', label: 'Employer Name' },
    { key: 'employer_email', label: 'Employer Email' },
    { key: 'employer_phone', label: 'Employer Phone' },
    { key: 'period_name', label: 'Contract Period' },
    { key: 'months', label: 'Months' },
    { key: 'start_date', label: 'Start Date' },
    { key: 'end_date', label: 'End Date' },
    { key: 'days_remaining', label: 'Days Remaining' },
    { key: 'status', label: 'Status' },
    { key: 'woman_phone', label: 'Woman Phone' },
    { key: 'woman_email', label: 'Woman Email' }
  ];
  
  const headerRow = columns.map(c => `<th style="border: 1px solid #000; padding: 8px 12px; background-color: #1a3a2a; color: white; font-weight: bold; text-align: left;">${c.label}</th>`).join('');
  
  const rowsHtml = contracts.map((c, index) => {
    const status = c.days_remaining <= 7 ? 'Critical' : c.days_remaining <= 30 ? 'Warning' : 'Good';
    const statusColor = c.days_remaining <= 7 ? '#ffebee' : c.days_remaining <= 30 ? '#fff3e0' : '#e8f5e9';
    
    const rowData = columns.map(col => {
      let value = c[col.key] || '';
      if (col.key === 'start_date' || col.key === 'end_date') {
        if (value) {
          try {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
              value = date.toLocaleDateString();
            }
          } catch (e) {}
        }
      }
      if (col.key === 'status') {
        value = status;
      }
      if (typeof value === 'string') {
        value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      return `<td style="border: 1px solid #000; padding: 6px 12px; font-size: 11px; ${index % 2 === 0 ? 'background-color: #f9f9f9;' : ''}">${value}</td>`;
    }).join('');
    return `<tr style="background-color: ${statusColor};">${rowData}</tr>`;
  }).join('');
  
  const htmlContent = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" 
          xmlns:x="urn:schemas-microsoft-com:office:excel" 
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Contracts</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
      <style>
        table {
          border-collapse: collapse;
          width: 100%;
          font-family: 'Segoe UI', Arial, sans-serif;
          font-size: 11px;
        }
        th {
          border: 1px solid #000;
          padding: 8px 12px;
          background-color: #1a3a2a;
          color: white;
          font-weight: bold;
          text-align: left;
          font-size: 12px;
        }
        td {
          border: 1px solid #000;
          padding: 6px 12px;
          font-size: 11px;
          vertical-align: middle;
        }
        .header-title {
          font-size: 18px;
          font-weight: bold;
          color: #1a3a2a;
          text-align: center;
          margin-bottom: 10px;
        }
        .header-info {
          font-size: 12px;
          color: #555;
          text-align: center;
          margin-bottom: 15px;
        }
        .footer {
          margin-top: 20px;
          font-size: 11px;
          color: #777;
          text-align: center;
          border-top: 1px solid #ddd;
          padding-top: 10px;
        }
      </style>
    </head>
    <body>
      <div class="header-title">Urugo WOC - Contract Management Report</div>
      <div class="header-info">
        Generated: ${new Date().toLocaleString()} | Total Contracts: ${contracts.length}
        ${type === 'expiring' ? '| Expiring Contracts Only' : ''}
      </div>
      <table>
        <thead>
          <tr>${headerRow}</tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>
      <div class="footer">
        &copy; ${new Date().getFullYear()} Urugo Women Opportunity Center. All rights reserved.
      </div>
    </body>
    </html>
  `;
  
  const blob = new Blob([htmlContent], { 
    type: 'application/vnd.ms-excel;charset=utf-8' 
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  
  setSuccessMessage(`${contracts.length} contracts exported successfully!`);
  setTimeout(() => setSuccessMessage(null), 3000);
}, []);

  const handleFilterChange = useCallback((key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({ status: 'all', start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0], end: new Date().toISOString().split('T')[0], user_type: 'all' });
    setSearchTerm('');
  }, []);

  const handleAddGalleryImage = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(newGalleryImage).forEach(key => {
      if (newGalleryImage[key] !== null && newGalleryImage[key] !== '') {
        if (key === 'image' && newGalleryImage[key]) formData.append(key, newGalleryImage[key]);
        else if (key !== 'image') formData.append(key, newGalleryImage[key]);
      }
    });
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/gallery-images', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setShowGalleryModal(false);
      setNewGalleryImage({ title: '', description: '', department_id: '', is_featured: false, image: null });
      fetchGalleryImages();
      setSuccessMessage(t('galleryImageAdded'));
    } catch (error) {
      console.error('Error adding gallery image:', error);
      setError(t('failedAddGalleryImage'));
    }
  }, [newGalleryImage, t, fetchGalleryImages]);

  const handleEditGalleryImage = useCallback(async (e) => {
    e.preventDefault();
    if (!currentGalleryImage) return;
    const formData = new FormData();
    Object.keys(currentGalleryImage).forEach(key => {
      if (currentGalleryImage[key] !== null && currentGalleryImage[key] !== undefined) {
        if (key === 'image' && currentGalleryImage[key] && currentGalleryImage[key] instanceof File) formData.append('image', currentGalleryImage[key]);
        else if (key === 'is_featured') formData.append(key, currentGalleryImage[key] ? 'true' : 'false');
        else if (key !== 'image_url' && key !== 'department_name' && key !== 'department_color') formData.append(key, currentGalleryImage[key]);
      }
    });
    if (!formData.has('updated_at')) formData.append('updated_at', new Date().toISOString());
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/gallery-images/${currentGalleryImage.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setShowGalleryModal(false);
      setCurrentGalleryImage(null);
      fetchGalleryImages();
      setSuccessMessage(t('galleryImageUpdated'));
    } catch (error) {
      console.error('Error updating gallery image:', error);
      setError(`${t('failedUpdateGalleryImage')}: ${error.response?.data?.error || error.message}`);
    }
  }, [currentGalleryImage, t, fetchGalleryImages]);

  const deleteGalleryImage = useCallback(async (imageId) => {
    setConfirmData({
      title: t('confirmDeleteImageTitle'), message: t('confirmDeleteImage'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/gallery-images/${imageId}`);
          setGalleryImages(prev => prev.filter(img => img.id !== imageId));
          setSuccessMessage(t('imageDeleted'));
        } catch (error) {
          console.error('Error deleting image:', error);
          setError(t('failedDeleteImage'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const handleSaveAbout = useCallback(async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/about-us', aboutData);
      setSuccessMessage(t('aboutPageSaved'));
      setShowAboutModal(false);
      fetchAboutData();
    } catch (error) {
      console.error('Error saving about page:', error);
      setError(`${t('failedSaveAboutPage')}: ${error.response?.data?.error || error.message}`);
    }
  }, [aboutData, t, fetchAboutData]);

  const handleAddCoreValue = useCallback(async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/core-values', newCoreValue);
      setShowCoreValueModal(false);
      setNewCoreValue({ value_text: '', sort_order: 0 });
      fetchAboutData();
      setSuccessMessage(t('coreValueAdded'));
    } catch (error) {
      console.error('Error adding core value:', error);
      setError(t('failedAddCoreValue'));
    }
  }, [newCoreValue, t, fetchAboutData]);

  const handleEditCoreValue = useCallback(async (e) => {
    e.preventDefault();
    if (!currentCoreValue) return;
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/core-values/${currentCoreValue.id}`, currentCoreValue);
      setShowCoreValueModal(false);
      setCurrentCoreValue(null);
      fetchAboutData();
      setSuccessMessage(t('coreValueUpdated'));
    } catch (error) {
      console.error('Error updating core value:', error);
      setError(t('failedUpdateCoreValue'));
    }
  }, [currentCoreValue, t, fetchAboutData]);

  const deleteCoreValue = useCallback(async (coreValueId) => {
    setConfirmData({
      title: t('confirmDeleteCoreValueTitle'), message: t('confirmDeleteCoreValue'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/core-values/${coreValueId}`);
          setCoreValues(prev => prev.filter(cv => cv.id !== coreValueId));
          setSuccessMessage(t('coreValueDeleted'));
        } catch (error) {
          console.error('Error deleting core value:', error);
          setError(t('failedDeleteCoreValue'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const handleCertificateUpload = useCallback(async (e) => {
    e.preventDefault();
    if (!selectedCertificateWoman || !certificateFile) return;
    const formData = new FormData();
    formData.append('certificate', certificateFile);
    formData.append('certificate_number', certificateData.certificate_number);
    formData.append('certificate_type', certificateData.certificate_type);
    formData.append('issuing_organization', certificateData.issuing_organization);
    setLoading(true);
    setError(null);
    try {
      await axios.post(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${selectedCertificateWoman.id}/certificate`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('certificateUploaded'));
      setShowCertificateModal(false);
      setSelectedCertificateWoman(null);
      setCertificateFile(null);
      setCertificateData({ certificate_number: '', certificate_type: '', issuing_organization: '' });
      await fetchWomenProfiles();
    } catch (error) {
      console.error('Error uploading certificate:', error);
      setError(`${t('failedUploadCertificate')}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [selectedCertificateWoman, certificateFile, certificateData, t, fetchWomenProfiles]);

  const deleteCertificate = useCallback(async (profileId) => {
    setConfirmData({
      title: t('confirmDeleteCertificateTitle'), message: t('confirmDeleteCertificate'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${profileId}/certificate`);
          setSuccessMessage(t('certificateDeleted'));
          fetchWomenProfiles();
        } catch (error) {
          console.error('Error deleting certificate:', error);
          setError(t('failedDeleteCertificate'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t, fetchWomenProfiles]);

  const verifyCertificate = useCallback(async (profileId) => {
    setConfirmData({
      title: t('confirmVerifyCertificateTitle'), message: t('confirmVerifyCertificate'),
      onConfirm: async () => {
        setLoading(true);
        try {
          await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${profileId}/certificate/verify`, { verified: true });
          setSuccessMessage(t('certificateVerifiedSuccess'));
          setWomenProfiles(prev => prev.map(profile => profile.id === profileId ? {
            ...profile, certificate_verified: true, certificate_verified_by: user?.id, certificate_verified_at: new Date().toISOString()
          } : profile));
        } catch (error) {
          console.error('Error verifying certificate:', error);
          setError(t('failedVerifyCertificate'));
        } finally { setLoading(false); }
      },
      onCancel: () => {},
      confirmText: t('verify'), cancelText: t('cancel'), type: 'warning'
    });
    setShowConfirmModal(true);
  }, [t, user?.id]);

  const unverifyCertificate = useCallback(async (profileId) => {
    setConfirmData({
      title: t('confirmUnverifyCertificateTitle'), message: t('confirmUnverifyCertificate'),
      onConfirm: async () => {
        setLoading(true);
        try {
          await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/women-profiles/${profileId}/certificate/verify`, { verified: false });
          setSuccessMessage(t('certificateUnverifiedSuccess'));
          setWomenProfiles(prev => prev.map(profile => profile.id === profileId ? {
            ...profile, certificate_verified: false, certificate_verified_by: null, certificate_verified_at: null
          } : profile));
        } catch (error) {
          console.error('Error unverifying certificate:', error);
          setError(t('failedUnverifyCertificate'));
        } finally { setLoading(false); }
      },
      onCancel: () => {},
      confirmText: t('unverify'), cancelText: t('cancel'), type: 'warning'
    });
    setShowConfirmModal(true);
  }, [t]);

  const handleAddTeamMember = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('full_name', newTeamMember.full_name || '');
    formData.append('position', newTeamMember.position || '');
    formData.append('department', newTeamMember.department || '');
    formData.append('bio', newTeamMember.bio || '');
    formData.append('email', newTeamMember.email || '');
    formData.append('phone', newTeamMember.phone || '');
    formData.append('sort_order', newTeamMember.sort_order || 0);
    formData.append('is_active', newTeamMember.is_active ? 'true' : 'false');
    if (newTeamMember.photo && newTeamMember.photo instanceof File) formData.append('photo', newTeamMember.photo);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/team-members', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }, params: {}
      });
      setShowTeamMemberModal(false);
      setNewTeamMember({ full_name: '', position: '', department: '', bio: '', email: '', phone: '', sort_order: 0, is_active: true, photo: null });
      fetchAboutData();
      setSuccessMessage(t('teamMemberAdded'));
    } catch (error) {
      console.error('Error adding team member:', error);
      setError(`${t('failedAddTeamMember')}: ${error.response?.data?.error || error.message}`);
    }
  }, [newTeamMember, t, fetchAboutData]);

  const handleEditTeamMember = useCallback(async (e) => {
    e.preventDefault();
    if (!currentTeamMember) return;
    const formData = new FormData();
    formData.append('full_name', currentTeamMember.full_name || '');
    formData.append('position', currentTeamMember.position || '');
    formData.append('department', currentTeamMember.department || '');
    formData.append('bio', currentTeamMember.bio || '');
    formData.append('email', currentTeamMember.email || '');
    formData.append('phone', currentTeamMember.phone || '');
    formData.append('sort_order', currentTeamMember.sort_order || 0);
    formData.append('is_active', currentTeamMember.is_active ? 'true' : 'false');
    if (currentTeamMember.photo && currentTeamMember.photo instanceof File) formData.append('photo', currentTeamMember.photo);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/team-members/${currentTeamMember.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }, params: {}
      });
      setShowTeamMemberModal(false);
      setCurrentTeamMember(null);
      fetchAboutData();
      setSuccessMessage(t('teamMemberUpdated'));
    } catch (error) {
      console.error('Error updating team member:', error);
      setError(`${t('failedUpdateTeamMember')}: ${error.response?.data?.error || error.message}`);
    }
  }, [currentTeamMember, t, fetchAboutData]);

  const deleteTeamMember = useCallback(async (memberId) => {
    setConfirmData({
      title: t('confirmDeleteTeamMemberTitle'), message: t('confirmDeleteTeamMember'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/team-members/${memberId}`, { params: {} });
          setTeamMembers(prev => prev.filter(member => member.id !== memberId));
          setSuccessMessage(t('teamMemberDeleted'));
        } catch (error) {
          console.error('Error deleting team member:', error);
          setError(t('failedDeleteTeamMember'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const handleAddPartner = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('partner_name', newPartner.partner_name);
    formData.append('partner_type', newPartner.partner_type);
    formData.append('website_url', newPartner.website_url || '');
    formData.append('description', newPartner.description || '');
    formData.append('sort_order', newPartner.sort_order || 0);
    formData.append('is_active', newPartner.is_active ? 'true' : 'false');
    if (partnerLogo) formData.append('logo', partnerLogo);
    setLoading(true);
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/manager/partners', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('partnerAdded'));
      setShowPartnerModal(false);
      setNewPartner({ partner_name: '', partner_type: '', website_url: '', description: '', sort_order: 0, is_active: true, logo: null });
      setPartnerLogo(null);
      fetchPartners();
    } catch (error) {
      console.error('Error adding partner:', error);
      setError(`${t('failedAddPartner')}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [newPartner, partnerLogo, t, fetchPartners]);

  const handleEditPartner = useCallback(async (e) => {
    e.preventDefault();
    if (!currentPartner) return;
    const formData = new FormData();
    formData.append('partner_name', currentPartner.partner_name);
    formData.append('partner_type', currentPartner.partner_type);
    formData.append('website_url', currentPartner.website_url || '');
    formData.append('description', currentPartner.description || '');
    formData.append('sort_order', currentPartner.sort_order || 0);
    formData.append('is_active', currentPartner.is_active ? 'true' : 'false');
    if (partnerLogo) formData.append('logo', partnerLogo);
    setLoading(true);
    try {
      await axios.put(`https://hsn.urugowoc.org.rw/backend/api/manager/partners/${currentPartner.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccessMessage(t('partnerUpdated'));
      setShowPartnerModal(false);
      setCurrentPartner(null);
      setPartnerLogo(null);
      fetchPartners();
    } catch (error) {
      console.error('Error updating partner:', error);
      setError(`${t('failedUpdatePartner')}: ${error.response?.data?.error || error.message}`);
    } finally { setLoading(false); }
  }, [currentPartner, partnerLogo, t, fetchPartners]);

  const deletePartner = useCallback(async (partnerId) => {
    setConfirmData({
      title: t('confirmDeletePartnerTitle'), message: t('confirmDeletePartner'),
      onConfirm: async () => {
        try {
          await axios.delete(`https://hsn.urugowoc.org.rw/backend/api/manager/partners/${partnerId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          setPartners(prev => prev.filter(p => p.id !== partnerId));
          setSuccessMessage(t('partnerDeleted'));
        } catch (error) {
          console.error('Error deleting partner:', error);
          setError(t('failedDeletePartner'));
        }
      },
      onCancel: () => {},
      confirmText: t('delete'), cancelText: t('cancel'), type: 'danger'
    });
    setShowConfirmModal(true);
  }, [t]);

  const togglePartnerStatus = useCallback(async (partnerId) => {
    try {
      const response = await axios.patch(`https://hsn.urugowoc.org.rw/backend/api/manager/partners/${partnerId}/toggle-status`, {}, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      setPartners(prev => prev.map(p => p.id === partnerId ? { ...p, is_active: response.data.is_active ? 1 : 0 } : p));
      setSuccessMessage(t('partnerStatusToggled'));
    } catch (error) {
      console.error('Error toggling partner status:', error);
      setError(t('failedTogglePartnerStatus'));
    }
  }, [t]);

  const handleImport = useCallback(async () => {
    if (!importFile) {
      setError(t('selectFileToImport') || 'Please select a file to import');
      return;
    }
  
    setImporting(true);
    setError(null);
  
    try {
      // Parse the Excel file using XLSX
      const data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const buffer = new Uint8Array(e.target.result);
            const workbook = XLSX.read(buffer, { type: 'array' });
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(firstSheet);
            resolve(jsonData);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(importFile);
      });
  
      if (!data || data.length === 0) {
        setError(t('emptyFile') || 'File is empty or has no data rows');
        setImporting(false);
        return;
      }
  
      // Send the parsed data as JSON
      const response = await axios.post(
        'https://hsn.urugowoc.org.rw/backend/api/manager/import-women-profiles',
        { data },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
  
      setSuccessMessage(response.data.message || `${data.length} women profiles imported successfully!`);
      setShowImportModal(false);
      setImportFile(null);
      fetchWomenProfiles();
      setTimeout(() => setSuccessMessage(null), 5000);
    } catch (error) {
      console.error('Error importing women profiles:', error);
      setError(error.response?.data?.error || t('failedImportWomen') || 'Failed to import women profiles');
    } finally {
      setImporting(false);
    }
  }, [importFile, t, fetchWomenProfiles]);

  const handlePasswordChange = useCallback(async (e) => {
    e.preventDefault();
    setChangingPassword(true);
    setPasswordError('');
    setPasswordSuccess('');
    if (passwordData.newPassword !== passwordData.confirmPassword) { setPasswordError('New passwords do not match'); setChangingPassword(false); return; }
    if (passwordData.newPassword.length < 6) { setPasswordError('Password must be at least 6 characters long'); setChangingPassword(false); return; }
    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/change-password', {
        currentPassword: passwordData.currentPassword, newPassword: passwordData.newPassword, confirmPassword: passwordData.confirmPassword
      }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      setPasswordSuccess('Password changed successfully!');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => setPasswordSuccess(''), 5000);
    } catch (error) {
      console.error('Failed to change password:', error);
      setPasswordError(error.response?.data?.error || 'Failed to change password');
    } finally { setChangingPassword(false); }
  }, [passwordData]);

  // ========== Menu items (defined after callbacks, but doesn't matter) ==========
  const menuItems = [
//     { id: 'dashboard', label: t('dashboard'), icon: <FaTachometerAlt />, mobileIcon: <FaHome /> },
//     { id: 'requests', label: t('requests'), icon: <FaClipboardList />, mobileIcon: <FaBriefcase /> },
//     { id: 'women', label: t('women'), icon: <FaVenus />, mobileIcon: <FaVenus /> },
//     { id: 'users', label: t('users'), icon: <FaUsers />, mobileIcon: <FaUsers /> },

//     { id: 'gallery', label: t('gallery'), icon: <FaImages />, mobileIcon: <FaImages /> },
//     { id: 'about', label: t('about'), icon: <FaInfoCircle />, mobileIcon: <FaInfoCircle /> },
//     { id: 'reports', label: t('reports'), icon: <FaChartPie />, mobileIcon: <FaChartBar /> },
//     { id: 'settings', label: t('settings'), icon: <FaCog />, mobileIcon: <FaCog /> },
//     { id: 'departments', label: t('departments') || 'Departments', icon: <FaBuilding />, mobileIcon: <FaBuilding /> },
//     { id: 'partners', label: t('partners'), icon: <FaHandshake /> },
//     { id: 'homepage', label: t('homepageManagement') || 'Homepage', icon: <FaHome /> },  
//     { id: 'activityImages', label: t('activityImages') || 'Women in Action', icon: <FaImages /> },
// Inside menuItems array (desktop)
// { id: 'events', label: t('events'), icon: <FaCalendarAlt />, mobileIcon: <FaCalendarAlt /> },
  ];

  const mobileMenuItems = [
    { id: 'dashboard', label: t('Home'), icon: <FaHome /> },
    { id: 'requests', label: t('Requests'), icon: <FaBriefcase /> },
    { id: 'women', label: t('Women'), icon: <FaVenus /> },
    { id: 'users', label: t('Users'), icon: <FaUsers /> },
    { id: 'gallery', label: t('Gallery'), icon: <FaImages /> },
    { id: 'about', label: t('About'), icon: <FaInfoCircle /> },
    { id: 'reports', label: t('Reports'), icon: <FaChartPie /> },
    { id: 'settings', label: t('Settings'), icon: <FaCog />, mobileIcon: <FaCog /> },
    { id: 'partners', label: t('Partners'), icon: <FaHandshake /> },
    { id: 'homepage', label: t('Homepage') || 'Homepage', icon: <FaHome /> },  
    // { id: 'departments', label: t('Departments') || 'Departments', icon: <FaBuilding /> },
    { id: 'activityImages', label: t('ActivityImages') || 'Women in Action', icon: <FaImages /> },
    { id: 'events', label: t('events'), icon: <FaCalendarAlt /> },
    { id: 'visitors', label: t('Visitors') || 'Visitors', icon: <FaChartBar /> },
  ];

  const filteredUsers = users.filter(user => 
    searchTerm === '' || 
    user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.full_name && user.full_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (user.phone && user.phone.includes(searchTerm))
  );

  // ========== ALL useEffect HOOKS (unchanged order) ==========
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }, []);

  useEffect(() => {
    if (activeMenu === 'events') {
      fetchEvents();
    }
  }, [activeMenu, eventsFilters, eventsPagination.page, fetchEvents]);


  useEffect(() => {
  if (activeMenu === 'visitors') {
    fetchVisitorAnalytics();
  }
}, [activeMenu, visitorChartDays, fetchVisitorAnalytics]);

  useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 600000);
    return () => clearInterval(interval);
  }, [fetchDashboardData]);

  useEffect(() => {
    if (activeMenu === 'women') {
      fetchWomenProfiles();
      fetchDepartments();
    }
  }, [activeMenu, womenFilters, womenPagination.page, womenPagination.limit, fetchWomenProfiles, fetchDepartments]);
  useEffect(() => {
    if (activeMenu === 'requests') { fetchRequestsWithSpecs(); fetchDepartments(); }
  }, [activeMenu, requestFilters, fetchRequestsWithSpecs, fetchDepartments]);

  useEffect(() => {
    if (activeMenu === 'gallery') { fetchGalleryImages(); fetchDepartments(); }
  }, [activeMenu, galleryFilters, galleryPagination.page, fetchGalleryImages, fetchDepartments]);

  useEffect(() => {
    if (activeMenu === 'about') {
      fetchAboutData();
      if (aboutTab === 'why-choose') fetchWhyChooseUsItems();
      else if (aboutTab === 'videos') fetchVideoSections();
    }
  }, [activeMenu, aboutTab, fetchAboutData, fetchWhyChooseUsItems, fetchVideoSections]);

 useEffect(() => {
  if (activeMenu === 'settings') {
    fetchMaintenanceSettings();
    fetchEmailSettings();   // ← ADD THIS
  }
}, [activeMenu, fetchMaintenanceSettings, fetchEmailSettings]);

  useEffect(() => {
    if (activeMenu === 'partners') { fetchPartners(); fetchPartnerTypes(); }
  }, [activeMenu, partnersFilters, partnersPagination.page, fetchPartners, fetchPartnerTypes]);

  // useEffect(() => {
  //   if (activeMenu === 'departments') { fetchDepartmentsFull(); fetchDepartmentStats(); }
  // }, [activeMenu, departmentFilters, fetchDepartmentsFull, fetchDepartmentStats]);

  useEffect(() => {
    if (activeMenu === 'homepage') { fetchHeroSlides(); fetchStatsItems(); }
  }, [activeMenu, fetchHeroSlides, fetchStatsItems]);

  useEffect(() => {
    if (activeMenu === 'activityImages') { fetchActivityImages(); fetchActivityImageStats(); fetchDepartments(); }
  }, [activeMenu, activityImagesFilters, activityImagesPagination.page, fetchActivityImages, fetchActivityImageStats, fetchDepartments]);

  useEffect(() => {
    if (activeMenu === 'dashboard') {
       fetchExpiringContracts(); fetchContractStats();  fetchOngoingCount();
      }
  }, [activeMenu, contractThreshold, fetchExpiringContracts, fetchContractStats, fetchOngoingCount]);

  // ========== LOADING STATE ==========
  if (loading) {
    return (
      <div className="manager-dashboard-loading">
        <div className="manager-loading-spinner"></div>
        <p>{t('loadingDashboard')}</p>
      </div>
    );
  }






  return (
    <div className="manager-dashboard">
      <header className="manager-mobile-header">
        <button 
          className="manager-mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={t('toggleMenu')}
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        <h1 className="manager-mobile-title">
          {menuItems.find(item => item.id === activeMenu)?.label}
        </h1>
        <div className="manager-mobile-actions">
          <button 
            className="manager-btn-notification-mobile"
            onClick={() => setActiveMenu('requests')}
            aria-label={t('notifications')}
          >
            <FaBell />
            {notifications.length > 0 && (
              <span className="manager-notification-count-mobile">{notifications.length}</span>
            )}
          </button>
          <button 
            className="manager-user-avatar-mobile"
            onClick={() => setActiveMenu('settings')}
          >
            {user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'M'}
          </button>
        </div>
      </header>

      <nav className="manager-mobile-nav">
        {mobileMenuItems.map(item => (
          <button
            key={item.id}
            className={`manager-mobile-nav-item ${activeMenu === item.id ? 'active' : ''}`}
            onClick={() => setActiveMenu(item.id)}
          >
            <span className="manager-mobile-nav-icon">{item.icon}</span>
            <span className="manager-mobile-nav-label">{item.label}</span>
          </button>
        ))}
        <button
          className="manager-mobile-nav-item"
          onClick={() => exportData('all')}
          disabled={exporting}
        >
          <span className="manager-mobile-nav-icon manager-export-icon">
            {exporting ? <FaSpinner className="manager-spinning" /> : <FaDownload />}
          </span>
          <span className="manager-mobile-nav-label">{t('export')}</span>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="manager-mobile-menu-overlay">
          <div className="manager-mobile-menu-content">
            <div className="manager-mobile-menu-header">
              <div className="manager-user-info-mobile">
                <div className="manager-user-avatar-mobile">
                  {user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'M'}
                </div>
                <div>
                  <h4>{user?.full_name || user?.username}</h4>
                  <p>{user?.email}</p>
                  <span className="manager-user-role">{t('manager')}</span>
                </div>
              </div>
              <button 
                className="manager-mobile-menu-close"
                onClick={() => setMobileMenuOpen(false)}
              >
                <FaTimes />
              </button>
            </div>
            
            <div className="manager-mobile-menu-items">
              {menuItems.map(item => (
                <button
                  key={item.id}
                  className={`manager-mobile-menu-item ${activeMenu === item.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveMenu(item.id);
                    setMobileMenuOpen(false);
                  }}
                >
                  <span className="manager-mobile-menu-icon">{item.icon}</span>
                  <span>{item.label}</span>
                  <FaChevronRight className="manager-mobile-menu-arrow" />
                </button>
              ))}
              
              <div className="manager-mobile-menu-divider"></div>
              
              <button className="manager-mobile-menu-item" onClick={handleRefresh}>
                <FaSync /> {t('refresh')}
              </button>
              <button className="manager-mobile-menu-item" onClick={onLogout}>
                <FaSignOutAlt /> {t('logout')}
              </button>
            </div>
          </div>
          <div 
            className="manager-mobile-menu-backdrop"
            onClick={() => setMobileMenuOpen(false)}
          />
        </div>
      )}

      <main className="manager-dashboard-main">
        <header className="manager-dashboard-header">
          <div className="manager-header-left">
            <div className="manager-logo">
              <FaBuilding />
              <span>{t('urugoWOC')}</span>
              <span className="manager-role-badge">{t('manager')}</span>
            </div>
            <nav className="manager-desktop-nav">
              {menuItems.map(item => (
                <button
                  key={item.id}
                  className={`manager-desktop-nav-item ${activeMenu === item.id ? 'active' : ''}`}
                  onClick={() => setActiveMenu(item.id)}
                >
                  <span className="manager-desktop-nav-icon">{item.icon}</span>
                  <span className="manager-desktop-nav-label">{item.label}</span>
                </button>
              ))}
            </nav>
          </div>
          <div className="manager-header-right">
            <div className="manager-notification-dropdown">
              <button 
                className="manager-btn-notification"
                aria-label={`${notifications.length} ${t('notifications')}`}
              >
                <FaBell />
                {notifications.length > 0 && (
                  <span className="manager-notification-count">{notifications.length}</span>
                )}
              </button>
              <div className="manager-notification-dropdown-content">
                <h4>{t('notifications')}</h4>
                {notifications.length > 0 ? (
                  notifications.map(notification => (
                    <div 
                      key={notification.id} 
                      className={`manager-notification-item ${notification.type}`}
                      onClick={notification.action}
                    >
                      <div className="manager-notification-icon">
                        {notification.type === 'warning' && <FaClock />}
                        {notification.type === 'user' && <FaUser />}
                      
                        {notification.type === 'success' && <FaCheckCircle />}
                      </div>
                      <div className="manager-notification-content">
                        <p>{notification.message}</p>
                        <span>{notification.time}</span>
                      </div>
                      <FaChevronRight />
                    </div>
                  ))
                ) : (
                  <p className="manager-no-notifications">{t('noNotifications')}</p>
                )}
              </div>
            </div>
            
            <div className="manager-user-profile">
              <div className="manager-user-avatar">
                {user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'M'}
              </div>
              <div className="manager-user-details">
                <h4>{user?.full_name || user?.username}</h4>
                <p>{user?.email}</p>
                <span className="manager-user-role">{t('manager')}</span>
              </div>
              <div className="manager-user-dropdown-menu">
                <button className="manager-btn-refresh-header" onClick={handleRefresh} disabled={refreshing}>
                  {refreshing ? <FaSpinner className="manager-spinning" /> : <FaSync />}
                </button>
                <button className="manager-logout-btn" onClick={onLogout}>
                  <FaSignOutAlt />
                </button>
              </div>
            </div>
          </div>
        </header>

        {error && (
          <div className="manager-message-banner manager-error">
            <FaExclamationTriangle />
            <span>{error}</span>
            <button onClick={() => setError(null)}>×</button>
          </div>
        )}
        
        {successMessage && (
          <div className="manager-message-banner manager-success">
            <FaCheckCircle />
            <span>{successMessage}</span>
            <button onClick={() => setSuccessMessage(null)}>×</button>
          </div>
        )}

        <div className="manager-dashboard-content">
                {/* Dashboard Section */}
          {activeMenu === 'dashboard' && (
            <>
              {/* Employment Status Cards - 6 per row */}
              <div className="manager-employment-stats-grid">
                {[
                  { key: 'unemployed', label: t('unemployed') || 'Unemployed', icon: <FaUserTimes /> },
                  { key: 'studying', label: t('studying') || 'Continuing Studying', icon: <FaGraduationCap /> },
                  { key: 'employed_by_company', label: t('employedByCompany') || 'Employed by Company', icon: <FaBuilding /> },
                  { key: 'self_employed', label: t('selfEmployed') || 'Self Employed', icon: <FaUserTie /> },
                  { key: 'professional_internship', label: t('Professional Internship') || 'Professional Internship', icon: <FaBriefcase /> },
                  { key: 'casual_job', label: t('Casual Job') || 'Casual Job', icon: <FaClock /> }
                ].map((item) => (
                  <div
                    key={item.key}
                    className="manager-quick-stat-item clickable"
                    onClick={() => handleEmploymentCardClick(item.key, item.label)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="manager-quick-stat-icon" style={{ background: 'rgba(99, 103, 52, 0.1)' }}>
                      {item.icon}
                    </div>
                    <div>
                      <h4>{stats.employment_stats?.[item.key] || 0}</h4>
                      <p>{item.label}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="manager-stats-overview">
                <div className="manager-stat-card primary">
                  <div className="manager-stat-icon">
                    <FaUsers />
                  </div>
                  <div className="manager-stat-content">
                    <h3>{stats.total_users || 0}</h3>
                    <p>{t('totalUsers')}</p>
                    <div className="manager-stat-details">
                      <span className="manager-stat-trend positive">
                        +{stats.new_this_month || 0} {t('thisMonth')}
                      </span>
                      <small>{stats.active_today || 0} {t('activeToday')}</small>
                    </div>
                  </div>
                </div>

                <div className="manager-stat-card success">
                  <div className="manager-stat-icon">
                    <FaClipboardList />
                  </div>
                  <div className="manager-stat-content">
                    <h3>{stats.total_requests || 0}</h3>
                    <p>{t('totalRequests')}</p>
                    <div className="manager-stat-details">
                      <span className="manager-stat-trend">
                        {stats.pending_requests || 0} {t('pending')}
                      </span>
                      <small>{stats.employer_count || 0} {t('employers')}</small>
                    </div>
                  </div>
                </div>

                <div
                  className="manager-stat-card warning"
                  onClick={() => {
                    setSelectedOngoingIds([]);
                    setOngoingFilters({ search: '', department_id: 'all', status: 'ongoing' });
                    setOngoingPagination(prev => ({ ...prev, page: 1 }));
                    fetchOngoingTrainees();
                    setActiveMenu('ongoing');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="manager-stat-icon">
                    <FaUserGraduate />
                  </div>
                  <div className="manager-stat-content">
                    <h3>{ongoingCount}</h3>
                    <p>{t('Ongoing Trainings') || 'Ongoing Trainings'}</p>
                    <div className="manager-stat-details">
                      <span className="manager-stat-trend positive">
                        {t('Click to manage') || 'Click to manage'}
                      </span>
                      <small>{t('inTraining') || 'Currently in training'}</small>
                    </div>
                  </div>
                </div>

                <div className="manager-stat-card info">
                  <div className="manager-stat-icon">
                    <FaGraduationCap />
                  </div>
                  <div className="manager-stat-content">
                    <h3>{stats.total_women || 0}</h3>
                    <p>{t('womenTrained')}</p>
                    <div className="manager-stat-details">
                      <span className="manager-stat-trend positive">
                        {stats.active_women || 0} {t('currentlyActive')}
                      </span>
                      <small>85% {t('successRate')}</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="manager-content-section">
                <h2><FaBolt /> {t('quickActions')}</h2>
                <div className="manager-quick-actions">
                  <button
                    className="manager-action-btn primary"
                    onClick={() => setActiveMenu('requests')}
                  >
                    <FaClipboardList />
                    <span>{t('reviewRequests')}</span>
                    <small>{stats.pending_requests || 0} {t('pending')}</small>
                  </button>
                  <button
                    className="manager-action-btn success"
                    onClick={() => exportData('all')}
                    disabled={exporting}
                  >
                    {exporting ? <FaSpinner className="manager-spinning" /> : <FaDownload />}
                    <span>{t('exportAllData')}</span>
                    <small>{t('csvFormat')}</small>
                  </button>
                  <button
                    className="manager-action-btn warning"
                    onClick={() => setActiveMenu('women')}
                  >
                    <FaVenus />
                    <span>{t('manageWomen')}</span>
                    <small>{stats.total_women} {t('profiles')}</small>
                  </button>
                  <button
                    className="manager-action-btn info"
                    onClick={() => setActiveMenu('users')}
                  >
                    <FaUserShield />
                    <span>{t('manageUsers')}</span>
                    <small>{stats.total_users} {t('users')}</small>
                  </button>
                </div>
              </div>

              <div className="manager-dashboard-grid">
                <div className="manager-content-section">
                  <div className="manager-section-header">
                    <h2><FaBell /> {t('notifications')}</h2>
                    <button className="manager-btn-link" onClick={() => setNotifications([])}>
                      {t('clearAll')}
                    </button>
                  </div>
                  <div className="manager-notifications-list">
                    {notifications.length > 0 ? (
                      notifications.map(notification => (
                        <div
                          key={notification.id}
                          className={`manager-notification-item ${notification.type}`}
                          onClick={notification.action}
                        >
                          <div className="manager-notification-icon">
                            {notification.type === 'warning' && <FaClock />}
                            {notification.type === 'user' && <FaUser />}
                            {notification.type === 'success' && <FaCheckCircle />}
                          </div>
                          <div className="manager-notification-content">
                            <p>{notification.message}</p>
                            <span>{notification.time}</span>
                          </div>
                          <FaChevronRight />
                        </div>
                      ))
                    ) : (
                      <div className="manager-no-notifications">
                        <FaCheckCircle />
                        <p>{t('allCaughtUp')}</p>
                        <small>{t('noNewNotifications')}</small>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="manager-content-section">
                <h2><FaChartLine /> {t('quickStatistics')}</h2>
                <div className="manager-quick-stats-grid">
                  <div className="manager-quick-stat">
                    <div className="manager-quick-stat-icon">
                      <FaBuilding />
                    </div>
                    <div className="manager-quick-stat-content">
                      <h4>7</h4>
                      <p>{t('departments')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat">
                    <div className="manager-quick-stat-icon">
                      <FaHandsHelping />
                    </div>
                    <div className="manager-quick-stat-content">
                      <h4>{stats.employer_count || 0}</h4>
                      <p>{t('employers')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat">
                    <div className="manager-quick-stat-icon">
                      <FaChartBar />
                    </div>
                    <div className="manager-quick-stat-content">
                      <h4>85%</h4>
                      <p>{t('successRate')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat">
                    <div className="manager-quick-stat-icon">
                      <FaRegCalendarCheck />
                    </div>
                    <div className="manager-quick-stat-content">
                      <h4>{stats.active_today || 0}</h4>
                      <p>{t('activeToday')}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* =========================================================
                  CONTRACT EXPIRATION SECTION — now INSIDE the dashboard
                  tab only. Will not render on other tabs.
                  ========================================================= */}
              <div className="manager-content-section">
                <div className="manager-section-header">
                  <h2><FaCalendarAlt /> {t('contractExpiration')}</h2>
                  <div className="manager-section-actions">
                    <div className="manager-filter-group">
                      <label>{t('showContractsExpiringIn')}:</label>
                      <select
                        className="manager-filter-select"
                        value={contractThreshold}
                        onChange={(e) => setContractThreshold(Number(e.target.value))}
                        style={{ width: 'auto', marginLeft: '8px' }}
                      >
                        <option value="7">7 {t('days')}</option>
                        <option value="15">15 {t('days')}</option>
                        <option value="30">30 {t('days')}</option>
                        <option value="60">60 {t('days')}</option>
                        <option value="90">90 {t('days')}</option>
                      </select>
                    </div>
                    <button
                      className="manager-btn manager-btn-outline"
                      onClick={() => {
                        fetchExpiringContracts();
                        fetchContractStats();
                      }}
                      disabled={refreshing}
                    >
                      {refreshing ? <FaSpinner className="manager-spinning" /> : <FaSync />}
                      {t('refresh')}
                    </button>
                    <button
                      className="manager-btn manager-btn-primary"
                      onClick={() => setActiveMenu('contracts')}
                    >
                      <FaFileAlt /> {t('manageAllContracts') || 'Manage All Contracts'}
                    </button>
                  </div>
                </div>

                {/* Contract Stats Cards */}
                <div className="manager-quick-stats-bar" style={{ marginBottom: '1.5rem' }}>
                  <div className="manager-quick-stat-item">
                    <div className="manager-quick-stat-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
                      <FaCheckCircle style={{ color: '#4CAF50' }} />
                    </div>
                    <div>
                      <h4>{contractStats.active_contracts || 0}</h4>
                      <p>{t('activeContracts')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat-item">
                    <div className="manager-quick-stat-icon" style={{ background: 'rgba(255, 152, 0, 0.1)' }}>
                      <FaClock style={{ color: '#ff9800' }} />
                    </div>
                    <div>
                      <h4>{contractStats.expiring_this_month || 0}</h4>
                      <p>{t('expiringThisMonth')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat-item">
                    <div className="manager-quick-stat-icon" style={{ background: 'rgba(33, 150, 243, 0.1)' }}>
                      <FaSync style={{ color: '#2196F3' }} />
                    </div>
                    <div>
                      <h4>{contractStats.renewed_this_month || 0}</h4>
                      <p>{t('renewedThisMonth')}</p>
                    </div>
                  </div>
                  <div className="manager-quick-stat-item">
                    <div className="manager-quick-stat-icon" style={{ background: 'rgba(244, 67, 54, 0.1)' }}>
                      <FaExclamationTriangle style={{ color: '#f44336' }} />
                    </div>
                    <div>
                      <h4>{contractStats.expiring_next_month || 0}</h4>
                      <p>{t('expiringNextMonth')}</p>
                    </div>
                  </div>
                </div>

                {expiringContracts.length === 0 ? (
                  <div className="manager-empty-state">
                    <FaCalendarAlt size={48} />
                    <h3>{t('noExpiringContracts')}</h3>
                    <p>{t('noContractsExpiringSoon')}</p>
                  </div>
                ) : (
                  <>
                    <div className="manager-alert manager-alert-warning" style={{ marginBottom: '1rem' }}>
                      <FaExclamationTriangle />
                      <p>
                        <strong>{expiringContracts.length}</strong> {t('contractsExpiringInNext')} {contractThreshold} {t('days')}
                      </p>
                    </div>

                    <div className="manager-table-responsive">
                      <table className="manager-data-table">
                        <thead>
                          <tr>
                            <th>{t('woman')}</th>
                            <th>{t('department')}</th>
                            <th>{t('contractPeriod')}</th>
                            <th>{t('startDate')}</th>
                            <th>{t('endDate')}</th>
                            <th>{t('daysRemaining')}</th>
                            <th>{t('employer')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {expiringContracts.map(contract => (
                            <tr key={contract.id} className={contract.days_remaining <= 7 ? 'manager-row-critical' : 'manager-row-warning'}>
                              <td>
                                <div className="manager-user-cell">
                                  <div className="manager-user-avatar-small">
                                    {contract.woman_name?.charAt(0) || 'W'}
                                  </div>
                                  <div>
                                    <strong>{contract.woman_name}</strong>
                                    <small>{contract.woman_phone || t('noPhone')}</small>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="manager-department-badge">
                                  {contract.department_name || t('general')}
                                </span>
                              </td>
                              <td>{contract.period_name || `${contract.months} months`}</td>
                              <td>{new Date(contract.start_date).toLocaleDateString()}</td>
                              <td>
                                <strong>{new Date(contract.end_date).toLocaleDateString()}</strong>
                              </td>
                              <td>
                                <span className={`manager-status-badge ${
                                  contract.days_remaining <= 7 ? 'manager-status-danger' :
                                  contract.days_remaining <= 30 ? 'manager-status-warning' :
                                  'manager-status-success'
                                }`}>
                                  {contract.days_remaining} {t('days')}
                                </span>
                              </td>
                              <td>
                                <div>
                                  <strong>{contract.employer_name}</strong>
                                  <br />
                                  <small>{contract.employer_email}</small>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="manager-table-summary" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                      <div className="manager-export-dropdown" style={{ position: 'relative' }}>
                        <button
                          className="manager-btn manager-btn-outline"
                          onClick={() => {
                            const dropdown = document.getElementById('export-options');
                            if (dropdown) dropdown.style.display = dropdown.style.display === 'none' ? 'flex' : 'none';
                          }}
                        >
                          <FaDownload /> {t('exportOptions') || 'Export Options'} <FaChevronDown style={{ marginLeft: '5px' }} />
                        </button>
                        <div
                          id="export-options"
                          style={{
                            display: 'none',
                            position: 'absolute',
                            bottom: '100%',
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            zIndex: 5000,
                            flexDirection: 'column',
                            minWidth: '200px',
                            marginBottom: '5px'
                          }}
                        >
                          <button
                            className="manager-dropdown-item"
                            onClick={() => exportContractsAsCSV(expiringContracts, 'expiring')}
                            style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                          >
                            <FaFileAlt /> {t('exportAsCSV') || 'Export as CSV'}
                          </button>
                          <button
                            className="manager-dropdown-item"
                            onClick={() => exportContractsAsCSV(expiringContracts, 'expiring')}
                            style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                          >
                            <FaFileExcel /> {t('exportAsExcel') || 'Export as Excel'}
                          </button>
                          <button
                            className="manager-dropdown-item"
                            onClick={() => exportContractsAsCSV(expiringContracts, 'expiring')}
                            style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer' }}
                          >
                            <FaFilePdf /> {t('exportAsPDF') || 'Export as PDF'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          )}


          {/* ==================== VISITOR ANALYTICS SECTION ==================== */}
{activeMenu === 'visitors' && (
  <div className="manager-content-section">
    <div className="manager-section-header">
      <h2><FaChartArea /> {t('Visitor Analytics') || 'Visitor Analytics'}</h2>
      <div className="manager-section-actions">
        <select
          className="manager-filter-select"
          value={visitorChartDays}
          onChange={(e) => setVisitorChartDays(parseInt(e.target.value, 10))}
        >
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
          <option value={365}>Last 365 days</option>
        </select>
        <button
          className="manager-btn manager-btn-outline"
          onClick={fetchVisitorAnalytics}
          disabled={loadingVisitors}
        >
          {loadingVisitors ? <FaSpinner className="manager-spinning" /> : <FaSync />}
          {t('refresh') || 'Refresh'}
        </button>
      </div>
    </div>

    {/* -------- KPI cards -------- */}
    <div
      className="manager-stats-overview"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', marginBottom: '1.5rem' }}
    >
      <div className="manager-stat-card primary">
        <div className="manager-stat-icon"><FaEyeSolid /></div>
        <div className="manager-stat-content">
          <h3>{visitorsSummary.total_visits || 0}</h3>
          <p>{t('total Page Views') || 'Total Page Views'}</p>
          <div className="manager-stat-details">
            <small>
              {visitorsSummary.total_unique_visitors || 0} {t('unique Visitors') || 'unique visitors'}
            </small>
          </div>
        </div>
      </div>

      <div className="manager-stat-card success">
        <div className="manager-stat-icon"><FaChartLine /></div>
        <div className="manager-stat-content">
          <h3>{visitorsSummary.today_visits || 0}</h3>
          <p>{t('visits Today') || 'Visits Today'}</p>
          <div className="manager-stat-details">
            <small>
              {visitorsSummary.today_unique_visitors || 0} {t('unique Visitors') || 'unique'}
            </small>
          </div>
        </div>
      </div>

      <div className="manager-stat-card info">
        <div className="manager-stat-icon"><FaCalendarAlt /></div>
        <div className="manager-stat-content">
          <h3>{visitorsSummary.month_visits || 0}</h3>
          <p>{t('visits This Month') || 'Visits This Month'}</p>
          <div className="manager-stat-details">
            <small>
              {visitorsSummary.month_unique_visitors || 0} {t('unique Visitors') || 'unique'}
            </small>
          </div>
        </div>
      </div>

      <div className="manager-stat-card warning">
        <div className="manager-stat-icon"><FaCalendar /></div>
        <div className="manager-stat-content">
          <h3>{visitorsSummary.year_visits || 0}</h3>
          <p>{t('visits This Year') || 'Visits This Year'}</p>
          <div className="manager-stat-details">
            <small>
              {visitorsSummary.year_unique_visitors || 0} {t('unique Visitors') || 'unique'}
            </small>
          </div>
        </div>
      </div>
    </div>

    {/* -------- Trend toggle -------- */}
    <div className="manager-filter-section" style={{ marginBottom: '1rem' }}>
      <div className="manager-filter-group">
        <label><FaFilter /> {t('view') || 'View'}:</label>
        <button
          className={`manager-btn ${visitorView === 'daily' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
          onClick={() => setVisitorView('daily')}
        >
          {t('daily') || 'Daily'}
        </button>
        <button
          className={`manager-btn ${visitorView === 'monthly' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
          onClick={() => setVisitorView('monthly')}
          style={{ marginLeft: '8px' }}
        >
          {t('monthly') || 'Monthly'}
        </button>
        <button
          className={`manager-btn ${visitorView === 'yearly' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
          onClick={() => setVisitorView('yearly')}
          style={{ marginLeft: '8px' }}
        >
          {t('yearly') || 'Yearly'}
        </button>
      </div>
    </div>

    {/* -------- Trend table -------- */}
    <div className="manager-content-section" style={{ padding: 0, marginBottom: '1.5rem' }}>
      {loadingVisitors ? (
        <div className="manager-loading-spinner" style={{ margin: '40px auto' }} />
      ) : (
        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                <th>{visitorView === 'daily' ? (t('date') || 'Date') : visitorView === 'monthly' ? (t('month') || 'Month') : (t('year') || 'Year')}</th>
                <th>{t('total Visits') || 'Total Visits'}</th>
                <th>{t('unique Visitors') || 'Unique Visitors'}</th>
                <th>{t('logged In Hits') || 'Logged-in Hits'}</th>
              </tr>
            </thead>
            <tbody>
              {(visitorView === 'daily' ? visitorDaily :
                visitorView === 'monthly' ? visitorMonthly :
                visitorYearly).map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.day || row.month || row.year}</strong></td>
                  <td>{row.total_visits || 0}</td>
                  <td>{row.unique_visitors || 0}</td>
                  <td>{row.logged_in_hits || 0}</td>
                </tr>
              ))}
              {(visitorView === 'daily' ? visitorDaily : visitorView === 'monthly' ? visitorMonthly : visitorYearly).length === 0 && (
                <tr>
                  <td colSpan={4} style={{ textAlign: 'center', color: '#888', padding: '20px' }}>
                    {t('no Data Yet') || 'No visitor data yet'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* -------- Two-column: Top pages + Devices -------- */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem', marginBottom: '1.5rem' }}>
      <div className="manager-content-section" style={{ padding: '1rem' }}>
        <h3 style={{ marginTop: 0 }}><FaEyeSolid /> {t('Top Pages') || 'Top Pages (Last 30 Days)'}</h3>
        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                <th>{t('path') || 'Path'}</th>
                <th>{t('hits') || 'Hits'}</th>
                <th>{t('unique') || 'Unique'}</th>
              </tr>
            </thead>
            <tbody>
              {visitorTopPages.map((p, i) => (
                <tr key={i}>
                  <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.path || '/'}</td>
                  <td>{p.hits || 0}</td>
                  <td>{p.unique_visitors || 0}</td>
                </tr>
              ))}
              {visitorTopPages.length === 0 && (
                <tr><td colSpan={3} style={{ textAlign: 'center', color: '#888' }}>{t('noDataYet') || 'No data yet'}</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="manager-content-section" style={{ padding: '1rem' }}>
        <h3 style={{ marginTop: 0 }}><FaDesktop /> {t('Device Breakdown') || 'Device Breakdown (Last 30 Days)'}</h3>
        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                <th>{t('device') || 'Device'}</th>
                <th>{t('hits') || 'Hits'}</th>
              </tr>
            </thead>
            <tbody>
              {visitorDevices.map((d, i) => (
                <tr key={i}>
                  <td>
                    {d.device === 'mobile' ? <FaMobileAlt /> :
                     d.device === 'tablet' ? <FaTabletAlt /> :
                     <FaDesktop />} {d.device || 'unknown'}
                  </td>
                  <td>{d.hits || 0}</td>
                </tr>
              ))}
              {visitorDevices.length === 0 && (
                <tr><td colSpan={2} style={{ textAlign: 'center', color: '#888' }}>{t('no Data Yet') || 'No data yet'}</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* -------- Recent visits -------- */}
    <div className="manager-content-section" style={{ padding: '1rem' }}>
      <div className="manager-section-header" style={{ marginBottom: '0.75rem' }}>
        <h3 style={{ margin: 0 }}><FaHistory /> {t('Recent Visits') || 'Recent Visits'}</h3>
        <span style={{ fontSize: '0.85rem', color: '#666' }}>
          {visitorRecentPagination.total} {t('total') || 'total'}
        </span>
      </div>

      <div className="manager-table-responsive">
        <table className="manager-data-table">
          <thead>
            <tr>
              <th>{t('time') || 'Time'}</th>
              <th>{t('path') || 'Path'}</th>
              <th>{t('device') || 'Device'}</th>
              <th>{t('browser') || 'Browser'}</th>
              <th>{t('os') || 'OS'}</th>
              <th>{t('visitor') || 'Visitor'}</th>
              <th>{t('user') || 'User'}</th>
            </tr>
          </thead>
          <tbody>
            {visitorRecent.map((v) => (
              <tr key={v.id}>
                <td>{new Date(v.visited_at).toLocaleString()}</td>
                <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.path}</td>
                <td>{v.device_type || '-'}</td>
                <td>{v.browser || '-'}</td>
                <td>{v.os || '-'}</td>
                <td style={{ fontSize: '0.75rem', color: '#666' }}>
                  #{String(v.visitor_id || '').slice(0, 8)}
                  {v.is_bot ? ' (bot)' : ''}
                </td>
                <td>
                  {v.user_id ? (
                    <span className="manager-status-badge manager-status-active">
                      #{v.user_id} {v.user_type}
                    </span>
                  ) : (
                    <span style={{ color: '#999' }}>guest</span>
                  )}
                </td>
              </tr>
            ))}
            {visitorRecent.length === 0 && (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', color: '#888', padding: '20px' }}>
                  {t('noVisitsYet') || 'No visits recorded yet'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {visitorRecentPagination.pages > 1 && (
        <div className="manager-pagination" style={{ marginTop: '1rem' }}>
          <button
            className="manager-pagination-btn"
            disabled={visitorRecentPagination.page <= 1}
            onClick={() => handleVisitorRecentPage(visitorRecentPagination.page - 1)}
          >
            {t('previous') || 'Previous'}
          </button>
          <span>
            {t('pageInfo', {
              page: visitorRecentPagination.page,
              pages: visitorRecentPagination.pages
            })}
          </span>
          <button
            className="manager-pagination-btn"
            disabled={visitorRecentPagination.page >= visitorRecentPagination.pages}
            onClick={() => handleVisitorRecentPage(visitorRecentPagination.page + 1)}
          >
            {t('next') || 'Next'}
          </button>
        </div>
      )}
    </div>
  </div>
)}
          
          {/* Requests Section */}
          {activeMenu === 'requests' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2>{t('requestManagementWithSpecs')}</h2>
                <div className="manager-section-actions">
                  <div className="manager-search-filter">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder={t('searchRequests')}
                      value={requestFilters.search}
                      onChange={(e) => setRequestFilters(prev => ({ ...prev, search: e.target.value }))}
                    />
                  </div>
                  <button 
                    className="manager-btn manager-btn-outline" 
                    onClick={() => setRequestFilters({
                      status: 'all',
                      start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
                      end: new Date().toISOString().split('T')[0],
                      search: ''
                    })}
                  >
                    <FaFilter /> {t('clearFilters')}
                  </button>
                </div>
              </div>
          
              <div className="manager-filter-section">
                <div className="manager-filter-group">
                  <label><FaFilter /> {t('filterBy')}:</label>
                  <select 
                    className="manager-filter-select"
                    value={requestFilters.status}
                    onChange={(e) => setRequestFilters(prev => ({ ...prev, status: e.target.value }))}
                  >
                    <option value="all">{t('allStatus')}</option>
                    <option value="pending">{t('pending')}</option>
                    <option value="approved">{t('approved')}</option>
                    <option value="rejected">{t('rejected')}</option>
                    <option value="completed">{t('completed')}</option>
                    <option value="cancelled">{t('cancelled')}</option>
                  </select>
                  <div className="manager-date-filter">
                    <FaCalendar />
                    <input
                      type="date"
                      value={requestFilters.start}
                      onChange={(e) => setRequestFilters(prev => ({ ...prev, start: e.target.value }))}
                    />
                    <span>{t('to')}</span>
                    <input
                      type="date"
                      value={requestFilters.end}
                      onChange={(e) => setRequestFilters(prev => ({ ...prev, end: e.target.value }))}
                    />
                  </div>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => exportData('requests')}
                    disabled={exporting}
                  >
                    {exporting ? <FaSpinner className="manager-spinning" /> : <FaDownload />}
                    {t('exportRequests')}
                  </button>
                </div>
              </div>
          
              {requestsWithSpecs.length === 0 ? (
                <div className="manager-empty-state">
                  <FaClipboardList size={48} />
                  <h3>{t('noRequestsFound')}</h3>
                  <p>{requestFilters.search || requestFilters.status !== 'all' ? t('noRequestsMatch') : t('noRequestsAvailable')}</p>
                </div>
              ) : (
                <>
                  <div className="manager-table-summary">
                    <p>{t('showingRequests', { count: requestsWithSpecs.length })}</p>
                    <div className="manager-stats-summary">
                      <span className="manager-stat-summary">
                        <FaClock /> {requestsWithSpecs.filter(r => r.status === 'pending').length} {t('pending')}
                      </span>
                      <span className="manager-stat-summary">
                        <FaCheckCircle /> {requestsWithSpecs.filter(r => r.status === 'approved').length} {t('approved')}
                      </span>
                      <span className="manager-stat-summary">
                        <FaSearch /> {requestsWithSpecs.filter(r => 
                          r.age_range || r.experience_level || r.skill_level
                        ).length} {t('withSpecifications')}
                      </span>
                    </div>
                  </div>
                  <div className="manager-table-responsive">
                    <table className="manager-data-table">
                      <thead>
                        <tr>
                          <th>{t('id')}</th>
                          <th>{t('date')}</th>
                          <th>{t('employer')}</th>
                          <th>{t('department')}</th>
                          <th>{t('employees')}</th>
                          <th>{t('specifications')}</th>
                         
                          <th>{t('status')}</th>
                          <th>{t('actions')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {requestsWithSpecs.map(request => (
                          <tr key={request.id}>
                            <td>REQ-{request.id}</td>
                            <td>{request.created_at ? new Date(request.created_at).toLocaleDateString() : t('n/a')}</td>
                            <td>
                              <div className="manager-user-cell">
                                <div className="manager-user-avatar-small">
                                  {request.employer_name?.charAt(0) || 'E'}
                                </div>
                                <div>
                                  <strong>{request.employer_name}</strong>
                                  <small>{request.employer_email}</small>
                                  {request.company_name && <small><FaBuilding /> {request.company_name}</small>}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="manager-department-cell">
                                <span className="manager-department-color" style={{ backgroundColor: request.department_color || '#ccc' }}></span>
                                {request.department_name || t('n/a')}
                              </div>
                            </td>
                         <td>
  <div className="manager-employees-cell">
    <strong
      className={
        Number(request.assigned_women_count || 0) >= Number(request.number_of_employees || 0)
          ? 'manager-count-complete'
          : Number(request.assigned_women_count || 0) > 0
          ? 'manager-count-partial'
          : 'manager-count-pending'
      }
    >
      <FaUserCheck /> {Number(request.assigned_women_count || 0)}/{Number(request.number_of_employees || 0)}
    </strong>
    <small>
      {Number(request.available_women_count || 0)} {t('available')}
    </small>
  </div>
</td>
                          <td>
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
    <RequestSpecificationsBadge 
      request={request} 
      t={t} 
      setSelectedRequestWithSpecs={setSelectedRequestWithSpecs} 
      setShowRequestDetailsModal={setShowRequestDetailsModal} 
    />
  </div>
</td>
                            
                            <td>
                              <span className={`manager-status-badge manager-status-${request.status || 'pending'}`}>
                                {request.status || t('pending')}
                              </span>
                            </td>
                            <td>
                              <div className="manager-action-buttons">
                                <button 
                                  className="manager-btn-icon manager-btn-icon view"
                                  onClick={() => {
                                    setSelectedRequestWithSpecs(request);
                                    setShowRequestDetailsModal(true);
                                  }}
                                  title={t('viewDetails')}
                                >
                                  <FaEye />
                                </button>
                                {request.status === 'pending' && (
                                  <>
                                  
<button 
  className="manager-btn-icon manager-btn-icon approve"
  onClick={() => openApproveRejectModal(request.id, 'approved', request)}
  title={t('approveRequest')}
>
  <FaCheckCircle />
</button>
<button 
  className="manager-btn-icon manager-btn-icon reject"
  onClick={() => openApproveRejectModal(request.id, 'rejected', request)}
  title={t('rejectRequest')}
>
  <FaTimesCircle />
</button>
                                  </>
                                )}
                                {request.status === 'approved' && request.available_women_count > 0 && (
                                  <button 
                                    className="manager-btn-icon manager-btn-icon assign"
                                    onClick={() => {
                                      setSelectedRequestWithSpecs(null);
                                      setActiveMenu('women');
                                    }}
                                    title={t('assignWomen')}
                                  >
                                    <FaUserCheck />
                                  </button>
                                )}
                                <button 
                                  className="manager-btn-icon manager-btn-icon email"
                                  onClick={() => openEmailModal(request)}
                                  title="Send Email"
                                >
                                  <FaEnvelope />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}


          {/* ==================== ONGOING TRAINING SECTION ==================== */}
{activeMenu === 'ongoing' && (
  <div className="manager-content-section">
    <div className="manager-section-header">
      <h2><FaUserGraduate /> {t('ongoingTraining') || 'Ongoing Training Trainees'}</h2>
      <div className="manager-section-actions">
        <div className="manager-search-filter">
          <FaSearch />
          <input
            type="text"
            placeholder={t('searchTrainees') || 'Search by name, phone, email...'}
            value={ongoingFilters.search}
            onChange={(e) => setOngoingFilters(prev => ({ ...prev, search: e.target.value, page: 1 }))}
          />
        </div>
        <select
          className="manager-filter-select"
          value={ongoingFilters.department_id}
          onChange={(e) => setOngoingFilters(prev => ({ ...prev, department_id: e.target.value, page: 1 }))}
        >
          <option value="all">{t('allDepartments') || 'All Departments'}</option>
          {departments.map(d => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
        <select
          className="manager-filter-select"
          value={ongoingFilters.status}
          onChange={(e) => setOngoingFilters(prev => ({ ...prev, status: e.target.value, page: 1 }))}
        >
          <option value="ongoing">{t('ongoing') || 'Ongoing'}</option>
          <option value="completed">{t('completed') || 'Completed'}</option>
          <option value="all">{t('all') || 'All'}</option>
        </select>

        {selectedOngoingIds.length > 0 && ongoingFilters.status === 'ongoing' && (
          <button
            className="manager-btn manager-btn-success"
            onClick={handleBulkComplete}
            disabled={loading}
          >
            <FaCheckCircle /> {t('completeSelected') || 'Complete Selected'} ({selectedOngoingIds.length})
          </button>
        )}

        <button
          className="manager-btn manager-btn-primary"
          onClick={() => {
            setEditingOngoing(null);
            setNewOngoingTrainee({
              name: '', age: '', phone: '', email: '', location: '',
              department_id: '', cohort: '',
              enrollment_date: new Date().toISOString().split('T')[0],
              expected_completion_date: '', notes: ''
            });
            setNameCheckState({ checking: false, exists: false, existing: null });
            setShowOngoingModal(true);
          }}
        >
          <FaUserPlus /> {t('addTrainee') || 'Add Trainee'}
        </button>
      </div>
    </div>

    {ongoingTrainees.length === 0 ? (
      <div className="manager-empty-state">
        <FaUserGraduate size={48} />
        <h3>{t('noOngoingTrainees') || 'No trainees found'}</h3>
        <p>{t('addFirstTrainee') || 'Add trainees to start tracking their training progress'}</p>
      </div>
    ) : (
      <>
        <div className="manager-table-summary">
          <p>{t('showingTrainees', { showing: ongoingTrainees.length, total: ongoingPagination.total }) || `Showing ${ongoingTrainees.length} of ${ongoingPagination.total}`}</p>
          <div className="manager-pagination">
            <button className="manager-pagination-btn"
              disabled={ongoingPagination.page <= 1}
              onClick={() => setOngoingPagination(prev => ({ ...prev, page: prev.page - 1 }))}>
              {t('previous') || 'Previous'}
            </button>
            <span>{t('pageInfo', { page: ongoingPagination.page, pages: ongoingPagination.pages })}</span>
            <button className="manager-pagination-btn"
              disabled={ongoingPagination.page >= ongoingPagination.pages}
              onClick={() => setOngoingPagination(prev => ({ ...prev, page: prev.page + 1 }))}>
              {t('next') || 'Next'}
            </button>
          </div>
        </div>

        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                {ongoingFilters.status === 'ongoing' && (
                  <th>
                    <input
                      type="checkbox"
                      checked={
                        ongoingTrainees.length > 0 &&
                        selectedOngoingIds.length === ongoingTrainees.filter(t => !t.is_completed).length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedOngoingIds(ongoingTrainees.filter(t => !t.is_completed).map(t => t.id));
                        } else {
                          setSelectedOngoingIds([]);
                        }
                      }}
                    />
                  </th>
                )}
                <th>ID</th>
                <th>{t('name') || 'Name'}</th>
                <th>{t('age') || 'Age'}</th>
                <th>{t('phone') || 'Phone'}</th>
                <th>{t('email') || 'Email'}</th>
                <th>{t('location') || 'Location'}</th>
                <th>{t('department') || 'Department'}</th>
                <th>{t('cohort') || 'Cohort'}</th>
                <th>{t('enrollmentDate') || 'Enrolled'}</th>
                <th>{t('status') || 'Status'}</th>
                <th>{t('actions') || 'Actions'}</th>
              </tr>
            </thead>
            <tbody>
              {ongoingTrainees.map(t => (
                <tr key={t.id} className={t.is_completed ? 'manager-row-inactive' : ''}>
                  {ongoingFilters.status === 'ongoing' && (
                    <td>
                      <input
                        type="checkbox"
                        disabled={t.is_completed}
                        checked={selectedOngoingIds.includes(t.id)}
                        onChange={() => {
                          setSelectedOngoingIds(prev =>
                            prev.includes(t.id)
                              ? prev.filter(x => x !== t.id)
                              : [...prev, t.id]
                          );
                        }}
                      />
                    </td>
                  )}
                  <td>OT-{t.id}</td>
                  <td><strong>{t.name}</strong></td>
                  <td>{t.age || '-'}</td>
                  <td>{t.phone || '-'}</td>
                  <td>{t.email || '-'}</td>
                  <td>{t.location || '-'}</td>
                  <td>
                    {t.department_name && (
                      <span className="manager-department-badge">{t.department_name}</span>
                    )}
                  </td>
                  <td>{t.cohort || '-'}</td>
                  <td>{t.enrollment_date ? new Date(t.enrollment_date).toLocaleDateString() : '-'}</td>
                  <td>
                    <span className={`manager-status-badge ${t.is_completed ? 'manager-status-active' : 'manager-status-warning'}`}>
                      {t.is_completed ? (t('completed') || 'Completed') : (t('ongoing') || 'Ongoing')}
                    </span>
                  </td>
                  <td>
                    <div className="manager-action-buttons">
                      <button
                        className="manager-btn-icon manager-btn-icon edit"
                        onClick={() => {
                          setEditingOngoing(t);
                          setNewOngoingTrainee({
                            name: t.name || '',
                            age: t.age || '',
                            phone: t.phone || '',
                            email: t.email || '',
                            location: t.location || '',
                            department_id: t.department_id || '',
                            cohort: t.cohort || '',
                            enrollment_date: t.enrollment_date
                              ? t.enrollment_date.split('T')[0]
                              : '',
                            expected_completion_date: t.expected_completion_date
                              ? t.expected_completion_date.split('T')[0]
                              : '',
                            notes: t.notes || ''
                          });
                          setNameCheckState({ checking: false, exists: false, existing: null });
                          setShowOngoingModal(true);
                        }}
                        title={t('edit')}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="manager-btn-icon manager-btn-icon delete"
                        onClick={() => deleteOngoingTrainee(t.id)}
                        title={t('delete')}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>
)}
          
          {/* Women Section */}
          {activeMenu === 'women' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2>{t('womenProfilesManagement')}</h2>
                <div className="manager-section-actions">
                  <div className="manager-search-filter">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder={t('searchWomen')}
                      value={womenFilters.search}
                      onChange={(e) => setWomenFilters(prev => ({ ...prev, search: e.target.value }))}
                    />
                  </div>
                                   <div className="manager-women-actions">
                    {selectedWomenForAssignment.length > 0 && (
                      <button
                        className="manager-btn manager-btn-primary manager-assign-selected-btn"
                        onClick={handleOpenAssignModal}
                      >
                        <FaUserCheck /> {t('assignSelected')} ({selectedWomenForAssignment.length})
                      </button>
                    )}

                    <button
                      className="manager-btn manager-btn-primary"
                      onClick={openAddTraineeModal}
                    >
                      <FaPlus /> {t('addNewProfile')}
                    </button>

                    <button
                      className="manager-btn manager-btn-outline"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaUpload /> {t('importProfiles')}
                    </button>

                    {/* ✅ Wrapped in a relative container so the dropdown is not clipped */}
                    <div className="manager-dropdown-wrapper">
                      <button
                        className="manager-btn manager-btn-outline"
                        onClick={() => {
                          const dropdown = document.getElementById('women-export-options');
                          if (dropdown) {
                            dropdown.style.display =
                              dropdown.style.display === 'none' ? 'block' : 'none';
                          }
                        }}
                      >
                        <FaDownload /> {t('exportOptions') || 'Export Options'} <FaChevronDown />
                      </button>

                      <div
                        id="women-export-options"
                        className="manager-dropdown-content"
                        style={{
                          display: 'none',
                          position: 'absolute',
                          right: 0,
                          top: 'calc(100% + 6px)',
                          backgroundColor: 'white',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                          zIndex: 5000,
                          minWidth: '240px'
                        }}
                      >
                        <button
                          className="manager-dropdown-item"
                          onClick={() => {
                            document.getElementById('women-export-options').style.display = 'none';
                            exportWomenToExcel();
                          }}
                          style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', width: '100%', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}
                        >
                          <FaFileExcel style={{ color: '#217346' }} /> {t('exportExcel') || 'Export as Excel (.xls)'}
                          <span style={{ fontSize: '10px', color: '#999', marginLeft: 'auto' }}>Spreadsheet</span>
                        </button>
                        <button
                          className="manager-dropdown-item"
                          onClick={() => {
                            document.getElementById('women-export-options').style.display = 'none';
                            exportWomenToPDF();
                          }}
                          style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', width: '100%', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}
                        >
                          <FaFilePdf style={{ color: '#dc3545' }} /> {t('exportPDF') || 'Export as PDF'}
                          <span style={{ fontSize: '10px', color: '#999', marginLeft: 'auto' }}>Printable</span>
                        </button>
                        <button
                          className="manager-dropdown-item"
                          onClick={() => {
                            document.getElementById('women-export-options').style.display = 'none';
                            exportData('women');
                          }}
                          style={{ padding: '10px 15px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', width: '100%', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}
                        >
                          <FaFileAlt style={{ color: '#6c757d' }} /> {t('exportCSV') || 'Export as CSV'}
                          <span style={{ fontSize: '10px', color: '#999', marginLeft: 'auto' }}>Plain Text</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              

           

              <div className="manager-filter-section">
                <div className="manager-filter-group">
                  <label><FaFilter /> {t('filterBy')}:</label>
                  <select 
                    className="manager-filter-select"
                    value={womenFilters.status}
                    onChange={(e) => setWomenFilters(prev => ({ ...prev, status: e.target.value }))}
                  >
                    <option value="all">{t('allStatus')}</option>
                    <option value="available">{t('available')}</option>
                    <option value="hired">{t('hired')}</option>
                  </select>
                  <select 
                    className="manager-filter-select"
                    value={womenFilters.department_id}
                    onChange={(e) => setWomenFilters(prev => ({ ...prev, department_id: e.target.value }))}
                  >
                    <option value="all">{t('allDepartments')}</option>
                    {departments.map(dept => (
                      <option key={dept.id} value={dept.id}>{dept.name}</option>
                    ))}
                  </select>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => setWomenFilters({ status: 'all', department_id: 'all', search: '' })}
                  >
                    <FaFilter /> {t('clearFilters')}
                  </button>
                </div>
              </div>

              {selectedWomenForAssignment.length > 0 && (
                <div className="manager-bulk-selection-header">
                  <div className="manager-bulk-selection-info">
                    <FaUserCheck />
                    <h4>{t('womenSelectedForAssignment', { count: selectedWomenForAssignment.length })}</h4>
                    <span className="manager-bulk-selection-count">
                      {selectedWomenForAssignment.length} {t('selected')}
                    </span>
                  </div>
                  <button 
                    className="manager-btn manager-btn-primary"
                    onClick={handleOpenAssignModal}
                  >
                    <FaUserCheck /> {t('assignSelectedWomen')}
                  </button>
                </div>
              )}

              {womenProfiles.length === 0 ? (
                <div className="manager-empty-state">
                  <FaVenus size={48} />
                  <h3>{t('noWomenProfilesFound')}</h3>
                  <p>{t('noProfilesMatchCriteria')}</p>
                </div>
              ) : (
                <>
                  <div className="manager-table-summary" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
    <p style={{ margin: 0 }}>{t('showingProfiles', { showing: womenProfiles.length, total: womenPagination.total })}</p>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label htmlFor="entries-select" style={{ fontSize: '14px', color: '#555' }}>Show:</label>
      <select
        id="entries-select"
        value={womenPagination.limit}
        onChange={(e) => {
          const val = e.target.value;
          const newLimit = val === 'all' ? 10000 : parseInt(val);
          setWomenPagination(prev => ({ ...prev, limit: newLimit, page: 1 }));
        }}
        style={{
          padding: '6px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px',
          background: 'white',
          cursor: 'pointer'
        }}
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="250">250</option>
        <option value="500">500</option>
        <option value="all">All</option>
      </select>
    </div>
  </div>
  <div className="manager-pagination">
    <button 
      className="manager-pagination-btn"
      disabled={womenPagination.page <= 1}
      onClick={() => setWomenPagination(prev => ({ ...prev, page: prev.page - 1 }))}
    >
      {t('previous')}
    </button>
    <span>{t('pageInfo', { page: womenPagination.page, pages: womenPagination.pages })}</span>
    <button 
      className="manager-pagination-btn"
      disabled={womenPagination.page >= womenPagination.pages}
      onClick={() => setWomenPagination(prev => ({ ...prev, page: prev.page + 1 }))}
    >
      {t('next')}
    </button>
  </div>
</div>
                  <div className="manager-table-responsive">
                    <table className="manager-data-table">
                
<thead>
  <tr>
    <th>
      <input 
        type="checkbox" 
        onChange={(e) => {
          if (e.target.checked) {
            const availableWomenIds = womenProfiles
              .filter(w => w.is_available)
              .map(w => w.id);
            setSelectedWomenForAssignment(availableWomenIds);
          } else {
            setSelectedWomenForAssignment([]);
          }
        }}
        checked={
          selectedWomenForAssignment.length > 0 && 
          selectedWomenForAssignment.length === womenProfiles.filter(w => w.is_available).length
        }
        disabled={womenProfiles.filter(w => w.is_available).length === 0}
        title={t('selectAllAvailable')}
      />
    </th>
    <th>ID</th>
    <th>{t('photo')}</th>
    <th>{t('name')}</th>
    <th>{t('age')}</th>
    <th>Cohort</th>
    <th>{t('department')}</th>
    <th>{t('skills')}</th>
    <th>{t('phone')}</th>
    <th>{t('email')}</th>
    <th>Placement Location</th>
    <th>Employment Status</th>
    <th>Company</th>
    <th>Position</th>
    <th>Income</th>
    <th>{t('status')}</th>
    <th>Active</th>
    <th>{t('actions')}</th>
  </tr>
</thead>


<tbody>
  {womenProfiles.map(profile => (
    <tr key={profile.id} className={!profile.is_active ? "manager-row-inactive" : ""}>
      <td>
        <input 
          type="checkbox"
          checked={selectedWomenForAssignment.includes(profile.id)}
          onChange={() => handleSelectForAssignment(profile.id)}
          disabled={!profile.is_available || !profile.is_active}
          title={!profile.is_active ? t('traineeInactive') : (!profile.is_available ? t('womanNotAvailable') : t('selectForAssignment'))}
        />
      </td>
      <td>W-{profile.id}</td>
      <td>
        <div className="manager-women-photo">
          {profile.profile_photo || profile.photo_url ? (
            <img 
              src={`${API_BASE_URL}${profile.profile_photo || profile.photo_url}`} 
              alt={profile.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/40';
              }}
            />
          ) : (
            <div className="manager-avatar-small">
              {profile.name?.charAt(0) || 'W'}
            </div>
          )}
        </div>
      </td>
      <td>
        <strong>{profile.name}</strong>
        {profile.email && <small>{profile.email}</small>}
      </td>
      <td>{profile.age || t('n/a')}</td>
      <td>{profile.cohort || '-'}</td>
      <td>{profile.department_name || t('n/a')}</td>
      <td>
        <div className="manager-skills-cell">
          {profile.competence_skills || profile.skills || t('n/a')}
        </div>
      </td>
      <td>{profile.phone || t('n/a')}</td>
      <td>{profile.email || t('n/a')}</td>
      <td>{profile.placement_location || '-'}</td>
      <td>
        <span className="manager-status-badge">
          {profile.employment_status ? t(profile.employment_status) || profile.employment_status : '-'}
        </span>
      </td>
      <td>{profile.company_name || '-'}</td>
      <td>{profile.working_position || '-'}</td>
      <td>{profile.monthly_income || '-'}</td>
      <td>
        <span className={`manager-status-badge ${profile.is_available ? 'manager-status-available' : 'manager-status-hired'}`}>
          {profile.is_available ? t('available') : t('hired')}
        </span>
      </td>
      <td>
        <button 
          className={`manager-btn-icon ${profile.is_active ? 'manager-btn-icon-success' : 'manager-btn-icon-danger'}`}
          onClick={() => toggleTraineeStatus(profile.id)}
          title={profile.is_active ? t('deactivate') : t('activate')}
        >
          {profile.is_active ? <FaToggleOn /> : <FaToggleOff />}
        </button>
      </td>
      <td>
        <div className="manager-action-buttons">
        <button 
  className="manager-btn-icon manager-btn-icon view"
  onClick={() => openEditTraineeModal(profile)}
  title={t('editProfile')}
>
  <FaEdit />
</button>
          <button 
            className="manager-btn-icon manager-btn-icon toggle"
            onClick={() => toggleAvailability(profile.id, !profile.is_available)}
            title={profile.is_available ? t('markAsHired') : t('markAsAvailable')}
            disabled={!profile.is_active}
          >
            {profile.is_available ? <FaUserCheck /> : <FaUserTimes />}
          </button>
          <button 
            className="manager-btn-icon manager-btn-icon delete"
            onClick={() => deleteProfile(profile.id)}
            title={t('deleteProfile')}
          >
            <FaTrash />
          </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}

          {/* Users Section */}
          {activeMenu === 'users' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2>{t('userManagement')}</h2>
                <div className="manager-section-actions">
                  <div className="manager-search-filter">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder={t('searchUsers')}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <button 
                    className="manager-btn manager-btn-outline" 
                    onClick={resetFilters}
                  >
                    <FaFilter /> {t('clearFilters')}
                  </button>
                </div>
              </div>

              <div className="manager-filter-section">
                <div className="manager-filter-group">
                  <label><FaFilter /> {t('filterBy')}:</label>
                  <select 
                    className="manager-filter-select"
                    value={filters.user_type}
                    onChange={(e) => handleFilterChange('user_type', e.target.value)}
                  >
                    <option value="all">{t('allTypes')}</option>
                    <option value="admin">{t('admin')}</option>
                    <option value="manager">{t('manager')}</option>
                    <option value="employer">{t('employer')}</option>
                  </select>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => exportData('users')}
                    disabled={exporting}
                  >
                    {exporting ? <FaSpinner className="manager-spinning" /> : <FaDownload />}
                    {t('exportUsers')}
                  </button>
                </div>
              </div>

              {filteredUsers.length === 0 ? (
                <div className="manager-empty-state">
                  <FaUsers size={48} />
                  <h3>{t('noUsersFound')}</h3>
                  <p>{searchTerm || filters.user_type !== 'all' ? t('noUsersMatchCriteria') : t('noUsersAvailable')}</p>
                </div>
              ) : (
                <>
                  <div className="manager-table-summary">
                    <p>{t('showingUsers', { count: filteredUsers.length })}</p>
                  </div>
                  <div className="manager-table-responsive">
                    <table className="manager-data-table">
                      <thead>
                        <tr>
                          <th>{t('id')}</th>
                          <th>{t('user')}</th>
                          <th>{t('fullName')}</th>
                          <th>{t('email')}</th>
                          <th>{t('phone')}</th>
                          <th>{t('type')}</th>
                          <th>{t('status')}</th>
                          <th>{t('joined')}</th>
                          <th>{t('actions')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredUsers.map(user => (
                          <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>
                              <div className="manager-user-cell">
                                <div className="manager-user-avatar-small">
                                  {user.username.charAt(0).toUpperCase()}
                                </div>
                                {user.username}
                              </div>
                            </td>
                            <td>{user.full_name || t('n/a')}</td>
                            <td>{user.email}</td>
                            <td>{user.phone || t('n/a')}</td>
                            <td>
                              <span className={`manager-user-type-badge manager-type-${user.user_type}`}>
                                {user.user_type}
                              </span>
                            </td>
                            <td>
                              <span className={`manager-status-badge manager-status-${user.status || 'active'}`}>
                                {user.status || t('active')}
                              </span>
                            </td>
                            <td>{new Date(user.created_at).toLocaleDateString()}</td>
                            <td>
                              <div className="manager-action-buttons">
                                {user.status === 'active' ? (
                                  <button 
                                    className="manager-btn-icon manager-btn-icon disable"
                                    onClick={() => updateUserStatus(user.id, 'suspended')}
                                    title={t('suspendUser')}
                                  >
                                    <FaLock />
                                  </button>
                                ) : (
                                  <button 
                                    className="manager-btn-icon manager-btn-icon enable"
                                    onClick={() => updateUserStatus(user.id, 'active')}
                                    title={t('activateUser')}
                                  >
                                    <FaUnlock />
                                  </button>
                                )}
                                {user.user_type !== 'admin' && (
                                  <button 
                                    className="manager-btn-icon manager-btn-icon delete"
                                    onClick={() => deleteUser(user.id)}
                                    title={t('deleteUser')}
                                  >
                                    <FaTrash />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}

          {/* Gallery Section */}
          {activeMenu === 'gallery' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2>{t('galleryManagement')}</h2>
                <div className="manager-section-actions">
                  <div className="manager-search-filter">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder={t('searchGallery')}
                      value={galleryFilters.search}
                      onChange={(e) => setGalleryFilters(prev => ({ ...prev, search: e.target.value }))}
                    />
                  </div>
                  <button 
                    className="manager-btn manager-btn-primary" 
                    onClick={() => {
                      setCurrentGalleryImage(null);
                      setShowGalleryModal(true);
                    }}
                  >
                    <FaPlus /> {t('addImage')}
                  </button>
                </div>
              </div>

              <div className="manager-filter-section">
                <div className="manager-filter-group">
                  <label><FaFilter /> {t('filterBy')}:</label>
                  <select 
                    className="manager-filter-select"
                    value={galleryFilters.department_id}
                    onChange={(e) => setGalleryFilters(prev => ({ ...prev, department_id: e.target.value }))}
                  >
                    <option value="all">{t('allDepartments')}</option>
                    {departments.map(dept => (
                      <option key={dept.id} value={dept.id}>{dept.name}</option>
                    ))}
                  </select>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => setGalleryFilters({ department_id: 'all', search: '' })}
                  >
                    <FaFilter /> {t('clearFilters')}
                  </button>
                </div>
              </div>

              {galleryImages.length === 0 ? (
                <div className="manager-empty-state">
                  <FaImages size={48} />
                  <h3>{t('noGalleryImagesFound')}</h3>
                  <p>{t('noImagesMatchCriteria')}</p>
                </div>
              ) : (
                <>
                  <div className="manager-table-summary">
                    <p>{t('showingImages', { showing: galleryImages.length, total: galleryPagination.total })}</p>
                    <div className="manager-pagination">
                      <button 
                        className="manager-pagination-btn"
                        disabled={galleryPagination.page <= 1}
                        onClick={() => setGalleryPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                      >
                        {t('previous')}
                      </button>
                      <span>{t('pageInfo', { page: galleryPagination.page, pages: galleryPagination.pages })}</span>
                      <button 
                        className="manager-pagination-btn"
                        disabled={galleryPagination.page >= galleryPagination.pages}
                        onClick={() => setGalleryPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                      >
                        {t('next')}
                      </button>
                    </div>
                  </div>
                  
                  <div className="manager-gallery-grid">
                    {galleryImages.map(image => (
                      <div key={image.id} className="manager-gallery-card">
                        <div className="manager-gallery-image">
                          <img 
                            src={`${API_BASE_URL}${image.image_url}`} 
                            alt={image.title}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://via.placeholder.com/300x200';
                            }}
                          />
                          {image.is_featured && (
                            <span className="manager-featured-badge">{t('featured')}</span>
                          )}
                        </div>
                        <div className="manager-gallery-content">
                          <h4>{image.title}</h4>
                          <p className="manager-gallery-description">
                            {image.description?.length > 100 
                              ? `${image.description.substring(0, 100)}...` 
                              : image.description}
                          </p>
                          <div className="manager-gallery-meta">
                            <span className="manager-department-badge">
                              {image.department_name || t('general')}
                            </span>
                            <span className="manager-date">
                              {new Date(image.uploaded_at).toLocaleDateString()}
                            </span>
                          </div>
                          <div className="manager-gallery-actions">
                            <button 
                              className="manager-btn-icon manager-btn-icon edit"
                              onClick={() => {
                                setCurrentGalleryImage(image);
                                setShowGalleryModal(true);
                              }}
                              title={t('edit')}
                            >
                              <FaEdit />
                            </button>
                            <button 
                              className="manager-btn-icon manager-btn-icon delete"
                              onClick={() => deleteGalleryImage(image.id)}
                              title={t('delete')}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          {/* About Section */}
          {activeMenu === 'about' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2>{t('aboutUsManagement')}</h2>
                <div className="manager-section-actions">
                  <div className="manager-about-tabs">
                    <button 
                      className={`manager-btn ${aboutTab === 'page' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
                      onClick={() => setAboutTab('page')}
                    >
                      {t('pageContent')}
                    </button>
                    <button 
                      className={`manager-btn ${aboutTab === 'values' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
                      onClick={() => setAboutTab('values')}
                    >
                      {t('coreValues')}
                    </button>
                    <button 
                      className={`manager-btn ${aboutTab === 'team' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
                      onClick={() => setAboutTab('team')}
                    >
                      {t('teamMembers')}
                    </button>
                    <button 
                      className={`manager-btn ${aboutTab === 'why-choose' ? 'manager-btn-primary' : 'manager-btn-outline'}`}
                      onClick={() => {
                        setAboutTab('why-choose');
                        fetchWhyChooseUsItems();
                      }}
                    >
                      <FaStar /> {t('whyChooseUs') || 'Why Choose Us'}
                    </button>
                  </div>
                </div>
              </div>

              {aboutTab === 'page' && (
                <div className="manager-about-content">
                  <div className="manager-card">
                    <div className="manager-card-header">
                      <h3><FaFileAlt /> {t('aboutPageContent')}</h3>
                      <button 
                        className="manager-btn manager-btn-primary"
                        onClick={() => setShowAboutModal(true)}
                      >
                        <FaEdit /> {t('editContent')}
                      </button>
                    </div>
                    <div className="manager-card-body">
                      {aboutData.title ? (
                        <div className="manager-page-preview">
                          <h4>{aboutData.title}</h4>
                          <div className="manager-section">
                            <h5>{t('mission')}</h5>
                            <p>{aboutData.mission || t('noMissionStatement')}</p>
                          </div>
                          <div className="manager-section">
                            <h5>{t('vision')}</h5>
                            <p>{aboutData.vision || t('noVisionStatement')}</p>
                          </div>
                          <div className="manager-section">
                            <h5>{t('history')}</h5>
                            <p>{aboutData.history || t('noHistoryContent')}</p>
                          </div>
                        </div>
                      ) : (
                        <div className="manager-empty-state">
                          <FaFileAlt size={48} />
                          <h3>{t('noAboutPageContent')}</h3>
                          <p>{t('clickEditContentToAdd')}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {aboutTab === 'values' && (
                <div className="manager-about-content">
                  <div className="manager-card">
                    <div className="manager-card-header">
                      <h3><FaStar /> {t('coreValues')}</h3>
                      <button 
                        className="manager-btn manager-btn-primary"
                        onClick={() => {
                          setCurrentCoreValue(null);
                          setShowCoreValueModal(true);
                        }}
                      >
                        <FaPlus /> {t('addValue')}
                      </button>
                    </div>
                    <div className="manager-card-body">
                      {coreValues.length === 0 ? (
                        <div className="manager-empty-state">
                          <FaStar size={48} />
                          <h3>{t('noCoreValues')}</h3>
                          <p>{t('addCoreValues')}</p>
                        </div>
                      ) : (
                        <div className="manager-values-grid">
                          {coreValues.map((value, index) => (
                            <div key={value.id || index} className="manager-value-card">
                              <div className="manager-value-header">
                                <span className="manager-value-number">{index + 1}</span>
                                <div className="manager-value-actions">
                                  <button 
                                    className="manager-btn-icon"
                                    onClick={() => {
                                      setCurrentCoreValue(value);
                                      setShowCoreValueModal(true);
                                    }}
                                    title={t('edit')}
                                  >
                                    <FaEdit />
                                  </button>
                                  <button 
                                    className="manager-btn-icon manager-btn-icon-delete"
                                    onClick={() => deleteCoreValue(value.id)}
                                    title={t('delete')}
                                  >
                                    <FaTrash />
                                  </button>
                                </div>
                              </div>
                              <div className="manager-value-content">
                                <p>{value.value_text}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {aboutTab === 'team' && (
                <div className="manager-about-content">
                  <div className="manager-card">
                    <div className="manager-card-header">
                      <h3><FaUsers /> {t('teamMembers')}</h3>
                      <button 
                        className="manager-btn manager-btn-primary"
                        onClick={() => {
                          setCurrentTeamMember(null);
                          setShowTeamMemberModal(true);
                        }}
                      >
                        <FaPlus /> {t('addTeamMember')}
                      </button>
                    </div>
                    <div className="manager-card-body">
                      {teamMembers.length === 0 ? (
                        <div className="manager-empty-state">
                          <FaUsers size={48} />
                          <h3>{t('noTeamMembers')}</h3>
                          <p>{t('addTeamMembers')}</p>
                        </div>
                      ) : (
                        <div className="manager-team-grid">
                          {teamMembers.map(member => (
                            <div key={member.id} className="manager-team-card">
                              {/* <div className="manager-team-photo">
                                {member.photo_url ? (
                                  <img 
                                    src={`${API_BASE_URL}${member.photo_url}`} 
                                    alt={member.full_name}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = 'https://via.placeholder.com/150';
                                    }}
                                  />
                                ) : (
                                  <div className="manager-team-default-photo">
                                    <FaUser size={40} />
                                  </div>
                                )}
                              </div> */}
                              <div className="manager-team-info">
                                <h4>{member.full_name}</h4>
                                <p className="manager-team-position">{member.position}</p>
                                <p className="manager-team-department">{member.department}</p>
                                <div className="manager-team-status">
                                  <span className={`manager-status-badge ${member.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
                                    {member.is_active ? t('active') : t('inactive')}
                                  </span>
                                </div>
                                <div className="manager-team-actions">
                                  <button 
                                    className="manager-btn-icon"
                                    onClick={() => {
                                      setCurrentTeamMember(member);
                                      setShowTeamMemberModal(true);
                                    }}
                                    title={t('edit')}
                                  >
                                    <FaEdit />
                                  </button>
                                  <button 
                                    className="manager-btn-icon manager-btn-icon-delete"
                                    onClick={() => deleteTeamMember(member.id)}
                                    title={t('delete')}
                                  >
                                    <FaTrash />
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Why Choose Us Tab */}
              {aboutTab === 'why-choose' && (
                <div className="manager-about-content">
                  <div className="manager-card">
                    <div className="manager-card-header">
                      <h3><FaStar /> {t('whyChooseUsItems') || 'Why Choose Us Items'}</h3>
                      <button 
                        className="manager-btn manager-btn-primary"
                        onClick={() => {
                          setCurrentWhyChooseUs(null);
                          setNewWhyChooseUs({
                            title: '',
                            description: '',
                            icon_name: 'FaHeart',
                            icon_type: 'fa',
                            sort_order: 0,
                            is_active: true
                          });
                          setShowWhyChooseUsModal(true);
                        }}
                      >
                        <FaPlus /> {t('addItem') || 'Add Item'}
                      </button>
                    </div>
                    <div className="manager-card-body">
                      {whyChooseUsItems.length === 0 ? (
                        <div className="manager-empty-state">
                          <FaStar size={48} />
                          <h3>{t('noWhyChooseUsItems') || 'No Why Choose Us items'}</h3>
                          <p>{t('addWhyChooseUsItems') || 'Add items to display on the homepage'}</p>
                        </div>
                      ) : (
                        <div className="manager-table-responsive">
                          <table className="manager-data-table">
                            <thead>
                              <tr>
                                <th>{t('icon') || 'Icon'}</th>
                                <th>{t('title') || 'Title'}</th>
                                <th>{t('description') || 'Description'}</th>
                                <th>{t('sortOrder') || 'Sort Order'}</th>
                                <th>{t('status') || 'Status'}</th>
                                <th>{t('actions') || 'Actions'}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {whyChooseUsItems.map(item => (
                                <tr key={item.id}>
                                  <td>
                                    <div className="manager-icon-preview">
                                      {item.icon_name === 'FaHeart' && <FaHeart />}
                                      {item.icon_name === 'FaChalkboardTeacher' && <FaChalkboardTeacher />}
                                      {item.icon_name === 'FaTools' && <FaTools />}
                                      {item.icon_name === 'FaHandshake' && <FaHandshake />}
                                      {item.icon_name === 'FaClock' && <FaClock />}
                                      {item.icon_name === 'FaCertificate' && <FaCertificate />}
                                      {item.icon_name === 'FaUsers' && <FaUsers />}
                                      {!['FaHeart','FaChalkboardTeacher','FaTools','FaHandshake','FaClock','FaCertificate','FaUsers'].includes(item.icon_name) && <FaHeart />}
                                    </div>
                                  </td>
                                  <td><strong>{item.title}</strong></td>
                                  <td className="manager-description-cell">
                                    {item.description.length > 60 
                                      ? `${item.description.substring(0, 60)}...` 
                                      : item.description}
                                   </td>
                                  <td>{item.sort_order || 0}</td>
                                  <td>
                                    <span className={`manager-status-badge ${item.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
                                      {item.is_active ? t('active') : t('inactive')}
                                    </span>
                                   </td>
                                  <td>
                                    <div className="manager-action-buttons">
                                      <button 
                                        className="manager-btn-icon manager-btn-icon edit"
                                        onClick={() => {
                                          setCurrentWhyChooseUs(item);
                                          setShowWhyChooseUsModal(true);
                                        }}
                                        title={t('edit')}
                                      >
                                        <FaEdit />
                                      </button>
                                      <button 
                                        className={`manager-btn-icon ${item.is_active ? 'manager-btn-icon-disable' : 'manager-btn-icon-enable'}`}
                                        onClick={() => toggleWhyChooseUsStatus(item.id)}
                                        title={item.is_active ? t('deactivate') : t('activate')}
                                      >
                                        {item.is_active ? <FaToggleOn /> : <FaToggleOff />}
                                      </button>
                                      <button 
                                        className="manager-btn-icon manager-btn-icon delete"
                                        onClick={() => deleteWhyChooseUsItem(item.id)}
                                        title={t('delete')}
                                      >
                                        <FaTrash />
                                      </button>
                                    </div>
                                   </td>
                                 </tr>
                              ))}
                            </tbody>
                           </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Events Management Section */}
{activeMenu === 'events' && (
  <div className="manager-content-section">
    <div className="manager-section-header">
      <h2><FaCalendarAlt /> {t('eventsManagement') || 'Events Management'}</h2>
      <div className="manager-section-actions">
        <div className="manager-search-filter">
          <FaSearch />
          <input
            type="text"
            placeholder={t('searchEvents') || 'Search events...'}
            value={eventsFilters.search}
            onChange={(e) => setEventsFilters(prev => ({ ...prev, search: e.target.value, page: 1 }))}
          />
        </div>
        <select
          className="manager-filter-select"
          value={eventsFilters.type}
          onChange={(e) => setEventsFilters(prev => ({ ...prev, type: e.target.value, page: 1 }))}
          style={{ marginLeft: '10px' }}
        >
          <option value="all">{t('allEvents') || 'All Events'}</option>
          <option value="latest">{t('latestUpdates') || 'Latest Updates'}</option>
          <option value="upcoming">{t('upcomingEvents') || 'Upcoming Events'}</option>
        </select>
        <button
          className="manager-btn manager-btn-primary"
          onClick={() => {
            setCurrentEvent(null);
            setEventImage(null);
            setNewEvent({ title: '', description: '', event_date: '', location: '', organizer: '', is_active: true, image: null });
            setShowEventModal(true);
          }}
        >
          <FaPlus /> {t('addEvent') || 'Add Event'}
        </button>
      </div>
    </div>

    {events.length === 0 ? (
      <div className="manager-empty-state">
        <FaCalendarAlt size={48} />
        <h3>{t('noEventsFound') || 'No events found'}</h3>
        <p>{t('noEventsMatchCriteria') || 'No events match your filter criteria'}</p>
      </div>
    ) : (
      <>
        <div className="manager-table-summary">
          <p>{t('showingEvents', { showing: events.length, total: eventsPagination.total }) || `Showing ${events.length} of ${eventsPagination.total} events`}</p>
          <div className="manager-pagination">
            <button
              className="manager-pagination-btn"
              disabled={eventsPagination.page <= 1}
              onClick={() => setEventsPagination(prev => ({ ...prev, page: prev.page - 1 }))}
            >
              {t('previous')}
            </button>
            <span>{t('pageInfo', { page: eventsPagination.page, pages: eventsPagination.pages })}</span>
            <button
              className="manager-pagination-btn"
              disabled={eventsPagination.page >= eventsPagination.pages}
              onClick={() => setEventsPagination(prev => ({ ...prev, page: prev.page + 1 }))}
            >
              {t('next')}
            </button>
          </div>
        </div>

        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                <th>{t('image') || 'Image'}</th>
                <th>{t('title') || 'Title'}</th>
                <th>{t('description') || 'Description'}</th>
                <th>{t('eventDate') || 'Event Date'}</th>
                <th>{t('location') || 'Location'}</th>
                <th>{t('organizer') || 'Organizer'}</th>
                <th>{t('status') || 'Status'}</th>
                <th>{t('actions') || 'Actions'}</th>
              </tr>
            </thead>
            <tbody>
              {events.map(event => (
                <tr key={event.id}>
                  <td>
                    <div className="manager-event-image">
                      {event.image_url ? (
                        <img
                          src={`${API_BASE_URL}${event.image_url}`}
                          alt={event.title}
                          style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
                          onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/50'; }}
                        />
                      ) : (
                        <div className="manager-avatar-small"><FaCalendarAlt /></div>
                      )}
                    </div>
                  </td>
                  <td><strong>{event.title}</strong></td>
                  <td className="manager-description-cell">
                    {event.description.length > 60 ? `${event.description.substring(0, 60)}...` : event.description}
                  </td>
                  <td>{event.event_date ? new Date(event.event_date).toLocaleDateString() : '-'}</td>
                  <td>{event.location || '-'}</td>
                  <td>{event.organizer || '-'}</td>
                  <td>
                    <span className={`manager-status-badge ${event.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
                      {event.is_active ? t('active') : t('inactive')}
                    </span>
                  </td>
                  <td>
                    <div className="manager-action-buttons">
                      <button
                        className="manager-btn-icon manager-btn-icon edit"
                        onClick={() => {
                          setCurrentEvent(event);
                          setEventImage(null);
                          setShowEventModal(true);
                        }}
                        title={t('edit')}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className={`manager-btn-icon ${event.is_active ? 'manager-btn-icon-disable' : 'manager-btn-icon-enable'}`}
                        onClick={() => toggleEventStatus(event.id)}
                        title={event.is_active ? t('deactivate') : t('activate')}
                      >
                        {event.is_active ? <FaToggleOn /> : <FaToggleOff />}
                      </button>
                      <button
                        className="manager-btn-icon manager-btn-icon delete"
                        onClick={() => deleteEvent(event.id)}
                        title={t('delete')}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>
)}

        

          {/* Partners Section */}
          {activeMenu === 'partners' && (
            <div className="manager-content-section">
              <div className="manager-section-header">
                <h2><FaHandshake /> {t('partnersManagement') || 'Partners & Sponsors'}</h2>
                <div className="manager-section-actions">
                  <div className="manager-search-filter">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder={t('searchPartners') || 'Search partners...'}
                      value={partnersFilters.search}
                      onChange={(e) => setPartnersFilters(prev => ({ ...prev, search: e.target.value, page: 1 }))}
                    />
                  </div>
                  <button 
                    className="manager-btn manager-btn-primary" 
                    onClick={() => {
                      setCurrentPartner(null);
                      setPartnerLogo(null);
                      setNewPartner({
                        partner_name: '',
                        partner_type: '',
                        website_url: '',
                        description: '',
                        sort_order: 0,
                        is_active: true,
                        logo: null
                      });
                      setShowPartnerModal(true);
                    }}
                  >
                    <FaPlus /> {t('addPartner') || 'Add Partner'}
                  </button>
                </div>
              </div>

              <div className="manager-filter-section">
                <div className="manager-filter-group">
                  <label><FaFilter /> {t('filterBy')}:</label>
                  <select 
                    className="manager-filter-select"
                    value={partnersFilters.partner_type}
                    onChange={(e) => setPartnersFilters(prev => ({ ...prev, partner_type: e.target.value, page: 1 }))}
                  >
                    <option value="all">{t('allTypes') || 'All Types'}</option>
                    {partnerTypes.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                  <select 
                    className="manager-filter-select"
                    value={partnersFilters.active}
                    onChange={(e) => setPartnersFilters(prev => ({ ...prev, active: e.target.value, page: 1 }))}
                  >
                    <option value="all">{t('allStatus') || 'All Status'}</option>
                    <option value="active">{t('active')}</option>
                    <option value="inactive">{t('inactive')}</option>
                  </select>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => setPartnersFilters({ search: '', partner_type: 'all', active: 'all' })}
                  >
                    <FaFilter /> {t('clearFilters')}
                  </button>
                  <button 
                    className="manager-btn manager-btn-outline"
                    onClick={() => {
                      const csvData = partners.map(p => ({
                        Name: p.partner_name,
                        Type: p.partner_type,
                        Website: p.website_url,
                        Description: p.description,
                        Status: p.is_active ? 'Active' : 'Inactive'
                      }));
                    }}
                  >
                    <FaDownload /> {t('export')}
                  </button>
                </div>
              </div>

              {partners.length === 0 ? (
                <div className="manager-empty-state">
                  <FaHandshake size={48} />
                  <h3>{t('noPartnersFound') || 'No partners found'}</h3>
                  <p>{t('noPartnersMatchCriteria') || 'No partners match your filter criteria'}</p>
                </div>
              ) : (
                <>
                  <div className="manager-table-summary">
                    <p>{t('showingPartners', { showing: partners.length, total: partnersPagination.total }) || `Showing ${partners.length} of ${partnersPagination.total} partners`}</p>
                    <div className="manager-pagination">
                      <button 
                        className="manager-pagination-btn"
                        disabled={partnersPagination.page <= 1}
                        onClick={() => setPartnersPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                      >
                        {t('previous')}
                      </button>
                      <span>{t('pageInfo', { page: partnersPagination.page, pages: partnersPagination.pages })}</span>
                      <button 
                        className="manager-pagination-btn"
                        disabled={partnersPagination.page >= partnersPagination.pages}
                        onClick={() => setPartnersPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                      >
                        {t('next')}
                      </button>
                    </div>
                  </div>
                  
                  <div className="manager-table-responsive">
                    <table className="manager-data-table">
                      <thead>
                        <tr>
                          <th>{t('logo') || 'Logo'}</th>
                          <th>{t('partnerName') || 'Partner Name'}</th>
                          <th>{t('type') || 'Type'}</th>
                          <th>{t('description') || 'Description'}</th>
                          <th>{t('website') || 'Website'}</th>
                          <th>{t('sortOrder') || 'Sort Order'}</th>
                          <th>{t('status') || 'Status'}</th>
                          <th>{t('actions') || 'Actions'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partners.map(partner => (
                          <tr key={partner.id}>
                            <td>
                              <div className="manager-partner-logo">
                                {partner.logo_url ? (
                                  <img 
                                    src={`${API_BASE_URL}${partner.logo_url}`} 
                                    alt={partner.partner_name}
                                    style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = 'https://via.placeholder.com/50';
                                    }}
                                  />
                                ) : (
                                  <div className="manager-avatar-small" style={{ width: '50px', height: '50px' }}>
                                    <FaBuilding />
                                  </div>
                                )}
                              </div>
                            </td>
                            <td><strong>{partner.partner_name}</strong></td>
                            <td><span className="manager-partner-type-badge">{partner.partner_type}</span></td>
                            <td className="manager-description-cell">
                              {partner.description ? (
                                partner.description.length > 60 
                                  ? `${partner.description.substring(0, 60)}...` 
                                  : partner.description
                              ) : t('noDescription') || 'No description'}
                            </td>
                            <td>
                              {partner.website_url ? (
                                <a href={partner.website_url} target="_blank" rel="noopener noreferrer" className="manager-link">
                                  <FaGlobe /> {t('visit') || 'Visit'}
                                </a>
                              ) : t('n/a')}
                            </td>
                            <td>{partner.sort_order || 0}</td>
                            <td>
                              <span className={`manager-status-badge ${partner.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
                                {partner.is_active ? t('active') : t('inactive')}
                              </span>
                            </td>
                            <td>
                              <div className="manager-action-buttons">
                                <button 
                                  className="manager-btn-icon manager-btn-icon edit"
                                  onClick={() => {
                                    setCurrentPartner(partner);
                                    setPartnerLogo(null);
                                    setShowPartnerModal(true);
                                  }}
                                  title={t('edit')}
                                >
                                  <FaEdit />
                                </button>
                                <button 
                                  className={`manager-btn-icon ${partner.is_active ? 'manager-btn-icon-disable' : 'manager-btn-icon-enable'}`}
                                  onClick={() => togglePartnerStatus(partner.id)}
                                  title={partner.is_active ? t('deactivate') : t('activate')}
                                >
                                  {partner.is_active ? <FaToggleOn /> : <FaToggleOff />}
                                </button>
                                <button 
                                  className="manager-btn-icon manager-btn-icon delete"
                                  onClick={() => deletePartner(partner.id)}
                                  title={t('delete')}
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}

        {/* Departments Section - simplified */}
{/* {activeMenu === 'departments' && (
  <div className="manager-content-section">
    <div className="manager-section-header">
      <h2><FaBuilding /> {t('departmentProgramsManagement') || 'Departments'}</h2>
      <div className="manager-section-actions">
        <button 
          className="manager-btn manager-btn-primary"
          onClick={() => {
            setCurrentDepartment(null);
            resetDepartmentForm();
            setShowDepartmentModal(true);
          }}
        >
          <FaPlus /> {t('addDepartment') || 'Add Department'}
        </button>
      </div>
    </div>

    {departmentsFull.length === 0 ? (
      <div className="manager-empty-state">
        <FaBuilding size={48} />
        <h3>{t('noDepartmentsFound') || 'No departments found'}</h3>
        <p>{t('addDepartmentDesc') || 'Add departments to display on the homepage'}</p>
      </div>
    ) : (
      <>
        <div className="manager-table-responsive">
          <table className="manager-data-table">
            <thead>
              <tr>
                <th>{t('name') || 'Name'}</th>
                <th>{t('description') || 'Description'}</th>
                <th>{t('actions') || 'Actions'}</th>
              </tr>
            </thead>
            <tbody>
              {departmentsFull.map(dept => (
                <tr key={dept.id}>
                  <td><strong>{dept.name}</strong></td>
                  <td className="manager-description-cell">
                    {dept.description ? (
                      dept.description.length > 100 
                        ? `${dept.description.substring(0, 100)}...` 
                        : dept.description
                    ) : t('noDescription') || 'No description'}
                  </td>
                  <td>
                    <div className="manager-action-buttons">
                      <button 
                        className="manager-btn-icon manager-btn-icon edit"
                        onClick={() => {
                          setCurrentDepartment(dept);
                          setNewDepartment({ name: dept.name, description: dept.description || '' });
                          setShowDepartmentModal(true);
                        }}
                        title={t('edit')}
                      >
                        <FaEdit />
                      </button>
                      <button 
                        className="manager-btn-icon manager-btn-icon delete"
                        onClick={() => deleteDepartment(dept.id, false)}
                        title={t('delete')}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>
)} */}
{/* Homepage Section */}
{activeMenu === 'homepage' && (
<div className="manager-content-section">
<div className="manager-section-header">
<h2><FaHome /> {t('homepageManagement') || 'Homepage Management'}</h2>
<div className="manager-section-actions">
<button 
className="manager-btn manager-btn-primary"
onClick={() => {
setCurrentHeroSlide(null);
setHeroSlideFile(null);
setNewHeroSlide({
title: '',
subtitle: '',
description: '',
button_text: 'Explore Departments',
button_link: '#departments',
sort_order: heroSlides.length,
is_active: true,
background_image: null
});
setShowHeroSlideModal(true);
}}
>
<FaPlus /> {t('addHeroSlide') || 'Add Hero Slide'}
</button>
<button 
className="manager-btn manager-btn-success"
onClick={() => {
setCurrentStat(null);
setNewStat({
value: '',
label: '',
icon: 'FaHeart',
color: '#FF9800',
sort_order: statsItems.length,
is_active: true
});
setShowStatModal(true);
}}
>
<FaPlus /> {t('addStat') || 'Add Stat'}
</button>
</div>
</div>

{/* Hero Slides Section */}
<div className="manager-card" style={{ marginBottom: '30px' }}>
<div className="manager-card-header">
<h3><FaImages /> {t('heroSlides') || 'Hero Slides'}</h3>
</div>
<div className="manager-card-body">
{heroSlides.length === 0 ? (
<div className="manager-empty-state">
<FaImages size={48} />
<h3>{t('noHeroSlides') || 'No hero slides'}</h3>
<p>{t('addHeroSlidesDesc') || 'Add slides to display on the homepage hero section'}</p>
</div>
) : (
<div className="manager-table-responsive">
<table className="manager-data-table">
<thead>
<tr>
<th>{t('image') || 'Image'}</th>
<th>{t('title') || 'Title'}</th>
<th>{t('subtitle') || 'Subtitle'}</th>
<th>{t('buttonText') || 'Button Text'}</th>
<th>{t('sortOrder') || 'Sort Order'}</th>
<th>{t('status') || 'Status'}</th>
<th>{t('actions') || 'Actions'}</th>
</tr>
</thead>
<tbody>
{heroSlides.map(slide => (
<tr key={slide.id}>
  <td>
    {slide.background_image ? (
      <img 
        src={`${API_BASE_URL}${slide.background_image}`} 
        alt={slide.title}
        style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
      />
    ) : (
      <div className="manager-avatar-small">No img</div>
    )}
  </td>
  <td><strong>{slide.title}</strong></td>
  <td>{slide.subtitle || '-'}</td>
  <td>{slide.button_text}</td>
  <td>{slide.sort_order || 0}</td>
  <td>
    <span className={`manager-status-badge ${slide.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
      {slide.is_active ? t('active') : t('inactive')}
    </span>
  </td>
  <td>
    <div className="manager-action-buttons">
      <button 
        className="manager-btn-icon manager-btn-icon edit"
        onClick={() => {
          setCurrentHeroSlide(slide);
          setHeroSlideFile(null);
          setShowHeroSlideModal(true);
        }}
        title={t('edit')}
      >
        <FaEdit />
      </button>
      <button 
        className={`manager-btn-icon ${slide.is_active ? 'manager-btn-icon-disable' : 'manager-btn-icon-enable'}`}
        onClick={() => toggleHeroSlideStatus(slide.id)}
        title={slide.is_active ? t('deactivate') : t('activate')}
      >
        {slide.is_active ? <FaToggleOn /> : <FaToggleOff />}
      </button>
      <button 
        className="manager-btn-icon manager-btn-icon delete"
        onClick={() => deleteHeroSlide(slide.id)}
        title={t('delete')}
      >
        <FaTrash />
      </button>
    </div>
  </td>
</tr>
))}
</tbody>
</table>
</div>
)}
</div>
</div>

{/* Stats Section */}
<div className="manager-card">
<div className="manager-card-header">
<h3><FaChartLine /> {t('stats') || 'Statistics'}</h3>
</div>
<div className="manager-card-body">
{statsItems.length === 0 ? (
<div className="manager-empty-state">
<FaChartLine size={48} />
<h3>{t('noStats') || 'No statistics'}</h3>
<p>{t('addStatsDesc') || 'Add statistics to display on the homepage'}</p>
</div>
) : (
<div className="manager-table-responsive">
<table className="manager-data-table">
<thead>
<tr>
<th>{t('icon') || 'Icon'}</th>
<th>{t('value') || 'Value'}</th>
<th>{t('label') || 'Label'}</th>
<th>{t('color') || 'Color'}</th>
<th>{t('sortOrder') || 'Sort Order'}</th>
<th>{t('status') || 'Status'}</th>
<th>{t('actions') || 'Actions'}</th>
</tr>
</thead>
<tbody>
{statsItems.map(stat => (
<tr key={stat.id}>
  <td>
    <div className="manager-icon-preview" style={{ color: stat.color }}>
      {getIconComponent(stat.icon)}
    </div>
  </td>
  <td><strong>{stat.value}</strong></td>
  <td>{stat.label}</td>
  <td>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{ width: '30px', height: '30px', backgroundColor: stat.color, borderRadius: '4px' }}></div>
      <span>{stat.color}</span>
    </div>
  </td>
  <td>{stat.sort_order || 0}</td>
  <td>
    <span className={`manager-status-badge ${stat.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
      {stat.is_active ? t('active') : t('inactive')}
    </span>
  </td>
  <td>
    <div className="manager-action-buttons">
      <button 
        className="manager-btn-icon manager-btn-icon edit"
        onClick={() => {
          setCurrentStat(stat);
          setShowStatModal(true);
        }}
        title={t('edit')}
      >
        <FaEdit />
      </button>
      <button 
        className="manager-btn-icon manager-btn-icon delete"
        onClick={() => deleteStat(stat.id)}
        title={t('delete')}
      >
        <FaTrash />
      </button>
    </div>
  </td>
</tr>
))}
</tbody>
</table>
</div>
)}
</div>
</div>
</div>
)}

{/* Activity Images Section */}
{activeMenu === 'activityImages' && (
<div className="manager-content-section">
<div className="manager-section-header">
<h2><FaImages /> {t('womenInAction') || 'Women in Action - Activity Images'}</h2>
<div className="manager-section-actions">
<div className="manager-search-filter">
<FaSearch />
<input
type="text"
placeholder={t('searchImages') || 'Search images...'}
value={activityImagesFilters.search}
onChange={(e) => setActivityImagesFilters(prev => ({ ...prev, search: e.target.value, page: 1 }))}
/>
</div>
<button 
className="manager-btn manager-btn-primary"
onClick={() => {
setCurrentActivityImage(null);
resetActivityImageForm();
setShowActivityImageModal(true);
}}
>
<FaPlus /> {t('addImage') || 'Add Image'}
</button>
<button 
className="manager-btn manager-btn-success"
onClick={() => setShowBulkUploadModal(true)}
>
<FaUpload /> {t('bulkUpload') || 'Bulk Upload'}
</button>
<button 
className="manager-btn manager-btn-outline"
onClick={exportActivityImages}
disabled={exporting}
>
{exporting ? <FaSpinner className="manager-spinning" /> : <FaDownload />}
{t('export') || 'Export'}
</button>
</div>
</div>

{/* Statistics Cards */}
<div className="manager-quick-stats-bar" style={{ marginBottom: '1.5rem' }}>
<div className="manager-quick-stat-item">
<div className="manager-quick-stat-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
<FaImages style={{ color: '#4CAF50' }} />
</div>
<div>
<h4>{activityImageStats.total_images || activityImages.length}</h4>
<p>{t('totalImages') || 'Total Images'}</p>
</div>
</div>
<div className="manager-quick-stat-item">
<div className="manager-quick-stat-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
<FaCheckCircle style={{ color: '#4CAF50' }} />
</div>
<div>
<h4>{activityImageStats.active_images || 0}</h4>
<p>{t('activeImages') || 'Active Images'}</p>
</div>
</div>
<div className="manager-quick-stat-item">
<div className="manager-quick-stat-icon" style={{ background: 'rgba(33, 150, 243, 0.1)' }}>
<FaBuilding style={{ color: '#2196F3' }} />
</div>
<div>
<h4>{activityImageStats.departments_with_images || 0}</h4>
<p>{t('departmentsWithImages') || 'Departments'}</p>
</div>
</div>
<div className="manager-quick-stat-item">
<div className="manager-quick-stat-icon" style={{ background: 'rgba(255, 152, 0, 0.1)' }}>
<FaCalendar style={{ color: '#FF9800' }} />
</div>
<div>
<h4>{activityImageStats.last_upload || t('never') || 'Never'}</h4>
<p>{t('lastUpload') || 'Last Upload'}</p>
</div>
</div>
</div>

{/* Filter Section */}
<div className="manager-filter-section">
<div className="manager-filter-group">
<label><FaFilter /> {t('filterBy') || 'Filter By'}:</label>
<select 
className="manager-filter-select"
value={activityImagesFilters.department_id}
onChange={(e) => setActivityImagesFilters(prev => ({ ...prev, department_id: e.target.value, page: 1 }))}
>
<option value="all">{t('allDepartments') || 'All Departments'}</option>
{departments.map(dept => (
<option key={dept.id} value={dept.id}>{dept.name}</option>
))}
</select>
<select 
className="manager-filter-select"
value={activityImagesFilters.status}
onChange={(e) => setActivityImagesFilters(prev => ({ ...prev, status: e.target.value, page: 1 }))}
>
<option value="all">{t('allStatus') || 'All Status'}</option>
<option value="active">{t('active') || 'Active'}</option>
<option value="inactive">{t('inactive') || 'Inactive'}</option>
</select>
<button 
className="manager-btn manager-btn-outline"
onClick={() => setActivityImagesFilters({ department_id: 'all', search: '', status: 'all' })}
>
<FaFilter /> {t('clearFilters') || 'Clear Filters'}
</button>
</div>
</div>

{activityImages.length === 0 ? (
<div className="manager-empty-state">
<FaImages size={48} />
<h3>{t('noActivityImages') || 'No activity images found'}</h3>
<p>{t('addActivityImagesDesc') || 'Add images to display in the Women in Action section on the homepage'}</p>
</div>
) : (
<>
<div className="manager-table-summary">
<p>{t('showingImages', { showing: activityImages.length, total: activityImagesPagination.total }) || `Showing ${activityImages.length} of ${activityImagesPagination.total} images`}</p>
<div className="manager-pagination">
<button 
className="manager-pagination-btn"
disabled={activityImagesPagination.page <= 1}
onClick={() => setActivityImagesPagination(prev => ({ ...prev, page: prev.page - 1 }))}
>
{t('previous')}
</button>
<span>{t('pageInfo', { page: activityImagesPagination.page, pages: activityImagesPagination.pages })}</span>
<button 
className="manager-pagination-btn"
disabled={activityImagesPagination.page >= activityImagesPagination.pages}
onClick={() => setActivityImagesPagination(prev => ({ ...prev, page: prev.page + 1 }))}
>
{t('next')}
</button>
</div>
</div>

<div className="manager-gallery-grid">
{activityImages
.filter(img => {
if (activityImagesFilters.status === 'active' && !img.is_active) return false;
if (activityImagesFilters.status === 'inactive' && img.is_active) return false;
return true;
})
.map(image => (
<div key={image.id} className="manager-gallery-card">
<div className="manager-gallery-image">
<img 
  src={image.image_url || '/placeholder-image.png'} 
  alt={image.title || image.description || 'Activity image'}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = 'https://via.placeholder.com/300x200?text=No+Image';
  }}
/>
{image.is_featured && (
  <span className="manager-featured-badge">{t('featured')}</span>
)}
{!image.is_active && (
  <span className="manager-inactive-badge">{t('inactive')}</span>
)}
</div>
<div className="manager-gallery-content">
<h4>{image.title || t('untitled') || 'Untitled'}</h4>
{image.department_name && (
  <span className="manager-department-badge" style={{ backgroundColor: image.department_color + '20', color: image.department_color }}>
    {image.department_name}
  </span>
)}
<p className="manager-gallery-description">
  {image.description?.length > 100 
    ? `${image.description.substring(0, 100)}...` 
    : image.description || t('noDescription') || 'No description'}
</p>
<div className="manager-gallery-meta">
  <span className="manager-date">
    <FaClock /> {new Date(image.uploaded_at).toLocaleDateString()}
  </span>
  {image.uploaded_by_name && (
    <span className="manager-uploader">
      <FaUser /> {image.uploaded_by_name}
    </span>
  )}
</div>
<div className="manager-gallery-actions">
  <button 
    className="manager-btn-icon manager-btn-icon edit"
    onClick={() => {
      setCurrentActivityImage(image);
      setActivityImageFile(null);
      setNewActivityImage({
        title: image.title || '',
        description: image.description || '',
        department_id: image.department_id || '',
        is_active: image.is_active === 1,
        image: null
      });
      setShowActivityImageModal(true);
    }}
    title={t('edit')}
  >
    <FaEdit />
  </button>
  <button 
    className={`manager-btn-icon ${image.is_active ? 'manager-btn-icon-disable' : 'manager-btn-icon-enable'}`}
    onClick={() => toggleActivityImageStatus(image.id)}
    title={image.is_active ? t('deactivate') : t('activate')}
  >
    {image.is_active ? <FaToggleOn /> : <FaToggleOff />}
  </button>
  {!image.is_active && (
    <button 
      className="manager-btn-icon manager-btn-icon-restore"
      onClick={() => restoreActivityImage(image.id)}
      title={t('restore') || 'Restore'}
    >
      <FaSync />
    </button>
  )}
  <button 
    className="manager-btn-icon manager-btn-icon delete"
    onClick={() => deleteActivityImage(image.id, false)}
    title={t('delete')}
  >
    <FaTrash />
  </button>
</div>
</div>
</div>
))}
</div>
</>
)}
</div>
)}

{/* Reports Section */}
{activeMenu === 'reports' && (
<div className="manager-content-section">
<h2><FaChartPie /> {t('reportsAnalytics')}</h2>

<div className="manager-reports-grid">
<div className="manager-report-card">
<h3><FaFileExport /> {t('generateReports')}</h3>
<div className="manager-report-options">
<button 
className="manager-report-btn" 
onClick={() => exportData('users')}
disabled={exporting}
>
{exporting ? <FaSpinner className="manager-spinning" /> : <FaUsers />}
{t('usersReport')}
</button>
<button 
className="manager-report-btn" 
onClick={() => exportData('requests')}
disabled={exporting}
>
{exporting ? <FaSpinner className="manager-spinning" /> : <FaClipboardList />}
{t('requestsReport')}
</button>

<button 
className="manager-report-btn" 
onClick={() => exportData('all')}
disabled={exporting}
>
{exporting ? <FaSpinner className="manager-spinning" /> : <FaDatabase />}
{t('fullDatabaseExport')}
</button>
</div>
</div>

<div className="manager-report-card">
<h3><FaChartBar /> {t('systemStatistics')}</h3>
<div className="manager-system-stats">
<div className="manager-system-stat">
<span className="manager-stat-label">{t('totalUsers')}</span>
<span className="manager-stat-value">{stats.total_users}</span>
</div>
<div className="manager-system-stat">
<span className="manager-stat-label">{t('employers')}</span>
<span className="manager-stat-value">{stats.employer_count}</span>
</div>
<div className="manager-system-stat">
<span className="manager-stat-label">{t('activeWomen')}</span>
<span className="manager-stat-value">{stats.active_women}</span>
</div>

</div>
</div>

<div className="manager-report-card">
<h3><FaChartPie /> {t('requestStatistics')}</h3>
<div className="manager-system-stats">
<div className="manager-system-stat">
<span className="manager-stat-label">{t('pending')}</span>
<span className="manager-stat-value">{stats.pending_requests || 0}</span>
</div>
<div className="manager-system-stat">
<span className="manager-stat-label">{t('approved')}</span>
<span className="manager-stat-value">{stats.approved_requests || 0}</span>
</div>
<div className="manager-system-stat">
<span className="manager-stat-label">{t('rejected')}</span>
<span className="manager-stat-value">{stats.rejected_requests || 0}</span>
</div>
<div className="manager-system-stat">
<span className="manager-stat-label">{t('successRate')}</span>
<span className="manager-stat-value">
{stats.total_requests > 0 
? Math.round((stats.approved_requests / stats.total_requests) * 100) 
: 0}%
</span>
</div>
</div>
</div>
</div>
</div>
)}

{/* Settings Section */}
{activeMenu === 'settings' && (
<div className="manager-content-section">
<h2><FaCog /> {t('settings')}</h2>

<div className="manager-settings-grid">
{/* Email Settings Card */}
<div className="manager-setting-card">
<h3><FaEnvelope /> {t('emailSettings')}</h3>
<div className="manager-setting-options">
 <div className="manager-setting-item">
  <div className="manager-setting-header">
    <h4>{t('emailNotifications') || 'Email Notifications'}</h4>
    <div className="manager-toggle-switch">
      <input
        type="checkbox"
        id="manager-notifications"
        checked={emailNotificationsEnabled}
        onChange={toggleEmailNotifications}
        disabled={updatingEmailToggle}
      />
      <label htmlFor="manager-notifications"></label>
    </div>
  </div>
  <p className="manager-setting-description">
    {emailNotificationsEnabled
      ? (t('email Notifications On') || '✅ Email notifications are ENABLED. All system emails (requests, approvals, assignments, reminders, password resets, broadcasts) will be sent.')
      : (t('email Notifications Off') || '🔕 Email notifications are DISABLED. NO emails will be sent anywhere in the system until you re-enable this.')}
  </p>
  {updatingEmailToggle && (
    <small style={{ color: '#718096' }}>
      <FaSpinner className="manager-spinning" /> {t('updating') || 'Updating...'}
    </small>
  )}
  {!emailNotificationsEnabled && (
    <div className="manager-alert manager-alert-warning" style={{ marginTop: '10px' }}>
      <FaExclamationTriangle />
      <p>
        <strong>{t('email Disabled Warning') || 'Email notifications are OFF'}</strong><br />
        {t('email Disabled Warning Desc') || 'Employers will NOT receive confirmation emails, status updates, assignment notices, or any other system emails. Password reset emails will also not be sent.'}
      </p>
    </div>
  )}
</div>

<div className="manager-setting-item">
<label>{t('autoApproveRequests')}</label>
<div className="manager-toggle-switch">
<input type="checkbox" id="manager-auto-approve" />
<label htmlFor="manager-auto-approve"></label>
</div>
</div>

<div className="manager-setting-item">
<h4>{t('emailBroadcast')}</h4>
<p className="manager-setting-description">
{t('emailBroadcastDescription')}
</p>
<button 
className="manager-btn manager-btn-primary"
onClick={openEmailBroadcastModal}
>
<FaEnvelope /> {t('sendEmailBroadcast')}
</button>
</div>

<div className="manager-setting-item">
<h4>{t('customEmail') || 'Send Custom Email'}</h4>
<p className="manager-setting-description">
{t('customEmailDescription') || 'Send emails to any email address (not limited to database users)'}
</p>
<button 
className="manager-btn manager-btn-info"
onClick={openCustomEmailModal}
>
<FaEnvelope /> {t('sendCustomEmail') || 'Send Custom Email'}
</button>
</div>
</div>
</div>

{/* Account Settings Card */}
<div className="manager-setting-card">
<h3><FaUserShield /> {t('accountSettings')}</h3>
<form onSubmit={handlePasswordChange}>
<div className="manager-setting-options">
{passwordError && (
<div className="manager-message-banner manager-error">
<FaExclamationTriangle />
<span>{passwordError}</span>
<button onClick={() => setPasswordError('')}>×</button>
</div>
)}

{passwordSuccess && (
<div className="manager-message-banner manager-success">
<FaCheckCircle />
<span>{passwordSuccess}</span>
<button onClick={() => setPasswordSuccess('')}>×</button>
</div>
)}

<div className="manager-setting-item">
<label>{t('currentPassword')} *</label>
<div className="manager-password-input-container" style={{ position: 'relative' }}>
<input
type={showCurrentPassword ? 'text' : 'password'}
value={passwordData.currentPassword}
onChange={(e) => setPasswordData(prev => ({
  ...prev,
  currentPassword: e.target.value
}))}
placeholder={t('enterCurrentPassword')}
required
style={{ paddingRight: '40px' }}
/>
<button
type="button"
className="manager-password-toggle"
onClick={() => setShowCurrentPassword(!showCurrentPassword)}
style={{
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#666'
}}
>
{showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
</button>
</div>
</div>

<div className="manager-setting-item">
<label>{t('newPassword')} *</label>
<div className="manager-password-input-container" style={{ position: 'relative' }}>
<input
type={showNewPassword ? 'text' : 'password'}
value={passwordData.newPassword}
onChange={(e) => setPasswordData(prev => ({
  ...prev,
  newPassword: e.target.value
}))}
placeholder={t('enterNewPassword')}
required
minLength={6}
style={{ paddingRight: '40px' }}
/>
<button
type="button"
className="manager-password-toggle"
onClick={() => setShowNewPassword(!showNewPassword)}
style={{
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#666'
}}
>
{showNewPassword ? <FaEyeSlash /> : <FaEye />}
</button>
</div>
</div>

<div className="manager-setting-item">
<label>{t('confirmPassword')} *</label>
<div className="manager-password-input-container" style={{ position: 'relative' }}>
<input
type={showConfirmPassword ? 'text' : 'password'}
value={passwordData.confirmPassword}
onChange={(e) => setPasswordData(prev => ({
  ...prev,
  confirmPassword: e.target.value
}))}
placeholder={t('confirmNewPassword')}
required
minLength={6}
style={{ paddingRight: '40px' }}
/>
<button
type="button"
className="manager-password-toggle"
onClick={() => setShowConfirmPassword(!showConfirmPassword)}
style={{
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#666'
}}
>
{showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
</button>
</div>
</div>

<div className="manager-setting-item">
<label>{t('emailAddress')}</label>
<input type="email" defaultValue={user?.email} readOnly />
</div>

<button type="submit" className="manager-btn manager-btn-primary" disabled={changingPassword}>
{changingPassword ? (
<>
<FaSpinner className="manager-spinning" /> {t('changing')}
</>
) : (
<>
<FaSave /> {t('changePassword')}
</>
)}
</button>
</div>
</form>
</div>

{/* System Settings Card - Maintenance Mode */}
<div className="manager-setting-card">
<h3><FaCog /> {t('systemSettings') || 'System Settings'}</h3>
<div className="manager-setting-options">
<div className="manager-alert manager-alert-info" style={{ marginBottom: '15px' }}>
<FaInfoCircle />
<p>
<strong>{t('Maintenance Mode Info') || 'About Maintenance Mode'}</strong><br />
{t('Maintenance Mode Description') || 
'When enabled, non-logged-in users will see a maintenance page. Logged-in administrators and managers can still access the site normally.'}
</p>
</div>

<div className="manager-setting-item">
<div className="manager-setting-header">
<h4>{t('Maintenance Mode') || 'Maintenance Mode'}</h4>
<div className="manager-toggle-switch">
<input 
type="checkbox" 
id="maintenance-mode-toggle"
checked={maintenanceMode.is_enabled}
onChange={toggleMaintenanceMode}
disabled={updatingMaintenance}
/>
<label htmlFor="maintenance-mode-toggle"></label>
</div>
</div>
<p className="manager-setting-description">
{maintenanceMode.is_enabled 
? (t('Maintenance Mode Enabled') || 'Maintenance mode is currently ENABLED. Users will see a maintenance page.') 
: (t('Maintenance Mode Disabled') || 'Maintenance mode is currently DISABLED. The site is accessible to all users.')}
</p>
</div>

<div className="manager-setting-item">
<label>{t('Maintenance Message') || 'Maintenance Message'}</label>
<textarea
value={maintenanceMode.message}
onChange={(e) => setMaintenanceMode(prev => ({ ...prev, message: e.target.value }))}
placeholder={t('Enter Maintenance Message') || 'Enter message to display during maintenance'}
rows="3"
disabled={updatingMaintenance}
/>
<small>{t('Maintenance Message Hint') || 'This message will be shown to users when maintenance mode is active'}</small>
</div>

<div className="manager-setting-actions">
<button 
className="manager-btn manager-btn-primary"
onClick={updateMaintenanceMessage}
disabled={updatingMaintenance}
>
{updatingMaintenance ? <FaSpinner className="manager-spinning" /> : <FaSave />}
{t('Save Message') || 'Save Message'}
</button>
</div>

{maintenanceMode.is_enabled && (
<div className="manager-alert manager-alert-warning" style={{ marginTop: '15px' }}>
<FaExclamationTriangle />
<p>
<strong>{t('Maintenance Mode Active') || 'Maintenance mode is ACTIVE'}</strong><br />
{t('Maintenance Mode Warning') || 'The site is currently in maintenance mode. Only logged-in users can access the site.'}
</p>
</div>
)}
</div>
</div>
</div>
</div>
)}
</div>
</main>

{/* Employment Details Modal with Pagination */}
{showEmploymentModal && (
  <div className="manager-modal-overlay" onClick={() => {
    // Close when clicking the overlay
    setShowEmploymentModal(false);
    setEmploymentModalPagination({ page: 1, limit: 20, total: 0, pages: 1 });
    setFilteredWomen([]);
  }}>
    <div className="manager-modal manager-modal-lg" onClick={e => e.stopPropagation()}>
      <div className="manager-modal-header">
        <h3>
          {selectedEmploymentStatus?.label} - {employmentModalPagination.total} Women
        </h3>
        <button 
          className="manager-modal-close" 
          onClick={() => {
            setShowEmploymentModal(false);
            setEmploymentModalPagination({ page: 1, limit: 20, total: 0, pages: 1 });
            setFilteredWomen([]);
          }}
        >
          <FaTimes />
        </button>
      </div>
      <div className="manager-modal-body">
        {modalLoading ? (
          <div className="manager-loading-spinner" style={{ margin: '40px auto' }} />
        ) : filteredWomen.length === 0 ? (
          <div className="manager-empty-state">
            <FaUserTimes size={48} />
            <h3>{t('noWomenFoundWithStatus') || 'No women found with this status'}</h3>
          </div>
        ) : (
          <>
            <div className="manager-table-responsive">
              <table className="manager-data-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{t('name')}</th>
                    <th>{t('age')}</th>
                    <th>{t('cohort')}</th>
                    <th>{t('department')}</th>
                    <th>{t('phone')}</th>
                    <th>{t('email')}</th>
                    <th>{t('placementLocation')}</th>
                    <th>{t('competenceSkills')}</th>
                    <th>{t('employmentStatus')}</th>
                    <th>{t('companyName')}</th>
                    <th>{t('workingPosition')}</th>
                    <th>{t('monthlyIncome')}</th>
                    <th>{t('availability')}</th>
                    <th>{t('active')}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredWomen.map(w => (
                    <tr key={w.id}>
                      <td>W-{w.id}</td>
                      <td><strong>{w.name}</strong></td>
                      <td>{w.age || '-'}</td>
                      <td>{w.cohort || '-'}</td>
                      <td>{w.department_name || '-'}</td>
                      <td>{w.phone || '-'}</td>
                      <td>{w.email || '-'}</td>
                      <td>{w.placement_location || '-'}</td>
                      <td>{w.competence_skills || '-'}</td>
                      <td>
                        <span className="manager-status-badge">
                          {w.employment_status ? t(w.employment_status) || w.employment_status : '-'}
                        </span>
                      </td>
                      <td>{w.company_name || '-'}</td>
                      <td>{w.working_position || '-'}</td>
                      <td>{w.monthly_income || '-'}</td>
                      <td>
                        <span className={`manager-status-badge ${w.is_available ? 'manager-status-available' : 'manager-status-hired'}`}>
                          {w.is_available ? t('available') : t('hired')}
                        </span>
                      </td>
                      <td>
                        <span className={`manager-status-badge ${w.is_active ? 'manager-status-active' : 'manager-status-inactive'}`}>
                          {w.is_active ? t('active') : t('inactive')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            {employmentModalPagination.pages > 1 && (
              <div className="manager-pagination" style={{ marginTop: '15px', justifyContent: 'center' }}>
                <button
                  className="manager-pagination-btn"
                  disabled={employmentModalPagination.page <= 1 || modalLoading}
                  onClick={() => handleEmploymentModalPageChange(employmentModalPagination.page - 1)}
                >
                  {t('previous')}
                </button>
                <span>
                  {t('pageInfo', { page: employmentModalPagination.page, pages: employmentModalPagination.pages })}
                </span>
                <button
                  className="manager-pagination-btn"
                  disabled={employmentModalPagination.page >= employmentModalPagination.pages || modalLoading}
                  onClick={() => handleEmploymentModalPageChange(employmentModalPagination.page + 1)}
                >
                  {t('next')}
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <div className="manager-modal-footer" style={{ justifyContent: 'space-between' }}>
        <div>
          <button
            className="manager-btn manager-btn-success"
            onClick={() => exportFilteredWomen('excel')}
            disabled={filteredWomen.length === 0}
          >
            <FaFileExcel /> {t('exportExcel') || 'Export Excel'}
          </button>
          <button
            className="manager-btn manager-btn-danger"
            onClick={() => exportFilteredWomen('pdf')}
            style={{ marginLeft: '10px' }}
            disabled={filteredWomen.length === 0}
          >
            <FaFilePdf /> {t('exportPDF') || 'Export PDF'}
          </button>
        </div>
        <button 
          className="manager-btn manager-btn-outline" 
          onClick={() => {
            setShowEmploymentModal(false);
            setEmploymentModalPagination({ page: 1, limit: 20, total: 0, pages: 1 });
            setFilteredWomen([]);
          }}
        >
          {t('close')}
        </button>
      </div>
    </div>
  </div>
)}
{/* Department Modal - simplified */}
{showDepartmentModal && (
  <div className="manager-modal-overlay">
    <div className="manager-modal">
      <div className="manager-modal-header">
        <h3>{currentDepartment ? (t('editDepartment') || 'Edit Department') : (t('addDepartment') || 'Add Department')}</h3>
        <button className="manager-modal-close" onClick={() => setShowDepartmentModal(false)}>
          <FaTimes />
        </button>
      </div>
      <form onSubmit={currentDepartment ? handleEditDepartment : handleAddDepartment}>
        <div className="manager-modal-body">
          <div className="manager-form-group">
            <label>{t('departmentName') || 'Department Name'} *</label>
            <input
              type="text"
              value={newDepartment.name}
              onChange={(e) => setNewDepartment(prev => ({ ...prev, name: e.target.value }))}
              required
              placeholder={t('enterDepartmentName') || 'e.g., Weaving, IT & AI Training'}
            />
          </div>
          <div className="manager-form-group">
            <label>{t('description') || 'Description'}</label>
            <textarea
              value={newDepartment.description}
              onChange={(e) => setNewDepartment(prev => ({ ...prev, description: e.target.value }))}
              rows="4"
              placeholder={t('enterDescription') || 'Enter department description'}
            />
          </div>
        </div>
        <div className="manager-modal-footer">
          <button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowDepartmentModal(false)}>
            {t('cancel')}
          </button>
          <button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
            {loading ? <FaSpinner className="manager-spinning" /> : null}
            {currentDepartment ? (t('update') || 'Update') : (t('add') || 'Add')}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{/* Event Modal */}
{showEventModal && (
  <div className="manager-modal-overlay">
    <div className="manager-modal manager-modal-lg">
      <div className="manager-modal-header">
        <h3>{currentEvent ? (t('editEvent') || 'Edit Event') : (t('addEvent') || 'Add Event')}</h3>
        <button className="manager-modal-close" onClick={() => setShowEventModal(false)}>
          <FaTimes />
        </button>
      </div>
      <form onSubmit={currentEvent ? handleEditEvent : handleAddEvent}>
        <div className="manager-modal-body">
          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('title') || 'Title'} *</label>
              <input
                type="text"
                value={currentEvent?.title || newEvent.title}
                onChange={(e) => {
                  if (currentEvent) {
                    setCurrentEvent(prev => ({ ...prev, title: e.target.value }));
                  } else {
                    setNewEvent(prev => ({ ...prev, title: e.target.value }));
                  }
                }}
                required
                placeholder={t('enterEventTitle') || 'Enter event title'}
              />
            </div>
            <div className="manager-form-group">
              <label>{t('eventDate') || 'Event Date'}</label>
              <input
                type="date"
                value={currentEvent?.event_date || newEvent.event_date}
                onChange={(e) => {
                  if (currentEvent) {
                    setCurrentEvent(prev => ({ ...prev, event_date: e.target.value }));
                  } else {
                    setNewEvent(prev => ({ ...prev, event_date: e.target.value }));
                  }
                }}
              />
            </div>
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('location') || 'Location'}</label>
              <input
                type="text"
                value={currentEvent?.location || newEvent.location}
                onChange={(e) => {
                  if (currentEvent) {
                    setCurrentEvent(prev => ({ ...prev, location: e.target.value }));
                  } else {
                    setNewEvent(prev => ({ ...prev, location: e.target.value }));
                  }
                }}
                placeholder={t('enterLocation') || 'Enter location'}
              />
            </div>
            <div className="manager-form-group">
              <label>{t('organizer') || 'Organizer'}</label>
              <input
                type="text"
                value={currentEvent?.organizer || newEvent.organizer}
                onChange={(e) => {
                  if (currentEvent) {
                    setCurrentEvent(prev => ({ ...prev, organizer: e.target.value }));
                  } else {
                    setNewEvent(prev => ({ ...prev, organizer: e.target.value }));
                  }
                }}
                placeholder={t('enterOrganizer') || 'Enter organizer'}
              />
            </div>
          </div>

          <div className="manager-form-group">
            <label>{t('description') || 'Description'} *</label>
            <textarea
              value={currentEvent?.description || newEvent.description}
              onChange={(e) => {
                if (currentEvent) {
                  setCurrentEvent(prev => ({ ...prev, description: e.target.value }));
                } else {
                  setNewEvent(prev => ({ ...prev, description: e.target.value }));
                }
              }}
              rows="4"
              required
              placeholder={t('enterEventDescription') || 'Enter event description'}
            />
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>
                <input
                  type="checkbox"
                  checked={currentEvent?.is_active !== undefined ? currentEvent.is_active : newEvent.is_active}
                  onChange={(e) => {
                    if (currentEvent) {
                      setCurrentEvent(prev => ({ ...prev, is_active: e.target.checked }));
                    } else {
                      setNewEvent(prev => ({ ...prev, is_active: e.target.checked }));
                    }
                  }}
                />
                <span> {t('active') || 'Active'}</span>
              </label>
            </div>
          </div>

          <div className="manager-form-group">
            <label>{t('eventImage') || 'Event Image'}</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setEventImage(e.target.files[0])}
            />
            {(currentEvent?.image_url && !eventImage) && (
              <div className="manager-current-image">
                <p>{t('currentImage') || 'Current image'}:</p>
                <img
                  src={`${API_BASE_URL}${currentEvent.image_url}`}
                  alt={t('current')}
                  style={{ maxWidth: '150px', marginTop: '10px', borderRadius: '4px' }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="manager-modal-footer">
          <button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowEventModal(false)}>
            {t('cancel')}
          </button>
          <button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
            {loading ? <FaSpinner className="manager-spinning" /> : null}
            {currentEvent ? (t('update') || 'Update') : (t('add') || 'Add')}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{/* Activity Image Modal */}
{showActivityImageModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentActivityImage ? (t('editActivityImage') || 'Edit Activity Image') : (t('addActivityImage') || 'Add Activity Image')}</h3>
<button className="manager-modal-close" onClick={() => setShowActivityImageModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentActivityImage ? handleEditActivityImage : handleAddActivityImage}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('title') || 'Title'}</label>
<input
type="text"
value={currentActivityImage?.title || newActivityImage.title}
onChange={(e) => {
if (currentActivityImage) {
setCurrentActivityImage(prev => ({ ...prev, title: e.target.value }));
} else {
setNewActivityImage(prev => ({ ...prev, title: e.target.value }));
}
}}
placeholder={t('enterImageTitle') || 'Enter image title'}
/>
</div>
<div className="manager-form-group">
<label>{t('department') || 'Department'}</label>
<select
value={currentActivityImage?.department_id || newActivityImage.department_id}
onChange={(e) => {
if (currentActivityImage) {
setCurrentActivityImage(prev => ({ ...prev, department_id: e.target.value }));
} else {
setNewActivityImage(prev => ({ ...prev, department_id: e.target.value }));
}
}}
>
<option value="">{t('selectDepartment') || 'Select Department'}</option>
{departments.map(dept => (
<option key={dept.id} value={dept.id}>{dept.name}</option>
))}
</select>
</div>
</div>

<div className="manager-form-group">
<label>{t('description') || 'Description'}</label>
<textarea
value={currentActivityImage?.description || newActivityImage.description}
onChange={(e) => {
if (currentActivityImage) {
setCurrentActivityImage(prev => ({ ...prev, description: e.target.value }));
} else {
setNewActivityImage(prev => ({ ...prev, description: e.target.value }));
}
}}
rows="3"
placeholder={t('enterImageDescription') || 'Enter image description'}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentActivityImage?.is_active !== undefined ? currentActivityImage.is_active : newActivityImage.is_active}
onChange={(e) => {
if (currentActivityImage) {
setCurrentActivityImage(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewActivityImage(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span> {t('active') || 'Active'}</span>
</label>
</div>
</div>

<div className="manager-form-group">
<label>{t('imageFile') || 'Image File'} *</label>
<input
type="file"
accept="image/*"
onChange={(e) => setActivityImageFile(e.target.files[0])}
required={!currentActivityImage}
/>
{currentActivityImage?.image_url && !activityImageFile && (
<div className="manager-current-image">
<p>{t('currentImage') || 'Current image'}:</p>
<img 
src={currentActivityImage.image_url} 
alt={t('current')}
style={{ maxWidth: '150px', marginTop: '10px', borderRadius: '8px' }}
/>
</div>
)}
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowActivityImageModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentActivityImage ? (t('update') || 'Update') : (t('add') || 'Add')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Bulk Upload Modal */}
{showBulkUploadModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{t('bulkUploadImages') || 'Bulk Upload Images'}</h3>
<button className="manager-modal-close" onClick={() => setShowBulkUploadModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={handleBulkUpload}>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('selectImages') || 'Select Images'} (Max 10 files)</label>
<input
type="file"
accept="image/*"
multiple
onChange={(e) => setBulkUploadFiles(Array.from(e.target.files))}
required
/>
<small>{t('bulkUploadInfo') || 'You can select up to 10 images at once. Supported formats: JPG, PNG, GIF, WebP'}</small>
</div>

<div className="manager-form-group">
<label>{t('department') || 'Department'}</label>
<select
value={newActivityImage.department_id}
onChange={(e) => setNewActivityImage(prev => ({ ...prev, department_id: e.target.value }))}
>
<option value="">{t('selectDepartment') || 'Select Department'}</option>
{departments.map(dept => (
<option key={dept.id} value={dept.id}>{dept.name}</option>
))}
</select>
</div>

<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={newActivityImage.is_active}
onChange={(e) => setNewActivityImage(prev => ({ ...prev, is_active: e.target.checked }))}
/>
<span> {t('active') || 'Active'}</span>
</label>
</div>

{bulkUploadFiles.length > 0 && (
<div className="manager-bulk-preview">
<h4>{t('selectedFiles') || 'Selected Files'}:</h4>
<div className="manager-bulk-files-list">
{bulkUploadFiles.map((file, index) => (
<div key={index} className="manager-bulk-file-item">
<span>{file.name}</span>
<span className="manager-file-size">({(file.size / 1024).toFixed(1)} KB)</span>
</div>
))}
</div>
</div>
)}
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowBulkUploadModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading || bulkUploadFiles.length === 0}>
{loading ? <FaSpinner className="manager-spinning" /> : <FaUpload />}
{loading ? t('uploading') || 'Uploading...' : t('uploadAll') || 'Upload All'}
</button>
</div>
</form>
</div>
</div>
)}

{/* Hero Slide Modal */}
{showHeroSlideModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentHeroSlide ? t('editHeroSlide') || 'Edit Hero Slide' : t('addHeroSlide') || 'Add Hero Slide'}</h3>
<button className="manager-modal-close" onClick={() => setShowHeroSlideModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentHeroSlide ? handleEditHeroSlide : handleAddHeroSlide}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('title') || 'Title'} *</label>
<input
type="text"
value={currentHeroSlide?.title || newHeroSlide.title}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, title: e.target.value }));
} else {
setNewHeroSlide(prev => ({ ...prev, title: e.target.value }));
}
}}
required
placeholder={t('enterTitle') || 'Enter title'}
/>
</div>
<div className="manager-form-group">
<label>{t('subtitle') || 'Subtitle'}</label>
<input
type="text"
value={currentHeroSlide?.subtitle || newHeroSlide.subtitle}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, subtitle: e.target.value }));
} else {
setNewHeroSlide(prev => ({ ...prev, subtitle: e.target.value }));
}
}}
placeholder={t('enterSubtitle') || 'Enter subtitle'}
/>
</div>
</div>

<div className="manager-form-group">
<label>{t('description') || 'Description'}</label>
<textarea
value={currentHeroSlide?.description || newHeroSlide.description}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, description: e.target.value }));
} else {
setNewHeroSlide(prev => ({ ...prev, description: e.target.value }));
}
}}
rows="3"
placeholder={t('enterDescription') || 'Enter description'}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('buttonText') || 'Button Text'}</label>
<input
type="text"
value={currentHeroSlide?.button_text || newHeroSlide.button_text}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, button_text: e.target.value }));
} else {
setNewHeroSlide(prev => ({ ...prev, button_text: e.target.value }));
}
}}
placeholder={t('enterButtonText') || 'Enter button text'}
/>
</div>
<div className="manager-form-group">
<label>{t('buttonLink') || 'Button Link'}</label>
<input
type="text"
value={currentHeroSlide?.button_link || newHeroSlide.button_link}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, button_link: e.target.value }));
} else {
setNewHeroSlide(prev => ({ ...prev, button_link: e.target.value }));
}
}}
placeholder={t('enterButtonLink') || '#departments'}
/>
</div>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('sortOrder') || 'Sort Order'}</label>
<input
type="number"
value={currentHeroSlide?.sort_order || newHeroSlide.sort_order}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewHeroSlide(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
/>
</div>
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentHeroSlide?.is_active !== undefined ? currentHeroSlide.is_active : newHeroSlide.is_active}
onChange={(e) => {
if (currentHeroSlide) {
setCurrentHeroSlide(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewHeroSlide(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('active')}</span>
</label>
</div>
</div>

<div className="manager-form-group">
<label>{t('backgroundImage') || 'Background Image'}</label>
<input
type="file"
accept="image/*"
onChange={(e) => setHeroSlideFile(e.target.files[0])}
/>
{currentHeroSlide?.background_image && !heroSlideFile && (
<div className="manager-current-image">
<p>{t('currentImage') || 'Current image'}:</p>
<img 
src={`${API_BASE_URL}${currentHeroSlide.background_image}`} 
alt={t('current')}
style={{ maxWidth: '200px', marginTop: '10px' }}
/>
</div>
)}
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowHeroSlideModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentHeroSlide ? (t('update') || 'Update') : (t('add') || 'Add')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Stat Modal */}
{showStatModal && (
<div className="manager-modal-overlay">
<div className="manager-modal">
<div className="manager-modal-header">
<h3>{currentStat ? t('editStat') || 'Edit Stat' : t('addStat') || 'Add Stat'}</h3>
<button className="manager-modal-close" onClick={() => setShowStatModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentStat ? handleEditStat : handleAddStat}>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('value') || 'Value'} *</label>
<input
type="text"
value={currentStat?.value || newStat.value}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, value: e.target.value }));
} else {
setNewStat(prev => ({ ...prev, value: e.target.value }));
}
}}
required
placeholder={t('enterValue') || 'Enter value (e.g., 800+)'}
/>
</div>

<div className="manager-form-group">
<label>{t('label') || 'Label'} *</label>
<input
type="text"
value={currentStat?.label || newStat.label}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, label: e.target.value }));
} else {
setNewStat(prev => ({ ...prev, label: e.target.value }));
}
}}
required
placeholder={t('enterLabel') || 'Enter label (e.g., Women Trained)'}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('icon') || 'Icon'}</label>
<select
value={currentStat?.icon || newStat.icon}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, icon: e.target.value }));
} else {
setNewStat(prev => ({ ...prev, icon: e.target.value }));
}
}}
>
<option value="FaUsers">FaUsers - Users</option>
<option value="FaGraduationCap">FaGraduationCap - Graduation</option>
<option value="FaHandsHelping">FaHandsHelping - Helping Hands</option>
<option value="FaHeart">FaHeart - Heart</option>
<option value="FaAward">FaAward - Award</option>
<option value="FaChartLine">FaChartLine - Chart Line</option>
</select>
</div>
<div className="manager-form-group">
<label>{t('color') || 'Color'}</label>
<input
type="color"
value={currentStat?.color || newStat.color}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, color: e.target.value }));
} else {
setNewStat(prev => ({ ...prev, color: e.target.value }));
}
}}
/>
</div>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('sortOrder') || 'Sort Order'}</label>
<input
type="number"
value={currentStat?.sort_order || newStat.sort_order}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewStat(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
/>
</div>
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentStat?.is_active !== undefined ? currentStat.is_active : newStat.is_active}
onChange={(e) => {
if (currentStat) {
setCurrentStat(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewStat(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('active')}</span>
</label>
</div>
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowStatModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentStat ? (t('update') || 'Update') : (t('add') || 'Add')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Why Choose Us Modal */}
{showWhyChooseUsModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentWhyChooseUs ? t('editWhyChooseUsItem') || 'Edit Item' : t('addWhyChooseUsItem') || 'Add Why Choose Us Item'}</h3>
<button className="manager-modal-close" onClick={() => setShowWhyChooseUsModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentWhyChooseUs ? handleEditWhyChooseUs : handleAddWhyChooseUs}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('title') || 'Title'} *</label>
<input
type="text"
value={currentWhyChooseUs?.title || newWhyChooseUs.title}
onChange={(e) => {
if (currentWhyChooseUs) {
setCurrentWhyChooseUs(prev => ({ ...prev, title: e.target.value }));
} else {
setNewWhyChooseUs(prev => ({ ...prev, title: e.target.value }));
}
}}
required
placeholder={t('enterTitle') || 'Enter title'}
/>
</div>
<div className="manager-form-group">
<label>{t('icon') || 'Icon'}</label>
<select
value={currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name}
onChange={(e) => {
if (currentWhyChooseUs) {
setCurrentWhyChooseUs(prev => ({ ...prev, icon_name: e.target.value }));
} else {
setNewWhyChooseUs(prev => ({ ...prev, icon_name: e.target.value }));
}
}}
>
<option value="FaHeart">Heart</option>
<option value="FaChalkboardTeacher">Teacher</option>
<option value="FaTools">Tools</option>
<option value="FaHandshake">Handshake</option>
<option value="FaClock">Clock</option>
<option value="FaCertificate">Certificate</option>
<option value="FaUsers">Users</option>
</select>
</div>
</div>

<div className="manager-form-group">
<label>{t('description') || 'Description'} *</label>
<textarea
value={currentWhyChooseUs?.description || newWhyChooseUs.description}
onChange={(e) => {
if (currentWhyChooseUs) {
setCurrentWhyChooseUs(prev => ({ ...prev, description: e.target.value }));
} else {
setNewWhyChooseUs(prev => ({ ...prev, description: e.target.value }));
}
}}
required
rows="4"
placeholder={t('enterDescription') || 'Enter description'}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('sortOrder') || 'Sort Order'}</label>
<input
type="number"
value={currentWhyChooseUs?.sort_order || newWhyChooseUs.sort_order}
onChange={(e) => {
if (currentWhyChooseUs) {
setCurrentWhyChooseUs(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewWhyChooseUs(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
placeholder="0"
/>
</div>
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentWhyChooseUs?.is_active !== undefined ? currentWhyChooseUs.is_active : newWhyChooseUs.is_active}
onChange={(e) => {
if (currentWhyChooseUs) {
setCurrentWhyChooseUs(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewWhyChooseUs(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('active')}</span>
</label>
</div>
</div>

<div className="manager-icon-preview-section">
<h4>{t('iconPreview') || 'Icon Preview'}:</h4>
<div className="manager-icon-preview-large">
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaHeart' && <FaHeart size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaChalkboardTeacher' && <FaChalkboardTeacher size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaTools' && <FaTools size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaHandshake' && <FaHandshake size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaClock' && <FaClock size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaCertificate' && <FaCertificate size={48} />}
{(currentWhyChooseUs?.icon_name || newWhyChooseUs.icon_name) === 'FaUsers' && <FaUsers size={48} />}
</div>
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowWhyChooseUsModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentWhyChooseUs ? t('update') || 'Update' : t('add') || 'Add'}
</button>
</div>
</form>
</div>
</div>
)}

{/* Video Section Modal */}
{showVideoSectionModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentVideoSection ? t('editVideoSection') || 'Edit Video' : t('addVideoSection') || 'Add Video'}</h3>
<button 
className="manager-modal-close" 
onClick={() => {
setShowVideoSectionModal(false);
setCurrentVideoSection(null);
setNewVideoSection({
title: '',
description: '',
video_file: null,
is_active: false
});
}}
>
<FaTimes />
</button>
</div>

<form onSubmit={currentVideoSection ? handleEditVideoSection : handleAddVideoSection}>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('videoFile') || 'Video File'} *</label>
<input
type="file"
accept="video/mp4,video/webm,video/ogg,video/quicktime"
onChange={(e) => {
const file = e.target.files[0];
if (currentVideoSection) {
setCurrentVideoSection(prev => ({ ...prev, video_file: file }));
} else {
setNewVideoSection(prev => ({ ...prev, video_file: file }));
}
}}
required={!currentVideoSection}
/>
<small>Supported formats: MP4, WebM, OGG, MOV (Max 1GB)</small>

{currentVideoSection?.video_url && !currentVideoSection.video_file && (
<div className="manager-current-video" style={{ marginTop: '10px' }}>
<p>{t('currentVideo') || 'Current video'}:</p>
<video 
src={currentVideoSection.video_url} 
controls
style={{ maxWidth: '300px', marginTop: '10px' }}
/>
</div>
)}
</div>

<div className="manager-form-group">
<label>{t('title') || 'Title'}</label>
<input
type="text"
value={currentVideoSection?.title || newVideoSection.title}
onChange={(e) => {
if (currentVideoSection) {
setCurrentVideoSection(prev => ({ ...prev, title: e.target.value }));
} else {
setNewVideoSection(prev => ({ ...prev, title: e.target.value }));
}
}}
placeholder={t('enterVideoTitle') || 'Enter video title'}
/>
</div>

<div className="manager-form-group">
<label>{t('description') || 'Description'}</label>
<textarea
value={currentVideoSection?.description || newVideoSection.description}
onChange={(e) => {
if (currentVideoSection) {
setCurrentVideoSection(prev => ({ ...prev, description: e.target.value }));
} else {
setNewVideoSection(prev => ({ ...prev, description: e.target.value }));
}
}}
rows="3"
placeholder={t('enterVideoDescription') || 'Enter video description'}
/>
</div>

<div className="manager-form-group">
<label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
<input
type="checkbox"
checked={currentVideoSection?.is_active !== undefined ? currentVideoSection.is_active : newVideoSection.is_active}
onChange={(e) => {
if (currentVideoSection) {
setCurrentVideoSection(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewVideoSection(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('setAsActive') || 'Set as active video'}</span>
</label>
<small>{t('onlyOneActive') || 'Only one video can be active at a time'}</small>
</div>
</div>

<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowVideoSectionModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentVideoSection ? (t('update') || 'Update') : (t('add') || 'Add')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Email Broadcast Modal */}
{showEmailBroadcastModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3><FaEnvelope /> {t('sendEmailBroadcast')}</h3>
<button className="manager-modal-close" onClick={() => setShowEmailBroadcastModal(false)} disabled={broadcastLoading}>
<FaTimes />
</button>
</div>

<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('subject')} *</label>
<input
type="text"
value={emailBroadcastData.subject}
onChange={(e) => setEmailBroadcastData(prev => ({ ...prev, subject: e.target.value }))}
placeholder={t('enterEmailSubject')}
disabled={broadcastLoading}
required
/>
</div>

<div className="manager-form-group">
<label>{t('message')} *</label>
<textarea
value={emailBroadcastData.message}
onChange={(e) => setEmailBroadcastData(prev => ({ ...prev, message: e.target.value }))}
placeholder={t('enterEmailMessage')}
rows="8"
disabled={broadcastLoading}
required
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('recipients')}</label>
<select
value={emailBroadcastData.recipients}
onChange={(e) => setEmailBroadcastData(prev => ({ ...prev, recipients: e.target.value }))}
disabled={broadcastLoading || emailBroadcastData.send_as_test}
>
<option value="all">{t('allUsers')}</option>
<option value="employers">{t('employersOnly')}</option>
<option value="admins">{t('adminsOnly')}</option>
<option value="managers">{t('managersOnly')}</option>
</select>
</div>

<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={emailBroadcastData.send_as_test}
onChange={(e) => setEmailBroadcastData(prev => ({ ...prev, send_as_test: e.target.checked }))}
disabled={broadcastLoading}
/>
<span>{t('sendTestEmail')}</span>
</label>
</div>
</div>

{emailBroadcastData.send_as_test && (
<div className="manager-form-group">
<label>{t('testEmailAddress')} *</label>
<input
type="email"
value={emailBroadcastData.test_email}
onChange={(e) => setEmailBroadcastData(prev => ({ ...prev, test_email: e.target.value }))}
placeholder={t('enterTestEmail')}
disabled={broadcastLoading}
required={emailBroadcastData.send_as_test}
/>
<small>{t('testEmailDescription')}</small>
</div>
)}

{!emailBroadcastData.send_as_test && (
<div className="manager-alert manager-alert-info">
<FaInfoCircle />
<p>
{emailBroadcastData.recipients === 'all' && t('broadcastAllUsersWarning')}
{emailBroadcastData.recipients === 'employers' && t('broadcastEmployersWarning')}
{emailBroadcastData.recipients === 'admins' && t('broadcastAdminsWarning')}
{emailBroadcastData.recipients === 'managers' && t('broadcastManagersWarning')}
</p>
</div>
)}
</div>

<div className="manager-modal-footer">
<button className="manager-btn manager-btn-outline" onClick={() => setShowEmailBroadcastModal(false)} disabled={broadcastLoading}>
{t('cancel')}
</button>
<button className="manager-btn manager-btn-primary" onClick={sendEmailBroadcast} disabled={broadcastLoading || !emailBroadcastData.subject || !emailBroadcastData.message}>
{broadcastLoading ? (
<>
<FaSpinner className="manager-spinning" /> {t('sending')}
</>
) : (
<>
<FaEnvelope /> {emailBroadcastData.send_as_test ? t('sendTestEmail') : t('sendBroadcast')}
</>
)}
</button>
</div>
</div>
</div>
)}

{/* Custom Email Modal */}
{showCustomEmailModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3><FaEnvelope /> {t('sendCustomEmail') || 'Send Custom Email'}</h3>
<button className="manager-modal-close" onClick={() => setShowCustomEmailModal(false)} disabled={customEmailLoading}>
<FaTimes />
</button>
</div>

<div className="manager-modal-body">
<div className="manager-alert manager-alert-info">
<FaInfoCircle />
<p>
{t('customEmailInfo') || 'Send emails to any email address. You can enter multiple email addresses separated by commas.'}
</p>
</div>

<div className="manager-form-group">
<label>{t('recipients') || 'Recipients'} *</label>
<textarea
value={customEmailData.recipients}
onChange={(e) => setCustomEmailData(prev => ({ ...prev, recipients: e.target.value }))}
placeholder={t('enterRecipients') || 'Enter email addresses separated by commas (e.g., email1@example.com, email2@example.com)'}
rows="3"
disabled={customEmailLoading}
required
/>
<small>
{t('multipleEmailsInfo') || 'Multiple emails: separate with commas. Max 100 recipients per batch.'}
</small>
</div>

<div className="manager-form-group">
<label>{t('subject')} *</label>
<input
type="text"
value={customEmailData.subject}
onChange={(e) => setCustomEmailData(prev => ({ ...prev, subject: e.target.value }))}
placeholder={t('enterEmailSubject')}
disabled={customEmailLoading}
required
/>
</div>

<div className="manager-form-group">
<label>{t('message')} *</label>
<textarea
value={customEmailData.message}
onChange={(e) => setCustomEmailData(prev => ({ ...prev, message: e.target.value }))}
placeholder={t('enterEmailMessage') || 'Enter your email message. You can use basic HTML formatting.'}
rows="10"
disabled={customEmailLoading}
required
/>
<small>
{t('messageFormatInfo') || 'Plain text or basic HTML supported. Line breaks will be preserved.'}
</small>
</div>

<div className="manager-form-group">
<label>{t('attachments') || 'Attachments'}</label>
<input
type="file"
multiple
accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx"
onChange={handleAttachmentChange}
disabled={customEmailLoading}
/>
<small>
{t('attachmentsInfo') || 'Maximum 5 files, 10MB each. Supported: PDF, Word, Excel, Images'}
</small>

{customEmailData.attachments.length > 0 && (
<div className="manager-attachments-list">
<h5>{t('selectedAttachments') || 'Selected attachments'}:</h5>
<ul>
{customEmailData.attachments.map((file, index) => (
<li key={index}>
<FaFileAlt /> {file.name} 
<span className="manager-file-size">
({(file.size / 1024).toFixed(1)} KB)
</span>
<button
type="button"
className="manager-btn-icon manager-btn-icon-delete"
onClick={() => {
  setCustomEmailData(prev => ({
    ...prev,
    attachments: prev.attachments.filter((_, i) => i !== index)
  }));
}}
disabled={customEmailLoading}
>
<FaTimes />
</button>
</li>
))}
</ul>
</div>
)}
</div>

<div className="manager-email-preview">
<h5>{t('emailPreview') || 'Email Preview'}:</h5>
<div className="manager-email-preview-content">
<div className="manager-email-preview-header">
<strong>{t('to') || 'To'}:</strong> {customEmailData.recipients || '[Recipients]'}
</div>
<div className="manager-email-preview-header">
<strong>{t('subject') || 'Subject'}:</strong> {customEmailData.subject || '[Subject]'}
</div>
<div className="manager-email-preview-body">
{customEmailData.message ? (
<div dangerouslySetInnerHTML={{ 
__html: customEmailData.message.replace(/\n/g, '<br>') 
}} />
) : (
<em>{t('noMessagePreview') || 'Message will appear here...'}</em>
)}
</div>
</div>
</div>
</div>

<div className="manager-modal-footer">
<button className="manager-btn manager-btn-outline" onClick={() => setShowCustomEmailModal(false)} disabled={customEmailLoading}>
{t('cancel')}
</button>
<button className="manager-btn manager-btn-info" onClick={sendCustomEmail} disabled={customEmailLoading || !customEmailData.recipients || !customEmailData.subject || !customEmailData.message}>
{customEmailLoading ? (
<>
<FaSpinner className="manager-spinning" /> {t('sending')}
</>
) : (
<>
<FaEnvelope /> {t('sendCustomEmail') || 'Send Custom Email'}
</>
)}
</button>
</div>
</div>
</div>
)}

{/* Gallery Modal */}
{showGalleryModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentGalleryImage ? t('editGalleryImage') : t('addGalleryImage')}</h3>
<button className="manager-modal-close" onClick={() => setShowGalleryModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentGalleryImage ? handleEditGalleryImage : handleAddGalleryImage}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('title')} *</label>
<input
type="text"
value={currentGalleryImage?.title || newGalleryImage.title}
onChange={(e) => {
if (currentGalleryImage) {
setCurrentGalleryImage(prev => ({ ...prev, title: e.target.value }));
} else {
setNewGalleryImage(prev => ({ ...prev, title: e.target.value }));
}
}}
required
/>
</div>
<div className="manager-form-group">
<label>{t('department')}</label>
<select
value={currentGalleryImage?.department_id || newGalleryImage.department_id}
onChange={(e) => {
if (currentGalleryImage) {
setCurrentGalleryImage(prev => ({ ...prev, department_id: e.target.value }));
} else {
setNewGalleryImage(prev => ({ ...prev, department_id: e.target.value }));
}
}}
>
<option value="">{t('general')}</option>
{departments.map(dept => (
<option key={dept.id} value={dept.id}>{dept.name}</option>
))}
</select>
</div>
</div>

<div className="manager-form-group">
<label>{t('description')}</label>
<textarea
value={currentGalleryImage?.description || newGalleryImage.description}
onChange={(e) => {
if (currentGalleryImage) {
setCurrentGalleryImage(prev => ({ ...prev, description: e.target.value }));
} else {
setNewGalleryImage(prev => ({ ...prev, description: e.target.value }));
}
}}
rows="3"
placeholder={t('enterImageDescription')}
/>
</div>

<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentGalleryImage?.is_featured || newGalleryImage.is_featured}
onChange={(e) => {
if (currentGalleryImage) {
setCurrentGalleryImage(prev => ({ ...prev, is_featured: e.target.checked }));
} else {
setNewGalleryImage(prev => ({ ...prev, is_featured: e.target.checked }));
}
}}
/>
<span>{t('featuredImage')}</span>
</label>
</div>

<div className="manager-form-group">
<label>{t('imageFile')} *</label>
<input
type="file"
accept="image/*"
onChange={(e) => {
if (currentGalleryImage) {
setCurrentGalleryImage(prev => ({ ...prev, image: e.target.files[0] }));
} else {
setNewGalleryImage(prev => ({ ...prev, image: e.target.files[0] }));
}
}}
required={!currentGalleryImage}
/>
{currentGalleryImage?.image_url && (
<div className="manager-current-image">
<p>{t('currentImage')}:</p>
<img 
src={`${API_BASE_URL}${currentGalleryImage.image_url}`} 
alt={t('current')}
style={{ maxWidth: '200px', marginTop: '10px' }}
/>
</div>
)}
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowGalleryModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary">
{currentGalleryImage ? t('updateImage') : t('addImage')}
</button>
</div>
</form>
</div>
</div>
)}

{/* About Modal */}
{showAboutModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{t('editAboutPageContent')}</h3>
<button className="manager-modal-close" onClick={() => setShowAboutModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={handleSaveAbout}>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('pageTitle')} *</label>
<input
type="text"
value={aboutData.title || ''}
onChange={(e) => setAboutData(prev => ({ ...prev, title: e.target.value }))}
required
placeholder={t('enterPageTitle')}
/>
</div>

<div className="manager-form-group">
<label>{t('missionStatement')} *</label>
<textarea
value={aboutData.mission || ''}
onChange={(e) => setAboutData(prev => ({ ...prev, mission: e.target.value }))}
rows="4"
required
placeholder={t('enterMissionStatement')}
/>
</div>

<div className="manager-form-group">
<label>{t('visionStatement')} *</label>
<textarea
value={aboutData.vision || ''}
onChange={(e) => setAboutData(prev => ({ ...prev, vision: e.target.value }))}
rows="4"
required
placeholder={t('enterVisionStatement')}
/>
</div>

<div className="manager-form-group">
<label>{t('historyAboutUs')} *</label>
<textarea
value={aboutData.history || ''}
onChange={(e) => setAboutData(prev => ({ ...prev, history: e.target.value }))}
rows="6"
required
placeholder={t('enterHistoryContent')}
/>
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowAboutModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary">
<FaSave /> {t('saveChanges')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Partner Modal */}
{showPartnerModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentPartner ? t('editPartner') || 'Edit Partner' : t('addPartner') || 'Add Partner'}</h3>
<button className="manager-modal-close" onClick={() => setShowPartnerModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentPartner ? handleEditPartner : handleAddPartner}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('partnerName') || 'Partner Name'} *</label>
<input
type="text"
value={currentPartner?.partner_name || newPartner.partner_name}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, partner_name: e.target.value }));
} else {
setNewPartner(prev => ({ ...prev, partner_name: e.target.value }));
}
}}
required
placeholder={t('enterPartnerName') || 'Enter partner/organization name'}
/>
</div>
<div className="manager-form-group">
<label>{t('partnerType') || 'Partner Type'} *</label>
<select
value={currentPartner?.partner_type || newPartner.partner_type}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, partner_type: e.target.value }));
} else {
setNewPartner(prev => ({ ...prev, partner_type: e.target.value }));
}
}}
required
>
<option value="">{t('selectType') || 'Select type'}</option>
<option value="Government">Government</option>
<option value="International NGO">International NGO</option>
<option value="Local NGO">Local NGO</option>
<option value="Corporate">Corporate</option>
<option value="Private">Private</option>
<option value="Educational">Educational</option>
<option value="Other">Other</option>
</select>
</div>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('websiteUrl') || 'Website URL'}</label>
<input
type="url"
value={currentPartner?.website_url || newPartner.website_url || ''}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, website_url: e.target.value }));
} else {
setNewPartner(prev => ({ ...prev, website_url: e.target.value }));
}
}}
placeholder="https://example.com"
/>
</div>
<div className="manager-form-group">
<label>{t('sortOrder') || 'Sort Order'}</label>
<input
type="number"
value={currentPartner?.sort_order || newPartner.sort_order || 0}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewPartner(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
/>
</div>
</div>

<div className="manager-form-group">
<label>{t('description') || 'Description'}</label>
<textarea
value={currentPartner?.description || newPartner.description || ''}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, description: e.target.value }));
} else {
setNewPartner(prev => ({ ...prev, description: e.target.value }));
}
}}
rows="4"
placeholder={t('enterPartnerDescription') || 'Enter partner description'}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('partnerLogo') || 'Partner Logo'}</label>
<input
type="file"
accept="image/*"
onChange={(e) => setPartnerLogo(e.target.files[0])}
/>
{currentPartner?.logo_url && !partnerLogo && (
<div className="manager-current-logo">
<p>{t('currentLogo') || 'Current logo'}:</p>
<img 
src={`${API_BASE_URL}${currentPartner.logo_url}`} 
alt={t('current')}
style={{ maxWidth: '100px', marginTop: '5px' }}
/>
</div>
)}
</div>
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentPartner?.is_active !== undefined ? currentPartner.is_active : newPartner.is_active}
onChange={(e) => {
if (currentPartner) {
setCurrentPartner(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewPartner(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('active')}</span>
</label>
</div>
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowPartnerModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary" disabled={loading}>
{loading ? <FaSpinner className="manager-spinning" /> : null}
{currentPartner ? t('updatePartner') || 'Update Partner' : t('addPartner') || 'Add Partner'}
</button>
</div>
</form>
</div>
</div>
)}

{/* Core Value Modal */}
{showCoreValueModal && (
<div className="manager-modal-overlay">
<div className="manager-modal">
<div className="manager-modal-header">
<h3>{currentCoreValue ? t('editCoreValue') : t('addCoreValue')}</h3>
<button className="manager-modal-close" onClick={() => setShowCoreValueModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentCoreValue ? handleEditCoreValue : handleAddCoreValue}>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>{t('coreValueText')} *</label>
<textarea
value={currentCoreValue?.value_text || newCoreValue.value_text}
onChange={(e) => {
if (currentCoreValue) {
setCurrentCoreValue(prev => ({ ...prev, value_text: e.target.value }));
} else {
setNewCoreValue(prev => ({ ...prev, value_text: e.target.value }));
}
}}
rows="4"
required
placeholder={t('enterCoreValueText')}
/>
</div>

<div className="manager-form-group">
<label>{t('sortOrder')}</label>
<input
type="number"
value={currentCoreValue?.sort_order || newCoreValue.sort_order}
onChange={(e) => {
if (currentCoreValue) {
setCurrentCoreValue(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewCoreValue(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
/>
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowCoreValueModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary">
{currentCoreValue ? t('updateCoreValue') : t('addCoreValue')}
</button>
</div>
</form>
</div>
</div>
)}

{/* Team Member Modal */}
{showTeamMemberModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-lg">
<div className="manager-modal-header">
<h3>{currentTeamMember ? t('editTeamMember') : t('addTeamMember')}</h3>
<button className="manager-modal-close" onClick={() => setShowTeamMemberModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={currentTeamMember ? handleEditTeamMember : handleAddTeamMember}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('fullName')} *</label>
<input
type="text"
value={currentTeamMember?.full_name || newTeamMember.full_name}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, full_name: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, full_name: e.target.value }));
}
}}
required
/>
</div>
<div className="manager-form-group">
<label>{t('position')} *</label>
<input
type="text"
value={currentTeamMember?.position || newTeamMember.position}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, position: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, position: e.target.value }));
}
}}
required
/>
</div>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('department')} *</label>
<input
type="text"
value={currentTeamMember?.department || newTeamMember.department}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, department: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, department: e.target.value }));
}
}}
required
/>
</div>
<div className="manager-form-group">
<label>{t('sortOrder')}</label>
<input
type="number"
value={currentTeamMember?.sort_order || newTeamMember.sort_order}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
} else {
setNewTeamMember(prev => ({ ...prev, sort_order: parseInt(e.target.value) }));
}
}}
min="0"
/>
</div>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('email')}</label>
<input
type="email"
value={currentTeamMember?.email || newTeamMember.email}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, email: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, email: e.target.value }));
}
}}
/>
</div>
<div className="manager-form-group">
<label>{t('phone')}</label>
<input
type="tel"
value={currentTeamMember?.phone || newTeamMember.phone}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, phone: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, phone: e.target.value }));
}
}}
/>
</div>
</div>

<div className="manager-form-group">
<label>{t('bioDescription')}</label>
<textarea
value={currentTeamMember?.bio || newTeamMember.bio}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, bio: e.target.value }));
} else {
setNewTeamMember(prev => ({ ...prev, bio: e.target.value }));
}
}}
rows="4"
placeholder={t('enterTeamMemberBio')}
/>
</div>

<div className="manager-form-row">
<div className="manager-form-group">
<label>
<input
type="checkbox"
checked={currentTeamMember?.is_active || newTeamMember.is_active}
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, is_active: e.target.checked }));
} else {
setNewTeamMember(prev => ({ ...prev, is_active: e.target.checked }));
}
}}
/>
<span>{t('activeTeamMember')}</span>
</label>
</div>
</div>

<div className="manager-form-group">
<label>{t('profilePhoto')}</label>
<input
type="file"
accept="image/*"
onChange={(e) => {
if (currentTeamMember) {
setCurrentTeamMember(prev => ({ ...prev, photo: e.target.files[0] }));
} else {
setNewTeamMember(prev => ({ ...prev, photo: e.target.files[0] }));
}
}}
/>
{currentTeamMember?.photo_url && (
<div className="manager-current-image">
<p>{t('currentPhoto')}:</p>
<img 
src={`${API_BASE_URL}${currentTeamMember.photo_url}`} 
alt={t('current')}
style={{ maxWidth: '150px', marginTop: '10px' }}
/>
</div>
)}
</div>
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowTeamMemberModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary">
{currentTeamMember ? t('updateTeamMember') : t('addTeamMember')}
</button>
</div>
</form>
</div>
</div>
)}


{/* Assign Modal */}
{showAssignModal && (
<AssignmentModal
isOpen={showAssignModal}
onClose={() => {
setShowAssignModal(false);
setSelectedRequest(null);
}}
selectedWomenCount={selectedWomenForAssignment.length}
employerRequests={employerRequests}
onAssign={handleAssignToEmployer}
loading={loading}
/>
)}

{/* Email Modal */}
{showEmailModal && (
<div className="manager-modal-overlay">
<div className="manager-modal">
<div className="manager-modal-header">
<h3>Send Email</h3>
<button className="manager-modal-close" onClick={() => setShowEmailModal(false)}>
<FaTimes />
</button>
</div>
<div className="manager-modal-body">
<div className="manager-form-group">
<label>To:</label>
<input
type="email"
value={emailData.to}
onChange={(e) => setEmailData(prev => ({ ...prev, to: e.target.value }))}
required
disabled
/>
<small>Email is pre-filled from the request</small>
</div>
<div className="manager-form-group">
<label>Subject:</label>
<input
type="text"
value={emailData.subject}
onChange={(e) => setEmailData(prev => ({ ...prev, subject: e.target.value }))}
required
placeholder="Enter email subject"
/>
</div>
<div className="manager-form-group">
<label>Message:</label>
<textarea
value={emailData.html}
onChange={(e) => setEmailData(prev => ({ ...prev, html: e.target.value }))}
rows="6"
required
placeholder="Enter your message..."
/>
</div>
</div>
<div className="manager-modal-footer">
<button className="manager-btn manager-btn-outline" onClick={() => setShowEmailModal(false)}>
Cancel
</button>
<button 
className="manager-btn manager-btn-primary" 
onClick={sendEmail}
disabled={!emailData.to || !emailData.subject || !emailData.html}
>
<FaEnvelope /> Send Email
</button>
</div>
</div>
</div>
)}

{/* Certificate Modal */}
{showCertificateModal && selectedCertificateWoman && (
<div className="manager-modal-overlay">
<div className="manager-modal">
<div className="manager-modal-header">
<h3>{t('uploadCertificate')}: {selectedCertificateWoman.name}</h3>
<button className="manager-modal-close" onClick={() => setShowCertificateModal(false)}>
<FaTimes />
</button>
</div>
<form onSubmit={handleCertificateUpload}>
<div className="manager-modal-body">
<div className="manager-form-row">
<div className="manager-form-group">
<label>{t('certificateNumber')} *</label>
<input
type="text"
value={certificateData.certificate_number}
onChange={(e) => setCertificateData(prev => ({ ...prev, certificate_number: e.target.value }))}
required
/>
</div>
<div className="manager-form-group">
<label>{t('certificateType')} *</label>
<select
value={certificateData.certificate_type}
onChange={(e) => setCertificateData(prev => ({ ...prev, certificate_type: e.target.value }))}
required
>
<option value="">{t('selectCertificateType')}</option>
<option value="vocational">{t('vocationalCertificate')}</option>
<option value="skill">{t('skillCertificate')}</option>
<option value="training">{t('trainingCertificate')}</option>
<option value="professional">{t('professionalCertificate')}</option>
<option value="other">{t('otherCertificate')}</option>
</select>
</div>
</div>

<div className="manager-form-group">
<label>{t('issuingOrganization')} *</label>
<input
type="text"
value={certificateData.issuing_organization}
onChange={(e) => setCertificateData(prev => ({ ...prev, issuing_organization: e.target.value }))}
required
/>
</div>

<div className="manager-form-group">
<label>{t('certificateFile')} * (PDF, PNG, JPG)</label>
<input
type="file"
accept=".pdf,.png,.jpg,.jpeg"
onChange={(e) => setCertificateFile(e.target.files[0])}
required
/>
<small>{t('maxFileSize')}: 10MB</small>
</div>

{selectedCertificateWoman.certificate_url && (
<div className="manager-current-certificate">
<p><strong>{t('currentCertificate')}:</strong></p>
<a 
href={`${API_BASE_URL}${selectedCertificateWoman.certificate_url}`} 
target="_blank" 
rel="noopener noreferrer"
>
{t('viewCurrentCertificate')}
</a>
</div>
)}
</div>
<div className="manager-modal-footer">
<button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowCertificateModal(false)}>
{t('cancel')}
</button>
<button type="submit" className="manager-btn manager-btn-primary">
{selectedCertificateWoman.certificate_url ? t('updateCertificate') : t('uploadCertificate')}
</button>
</div>
</form>
</div>
</div>
)}


{/* Trainee Registration Modal */}
{showTraineeRegistrationModal && (
  <TraineeRegistrationModal
    isOpen={showTraineeRegistrationModal}
    onClose={() => {
      setShowTraineeRegistrationModal(false);
      setEditingTrainee(null);
    }}
    user={user}
    onSuccess={handleTraineeRegistrationSuccess}
    editMode={!!editingTrainee}
    traineeData={editingTrainee}
  />
)}


{/* ==================== ONGOING TRAINEE MODAL ==================== */}
{showOngoingModal && (
  <div className="manager-modal-overlay" onClick={() => setShowOngoingModal(false)}>
    <div className="manager-modal manager-modal-lg" onClick={e => e.stopPropagation()}>
      <div className="manager-modal-header">
        <h3>
          {editingOngoing
            ? (t('editOngoingTrainee') || 'Edit Ongoing Trainee')
            : (t('addOngoingTrainee') || 'Add Trainee to Ongoing Training')}
        </h3>
        <button className="manager-modal-close" onClick={() => setShowOngoingModal(false)}>
          <FaTimes />
        </button>
      </div>

      <form onSubmit={editingOngoing ? handleUpdateOngoingTrainee : handleAddOngoingTrainee}>
        <div className="manager-modal-body">

          {/* ===== NAME with live check ===== */}
          <div className="manager-form-group">
            <label>{t('name') || 'Name'} *</label>
            <input
              type="text"
              value={newOngoingTrainee.name}
              onChange={(e) => {
                const val = e.target.value;
                setNewOngoingTrainee(prev => ({ ...prev, name: val }));
                // Live check only when adding (not editing)
                if (!editingOngoing) checkOngoingName(val);
              }}
              onBlur={(e) => {
                // Also check on blur for immediate feedback
                if (!editingOngoing && e.target.value.trim().length >= 2) {
                  checkOngoingName(e.target.value);
                }
              }}
              required
              placeholder={t('enterName') || 'Enter full name'}
              className={nameCheckState.exists ? 'error' : ''}
            />
            {nameCheckState.checking && (
              <small style={{ color: '#718096' }}>
                <FaSpinner className="manager-spinning" /> Checking...
              </small>
            )}
            {!nameCheckState.checking && nameCheckState.exists && (
              <small style={{ color: '#f44336', fontWeight: 600 }}>
                <FaExclamationCircle /> A trainee named "{nameCheckState.existing?.name}" is already in ongoing training.
              </small>
            )}
            {!nameCheckState.checking && !nameCheckState.exists && newOngoingTrainee.name.trim().length >= 2 && (
              <small style={{ color: '#4CAF50' }}>
                <FaCheckCircle /> Name is available
              </small>
            )}
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('age') || 'Age'}</label>
              <input
                type="number" min="15" max="100"
                value={newOngoingTrainee.age}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, age: e.target.value }))}
                placeholder="25"
              />
            </div>
            <div className="manager-form-group">
              <label>{t('phone') || 'Phone'}</label>
              <input
                type="tel"
                value={newOngoingTrainee.phone}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, phone: e.target.value }))}
                placeholder="+250 78X XXX XXX"
              />
            </div>
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('email') || 'Email'}</label>
              <input
                type="email"
                value={newOngoingTrainee.email}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, email: e.target.value }))}
                placeholder="email@example.com"
              />
            </div>
            <div className="manager-form-group">
              <label>{t('location') || 'Location'}</label>
              <input
                type="text"
                value={newOngoingTrainee.location}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, location: e.target.value }))}
                placeholder="Kigali, Rwanda"
              />
            </div>
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('department') || 'Department'}</label>
              <select
                value={newOngoingTrainee.department_id}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, department_id: e.target.value }))}
              >
                <option value="">{t('selectDepartment') || 'Select Department'}</option>
                {departments.map(d => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </select>
            </div>
            <div className="manager-form-group">
              <label>{t('cohort') || 'Cohort'}</label>
              <input
                type="text"
                value={newOngoingTrainee.cohort}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, cohort: e.target.value }))}
                placeholder="Cohort 5"
              />
            </div>
          </div>

          <div className="manager-form-row">
            <div className="manager-form-group">
              <label>{t('enrollmentDate') || 'Enrollment Date'}</label>
              <input
                type="date"
                value={newOngoingTrainee.enrollment_date}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, enrollment_date: e.target.value }))}
              />
            </div>
            <div className="manager-form-group">
              <label>{t('expectedCompletion') || 'Expected Completion'}</label>
              <input
                type="date"
                value={newOngoingTrainee.expected_completion_date}
                onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, expected_completion_date: e.target.value }))}
              />
            </div>
          </div>

          <div className="manager-form-group">
            <label>{t('notes') || 'Notes'}</label>
            <textarea
              rows="3"
              value={newOngoingTrainee.notes}
              onChange={(e) => setNewOngoingTrainee(prev => ({ ...prev, notes: e.target.value }))}
              placeholder="Any additional notes..."
            />
          </div>
        </div>

        <div className="manager-modal-footer">
          <button type="button" className="manager-btn manager-btn-outline" onClick={() => setShowOngoingModal(false)}>
            {t('cancel') || 'Cancel'}
          </button>
          <button
            type="submit"
            className="manager-btn manager-btn-primary"
            disabled={loading || (!editingOngoing && nameCheckState.exists)}
          >
            {loading ? <FaSpinner className="manager-spinning" /> : <FaSave />}
            {editingOngoing ? (t('update') || 'Update') : (t('add') || 'Add')}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{/* Request Details Modal */}

{showRequestDetailsModal && selectedRequestWithSpecs && (
  <RequestDetailsModal 
    request={selectedRequestWithSpecs}
    onClose={() => {
      setShowRequestDetailsModal(false);
      setSelectedRequestWithSpecs(null);
    }}
    t={t}
    updateRequestWithSpecsStatus={updateRequestWithSpecsStatus}
    updatingRequest={updatingRequest}
    formatCurrency={formatCurrency}
    openApproveRejectModal={openApproveRejectModal}
  />
)}


{/* ==================== EMAIL TOGGLE TOAST ==================== */}
{emailToggleToast && (
  <div 
    className={`manager-email-toast manager-email-toast-${emailToggleToast.type}`}
    role="alert"
  >
    <div className="manager-email-toast-icon">
      {emailToggleToast.type === 'error' ? <FaExclamationTriangle /> : <FaCheckCircle />}
    </div>
    <div className="manager-email-toast-content">
      {emailToggleToast.message}
    </div>
    <button 
      className="manager-email-toast-close"
      onClick={() => setEmailToggleToast(null)}
      aria-label="Close"
    >
      <FaTimes />
    </button>
  </div>
)}

{/* ==================== APPROVE / REJECT MODAL ==================== */}
{showApproveRejectModal && approveRejectAction && (
  <div className="manager-modal-overlay" onClick={() => !approveRejectSubmitting && setShowApproveRejectModal(false)}>
    <div 
      className="manager-modal manager-modal-lg manager-approve-reject-modal" 
      onClick={e => e.stopPropagation()}
    >
      <div className={`manager-modal-header manager-approve-reject-header-${approveRejectAction.action}`}>
        <h3>
          {approveRejectAction.action === 'approved' ? (
            <><FaCheckCircle /> {t('approveRequest') || 'Approve Request'}</>
          ) : (
            <><FaTimesCircle /> {t('rejectRequest') || 'Reject Request'}</>
          )}
        </h3>
        <button 
          className="manager-modal-close" 
          onClick={() => !approveRejectSubmitting && setShowApproveRejectModal(false)}
          disabled={approveRejectSubmitting}
        >
          <FaTimes />
        </button>
      </div>
      
      <div className="manager-modal-body">
        {/* Request summary */}
        <div className="manager-approve-reject-summary">
          <div className="manager-approve-reject-summary-item">
            <label>{t('requestId') || 'Request ID'}:</label>
            <span>REQ-{approveRejectAction.requestId}</span>
          </div>
          {approveRejectAction.requestData?.employer_name && (
            <div className="manager-approve-reject-summary-item">
              <label>{t('employer') || 'Employer'}:</label>
              <span>{approveRejectAction.requestData.employer_name}</span>
            </div>
          )}
          {approveRejectAction.requestData?.employer_email && (
            <div className="manager-approve-reject-summary-item">
              <label>{t('email') || 'Email'}:</label>
              <span>{approveRejectAction.requestData.employer_email}</span>
            </div>
          )}
          {approveRejectAction.requestData?.department_name && (
            <div className="manager-approve-reject-summary-item">
              <label>{t('department') || 'Department'}:</label>
              <span>{approveRejectAction.requestData.department_name}</span>
            </div>
          )}
          {approveRejectAction.requestData?.number_of_employees && (
            <div className="manager-approve-reject-summary-item">
              <label>{t('employeesNeeded') || 'Employees Needed'}:</label>
              <span>{approveRejectAction.requestData.number_of_employees}</span>
            </div>
          )}
        </div>
        
        {/* Status preview */}
        <div className={`manager-approve-reject-status-preview manager-status-preview-${approveRejectAction.action}`}>
          <strong>{t('newStatus') || 'New Status'}:</strong>{' '}
          <span className={`manager-status-badge manager-status-${approveRejectAction.action}`}>
            {approveRejectAction.action.toUpperCase()}
          </span>
        </div>
        
        {/* Email toggle warning */}
        {!emailNotificationsEnabled && approveRejectSendEmail && (
          <div className="manager-alert manager-alert-warning">
            <FaExclamationTriangle />
            <p>
              <strong>{t('emailDisabledWarning') || 'Email notifications are currently DISABLED'}</strong><br />
              {t('emailDisabledWarningDesc') || 'The employer will NOT receive an email notification about this status change.'}
            </p>
          </div>
        )}
        
        {/* Send email toggle */}
        <div className="manager-form-group manager-approve-reject-email-toggle">
          <label className="manager-approve-reject-toggle-label">
            <input
              type="checkbox"
              checked={approveRejectSendEmail}
              onChange={(e) => setApproveRejectSendEmail(e.target.checked)}
              disabled={approveRejectSubmitting}
            />
            <span>
              <FaEnvelope /> {t('sendEmailNotification') || 'Send email notification to employer'}
            </span>
          </label>
          <small>
            {t('emailWillBeSentTo') || 'Email will be sent to'}:{' '}
            <strong>{approveRejectAction.requestData?.employer_email || 'employer'}</strong>
          </small>
        </div>
        
        {/* Message textarea */}
        <div className="manager-form-group">
          <label>
            {t('messageToEmployer') || 'Message to Employer (Optional)'}
          </label>
          <textarea
            value={approveRejectMessage}
            onChange={(e) => setApproveRejectMessage(e.target.value)}
            rows="5"
            placeholder={
              approveRejectAction.action === 'approved'
                ? t('approveMessagePlaceholder') || 'Add a note to include in the approval email (e.g., next steps, contact info)...'
                : t('rejectMessagePlaceholder') || 'Explain why this request is being rejected (this will be sent to the employer)...'
            }
            disabled={approveRejectSubmitting}
          />
          <small>
            {t('messageHelperText') || 'This message will be included in the email notification sent to the employer.'}
          </small>
        </div>
      </div>
      
      <div className="manager-modal-footer">
        <button 
          type="button" 
          className="manager-btn manager-btn-outline"
          onClick={() => setShowApproveRejectModal(false)}
          disabled={approveRejectSubmitting}
        >
          {t('cancel') || 'Cancel'}
        </button>
        <button 
          type="button" 
          className={`manager-btn ${
            approveRejectAction.action === 'approved' 
              ? 'manager-btn-primary' 
              : 'manager-btn-danger'
          }`}
          onClick={submitApproveRejectAction}
          disabled={approveRejectSubmitting}
        >
          {approveRejectSubmitting ? (
            <><FaSpinner className="manager-spinning" /> {t('submitting') || 'Submitting...'}</>
          ) : (
            <>
              {approveRejectAction.action === 'approved' ? <FaCheckCircle /> : <FaTimesCircle />}
              {approveRejectAction.action === 'approved' 
                ? (t('confirmApprove') || 'Confirm Approval') 
                : (t('confirmReject') || 'Confirm Rejection')}
            </>
          )}
        </button>
      </div>
    </div>
  </div>
)}
{/* Import Modal */}
<ImportModal 
t={t}
showImportModal={showImportModal}
setShowImportModal={setShowImportModal}
importFile={importFile}
setImportFile={setImportFile}
importing={importing}
handleImport={handleImport}
/>

{/* Confirmation Modal */}
{showConfirmModal && (
<div className="manager-modal-overlay">
<div className="manager-modal manager-modal-sm">
<div className="manager-modal-header">
<h3>{confirmData.title}</h3>
<button className="manager-modal-close" onClick={() => setShowConfirmModal(false)}>
<FaTimes />
</button>
</div>
<div className="manager-modal-body">
<p>{confirmData.message}</p>
</div>
<div className="manager-modal-footer">
<button 
type="button" 
className={`manager-btn manager-btn-outline ${confirmData.type === 'danger' ? 'manager-btn-danger' : ''}`}
onClick={() => {
if (confirmData.onCancel) confirmData.onCancel();
setShowConfirmModal(false);
}}
>
{confirmData.cancelText}
</button>
<button 
type="button" 
className={`manager-btn ${confirmData.type === 'danger' ? 'manager-btn-danger' : 'manager-btn-primary'}`}
onClick={() => {
if (confirmData.onConfirm) confirmData.onConfirm();
setShowConfirmModal(false);
}}
>
{confirmData.confirmText}
</button>
</div>
</div>
</div>
)}
</div>
);
};

export default ManagerDashboard;
